import gsap, {Linear, Power2, Power4, Expo, Cubic, Back} from 'gsap';
import {CustomEase} from '../libs/gsap/CustomEase.min';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Draggable from 'gsap/Draggable';
import {getjQueryEl, isAccessibleElement, pxToRem} from "../utils/util";
import commonUiList from "../common.ui.list";
import {Popup, PopupAlert} from "../components";
import {getToastTmpl} from "../components/templates/html.template";
import { initPlugins } from 'smooth-scrollbar/plugin';
import PullToRefresh from '../libs/pullToRefresh';

import {
    getSkeletonNoneTmpl, // 없을때
    getSkeletonDefaultTmpl, //기본
    getSkeletonMainTmpl1, // 홈 my
    getSkeletonMainTmpl2, // 홈 상품
    getSkeletonMainTmpl3, // 홈 타임라인
    getSkeletonMainTmpl4, //홈 메뉴
    getSkeletonMainTmpl5, //홈 간편홈모드
    getSkeletonSubTmpl1, //서브 혜택
    getSkeletonSubTmpl2, //서브 계좌목록
    getSkeletonSubTmpl3, //서브 거래내역
    getSkeletonSubTmpl4, //서브 이체
    getSkeletonSubTmpl5, //서브 부동산자산관리 홈
    getSkeletonSubTmpl6, //서브 공모주 청약
    getSkeletonSubTmpl7, //서브 요즘 케뱅
    getSkeletonSubTmpl8, //서브 one 체크카드
    getSkeletonHomeTmpl1, // 홈개편 홈탭
    getSkeletonHomeTmpl2, // 홈개편 혜택탭
    getSkeletonHomeTmpl3, // 홈개편 발견탭 foru
    getSkeletonHomeTmpl4, // 홈개편 발견탭 상품
    getSkeletonHomeTmpl5, // 홈개편 사장님홈
    getSkeletonHomeTmpl6, // 홈개편 간편홈
    getSkeletonHomeTmpl7, // 홈개편 전체탭
    getSkeletonHomeTmpl8, // 홈 - 투자탭 - 투자하기
    getSkeletonHomeTmpl9, // 홈 - 투자탭 - 내종목
    getSkeletonHomeTmpl10, // 홈 - 투자탭 - 인사이트
    getSkeletonHomeTmplSub1, // 홈개편 내 자산(전체계좌조회)
} from "../components/templates/skeleton.template";

import bodymovin from '../libs/lottie.min';
import {
    isA11yCheckVersion,
    isA11yFakeSkeleton,
    isA11yCreatButton,
    isA11yOnceSpinnerDiv,
    isA11ySameTextFilter,
    getElementIdx,
    a11yDebounce,
    FocusTrap,
    isEventBanner,
    isA11ySetAttr,
    //isA11yKeyPad,
} from "../functions/a11y.ui";

const $document = $(document);

export const isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream);
export const isMain = $('.acoma0101_m01, .acoma0101_m10, .ccoma0101_m01, .mcoma0101_m10').length > 0;
export const isGalaxyFold = !!navigator.userAgent.match(/sm-f9/ig);
/**
 * @summary 동적으로 컨텐츠가 들어오고 나서 ui의 추가적인 초기화가 필요할때 사용
 * @param {boolean} force 기본: false, flase: 신규요소 초기화, true: 기존요소까지 초기화
 */
export function refreshUI(force = false) {
    commonUiList.forEach((ui) => {
        $(ui.className).toArray().forEach((el) => {
            if (force || !$(el).data('ui')) {
                if ($(el).hasClass('ui-alert')) {
                    return;
                }
                if (!!$(el).data('ui')) {
                    $(el).data('ui').detachEvents();
                }
                
                const Class = ui.classObject;
                const options = {...$(el).data()};
                const uiInstance = new Class(el, options, ui.className);
                $(el).data('ui', uiInstance);
            }
        });
    });
    frontUI.pageInnerScroll();
    if ($('.ui-widget').length > 0 ) { // ios 상단땡겼을때 bg 들어가는 부분
        $('.ui-widget').data('ui').setBgColor();
    }
}

/**
 * 공통 해당 위치로 스크롤
 * @param {number | HTMLElement | string | jQuery} value scroll할 숫자 또는 htmlElement 또는 셀렉터스트링 또는 jQuery
 * @param {boolean} withAnimation 기본: true, 애니메이션 여부
 * @param {boolean} withSticky 기본: true, 해더등의 스티키 상황인지에 따라 top offset변경 됨
 *
 * @example
 * scrollTo(100);
 * scrollTo(document.getElementById('id');
 * scrollTo('.some-class');
 * scrollTo($('.some-class'));
 */

export function scrollTo(value, withAnimation = true, withSticky = true) {
    let scrollTarget;
    if (typeof value !== 'number') {
        const $el = getjQueryEl(value);
        const getScrollParent = (node) => {
            if (node === null) return null; 
            const overflowY = window.getComputedStyle(node).overflowY;
            if (node.scrollHeight > node.clientHeight && overflowY !== 'visible' && overflowY !== 'hidden') {
                return node;
            } else if (node.tagName.toLowerCase() === 'body' ) {
                return 'html, body';
            } else {
                return getScrollParent(node.parentNode)
            }
        }
        const scrollableEl = getScrollParent($el[0]);
        scrollTarget = $(scrollableEl);
    } else {
        scrollTarget = $('.activeSlide').find('.page-inner-scroll').length > 0 && $('.activeSlide').find('.page-inner-scroll').innerHeight() <  $('.activeSlide').find('.page-inner-scroll')[0].scrollHeight ? $('.activeSlide').find('.page-inner-scroll') : $('html, body');
    }

    scrollToTarget(scrollTarget, value, withAnimation, withSticky);
    // scrollToTarget($('html, body'), value, withAnimation, withSticky);
}

/**
 * @summary scrollTo 함수내에서 실행되는 실질적인 Handler 함수 target 파라미터를 scrollTo 에서 설정하지만 frontUi 에서 개별 호출 가능
 * @param {HTMLElement | string | jQuery} target scroll부모 htmlElement 또는 셀렉터스트링 또는 jQuery
 * @param {HTMLElement | string | jQuery} value scroll좌표 htmlElement 또는 셀렉터스트링 또는 jQuery
 * @param {boolean} withAnimation 기본: true, 애니메이션 여부
 * @param {boolean} withSticky 기본: true, 해더등의 스티키 상황인지에 따라 top offset변경 됨
 * 
 * @example
 * frontUI.scrollToTarget('.parent-class', '.current-class')
 *
 */
export function scrollToTarget(target, value, withAnimation = true, withSticky = true) {
    let moveScroll = value;

    if (typeof value !== 'number') {
        const $el = getjQueryEl(value);
        const header = $('#header');
        const stickyPopupHeader = $el.closest('.popup-content').siblings('.popup-header.sticky');

        moveScroll = $el.offset().top;

        if (withSticky) {
            if (stickyPopupHeader.length) {
                moveScroll -= stickyPopupHeader.outerHeight();
            } else if (header.length) {
                moveScroll -= header.outerHeight();
            }
            moveScroll -= 10;
        }

        console.log('기본', moveScroll)
    }

    if (getjQueryEl(target).hasClass('page-inner-scroll')) {
        const nowScroll = getjQueryEl(target).scrollTop();
        moveScroll += nowScroll;
    } else {
        if ($('.statusExpension').length > 0) {
            const headerH = $('#header_new').length > 0 ? $('#header_new').find('.header_sub').outerHeight() : 50;
            moveScroll -= headerH;
        }
        
        if ($('.mobile.android').length > 0) {
            moveScroll -= 50;
        }
    }

    if(getjQueryEl(target).find('.component-header').length) {
        moveScroll -= getjQueryEl(target).find('.component-header').outerHeight();

        console.log('안에 해더 있을때', moveScroll)
    } 

    setTimeout(() => {
        if (getjQueryEl(target).hasClass('popup-inner')) {
            if (typeof value !== 'number') {
                const nowScrollT = getjQueryEl(target).scrollTop();
                const parentOffset = getjQueryEl(target)[0].getBoundingClientRect().top;
                const targetOffset = getjQueryEl(value)[0].getBoundingClientRect().top;
                getjQueryEl(target).scrollTop(targetOffset - parentOffset + nowScrollT - 5);
            } else {
                getjQueryEl(target).scrollTop(value);
            }
        } else {
            if (typeof withAnimation == 'number') { // CHPFMTASK-1179
                getjQueryEl(target).animate({scrollTop: moveScroll}, withAnimation);
            } else {
                getjQueryEl(target).animate({scrollTop: moveScroll}, withAnimation ? 500 : 0);
            }
            // getjQueryEl(target).animate({scrollTop: moveScroll}, withAnimation ? 500 : 0);
        }
    }, 100);
}

/**
 * @summary 팝업 내 스크롤 타겟 이동
 * @param {string | jQuery} target scroll좌표 셀렉터 : object, string
 * @param {boolean} withAnimation 기본: true, 애니메이션 여부
 */
export function popupScrollTarget(target, withAnimation = true) { //CHPFMTASK-618 : 240412 팝업 내 스크롤 타겟 이동
    let $target = target;
    (typeof target === 'object') ? $target = target : $target = $(`#${target}`).length > 0 ? $(`#${target}`) : $(`.${target}`) ;
    if($target.length < 1) return;
    const $moveEl =  $target.closest('.ui-bottom').length > 0 ?  $target.closest('.popup-content') :  $target.closest('.ui-popup');

    $moveEl.stop().animate({
        scrollTop: $target.closest('.ui-bottom').length > 0 ? $target.position().top : 
        $moveEl.scrollTop() + ($target.offset().top - $target.closest('.ui-popup').find('.popup-header').outerHeight())
    }, withAnimation ? 400 : 0, $.cubicBez( "steady", [0.42, 0, 0.58, 1]));
}

// 사용안함 
export function setScrollbar() {
    // 스크롤바
    $('.scrollbar-outer')[0] && $('.scrollbar-outer').scrollbar();
    $('.scrollbar-inner')[0] && $('.scrollbar-inner').scrollbar();
}

/**
 * @summary 가로 스크롤 타겟 이동
 * @param {jQuery} $scrollEl scroll부모 jQuery셀랙터
 * @param {jQuery} $activeEl scroll좌표 jQuery셀랙터
 * @param {number} margin 최초시작 좌측 마진
 * @param {number} speed scroll되는 속도
 */
export function setActivePosition($scrollEl, $activeEl, margin = 50, speed = 300) { // 2024 홈개편 수정 240424

    if($scrollEl == undefined || $scrollEl.length == 0 || $activeEl == undefined || $activeEl.length == 0 ||  $scrollEl == null || $activeEl == null) {
        console.log('return! subTab None');
        return false;
    }
    const currentScrollLeft = $scrollEl[0].scrollLeft;
    const activeWidth = $activeEl.outerWidth(true);
    const activeLeft = $activeEl.position().left;
    let activeNextWidth;
    let activeNextLeft;

    if ($activeEl.next().length > 0 ) {
        activeNextWidth =  $activeEl.next().outerWidth(true);
        activeNextLeft =  $activeEl.next().position().left;
    } else {
        activeNextWidth = activeWidth
        activeNextLeft = activeLeft
    }
    const scrollElPl = $scrollEl.css('padding-left') != undefined ? Number($scrollEl.css('padding-left').replace('px','')) : 0;
    
   

    if ($scrollEl.attr('type-home') == undefined) { // 기존 이동  240526   closest('.home') 에서 변경 

        if (currentScrollLeft + activeNextLeft + activeNextWidth > $(window).width()){
            gsap.to($scrollEl, {scrollLeft: currentScrollLeft + activeLeft - scrollElPl, duration: speed/1000, ease: Power2.easeOut});
        } else  if (activeLeft < $(window).width()/3) {
            gsap.to($scrollEl, {scrollLeft: 0 - scrollElPl, duration: speed/1000, ease: Power2.easeOut});
        } else {
            gsap.to($scrollEl, {scrollLeft: currentScrollLeft + activeLeft - margin, duration: speed/1000, ease: Power2.easeOut});
        }
    } else { // 홈개편 이동
        gsap.to($scrollEl, {scrollLeft: ((activeLeft + activeWidth/2) - ($(window).width()/2)) + currentScrollLeft, duration: speed/1000, ease: Power2.easeOut});
    }
}

/**
 * @summary navigator.userAgent로 디바이스 체크하여 ios일시 meta[name=viewport]의 속성을 바꿈
 */
export function changeIOSMetaTag() {
    if (isIOS) {
        $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no');
    }
}

/**
 * @summary 3가지 조건 분기 액션실행 함수 \
 * [data-scroll-transform] 속성이 있을시 상단비주얼 스크롤 모션 실행 \
 * [scroll-content-eventwrap] 속성이 있을시 버튼 클릭 순차 스크롤 실행 \
 * [scrollbar-wrap] 속성이 있을시 하단 스크롤 콘텐츠의 scrollTop이 해더높이 만큼 스크롤 되었을때 fixed 시키는 효과 실행
 */
export function scrollTransformView() {
    // console.log('scrollTransformView 실행')
    // 상단 비주얼 스크롤 모션
    const getTsContent =  $('[data-scroll-transform]');
    if(getTsContent.length > 0){
        getTsContent.each(function(){
            const This = $(this), innerScroll = This.closest('.page-inner-scroll'),
            scrollTarget = (innerScroll.length > 0) ? innerScroll : This.closest('.ui-popup'),
            classChingeObj = (innerScroll.length > 0) ? scrollTarget.find('.component-header') : scrollTarget.find('.popup-group, .popup-header'),
            ccPoint = This.innerHeight();
            let motionArr = [];
            let motionOffset;
            if (This.data().scrollTransformOffset != undefined ) {
                motionArr = This.data().scrollTransformMotion?.split(',');
                let $scrollTransform = innerScroll.find(This.data().scrollTransformOffset);
                if ($scrollTransform.attr('offsetTop') == undefined) {
                    $scrollTransform.attr('offsetTop', $scrollTransform.offset().top  + (classChingeObj.length>0 ? Number(classChingeObj.outerHeight()) : 0))
                }
                motionOffset =  Number($scrollTransform.attr('offsetTop'))
            }
            let bannerOffset ;
            if (This.find('[data-opacity-speed="0"]').length > 0) {
                if (This.find('[data-opacity-speed="0"]').attr('offsetTop') == undefined) {
                    This.find('[data-opacity-speed="0"]').attr('offsetTop',This.find('[data-opacity-speed="0"]').offset().top  )
                } else {
                }
                bannerOffset = This.find('[data-opacity-speed="0"]').attr('offsetTop')
            }
            scrollTarget.off('scroll.scrollTFV').on('scroll.scrollTFV','',(e)=>{
                const $this = $(e.target);
                let getTsSpeed = This.data().scrollTransformSpeed, classChingeData = This.data().scrollChingeClass,
                getTs = This.data().scrollTransform, maxTs = -15, setPos = '%', setTs = -$this.scrollTop() / 2, setEq = setTs <= maxTs;
                function setOption(overScroll = false){
                    if(getTs == 'scale'){
                        maxTs = 1.25;
                        setPos = '';
                        setTs = $this.scrollTop() / 1000 + 1;
                        setEq = setTs >= maxTs;
                    }
                    if(overScroll == true){
                        getTs = 'scale'; 
                        getTsSpeed = 0.2;
                        maxTs = 1.07;
                        setPos = '';
                        setTs = -$this.scrollTop() / 1000 + 1;
                        setEq = setTs >= maxTs;
                    }
                }
                ($(window).scrollTop() < 0 || $('html, body').scrollTop() < 0 || $this.scrollTop() < 0) ? setOption(true) : setOption();
                ($this.scrollTop() > ccPoint) ? classChingeObj.addClass(classChingeData) : classChingeObj.removeClass(classChingeData);
                function tsEvent(ts, eq, mts, sts, sp){
                    This.find('.text-area, .img-area')?.css('opacity', (-$this.scrollTop() / ccPoint + 1));
                    if (This.data().scrollTransformOffset != undefined && bannerOffset != undefined) {
                        if ($this.scrollTop() > motionOffset - bannerOffset - 30) {
                            This.find('.kds-banner-card')?.css('opacity', 0);
                        } else {
                            //This.find('.kds-banner-card')?.css('opacity', (-$this.scrollTop() / ccPoint +1));
                            This.find('.kds-banner-card')?.css('opacity', 1);
                        }
                        
                    }
                    
                    if (motionArr.length > 0) {
                        for (var i = 0; i < motionArr.length; i++) {
                            This.find(motionArr[i])?.css({
                                'transform': `translate(${This.find(motionArr[i]).attr('data-transform-x') == 'true' ? -50 : 0}%, ${-(Math.min($this.scrollTop() / motionOffset) * This.find(motionArr[i]).attr('data-scroll-num'))}px)`,
                            })
                        }
                    } else {
                        This.css({'transition':`all ${(getTsSpeed==0 || getTsSpeed) ? getTsSpeed : 0.3}s`,'transform':`${ts}(${(eq) ? mts : sts}${sp})`});
                    }
                }
                
                
                if ($this.scrollTop() < ccPoint + 100 ) {
                    tsEvent(getTs, setEq, maxTs, setTs, setPos);
                }
                
            });
        });
    }

    // 버튼 클릭 순차 스크롤
    const getScrollContent = $('[scroll-content-eventwrap]');
    if(getScrollContent.length > 0){
        console.log('data-scroll-contnet-event init');
        getScrollContent.each(function(){
            const This = $(this), innerScroll = This.closest('.page-inner-scroll'),
            scrollTarget = (innerScroll.length > 0) ? innerScroll : This.closest('.ui-popup'),
            scrollGab = scrollTarget.hasClass('ui-full') ? 154 : 0,
            scrollItems =  scrollTarget.find('[scroll-content]'),
            contentBox = (innerScroll.length > 0) ? scrollTarget.find('.container-component') : scrollTarget.find('.popup-content'),
            header = (innerScroll.length > 0) ? scrollTarget.find('.component-header') : scrollTarget.find('.popup-header'),
            headerHeight = (header.length > 0) ? header.outerHeight() : 0, 
            maxScroll = scrollTarget[0].scrollHeight;
            let scrollSpeed = 500, setPosition=[], scNum = 0, rescNum = scNum, scMax = scrollItems.length, 
            scBtn = scrollTarget.find('[scroll-content-btn]'), scCheck = scrollTarget.find('[scroll-content-check]');
            scrollItems.each(function(i){setPosition.push($(this).offset().top - (headerHeight + scrollGab));});
            shScrollbtn();
            scBtn.off('click').on('click',(e)=>{
                (scNum == scMax) ? (
                    scrollMove(maxScroll),
                    setTimeout(()=>{
                        shScrollbtn('check');
                    },scrollSpeed / 2)  
                ) : scrollMove(setPosition[scNum]);
                if(scNum < scMax) scNum ++;
            });
            function scrollMove(value){
                scrollTarget.stop().animate({scrollTop:value},scrollSpeed);
            }
            function shScrollbtn(value){
                if(scCheck.length > 0) {
                    (value == 'check') ? (scBtn.hide(), scCheck.show()) : (scBtn.show(), scCheck.hide());
                } 
            }
            function checkScrollPoint(){
                const $innerHeight = contentBox.innerHeight();
                scrollItems.each(function(i){
                    if(scrollTarget.scrollTop() >= setPosition[i] && scrollTarget.scrollTop() < setPosition[i] + $(this).innerHeight()){
                        rescNum = scNum;
                        if(rescNum < i+1) scNum = i+1;
                    }
                });
                if($innerHeight && Math.floor($innerHeight - scrollTarget.scrollTop()) <= scrollTarget.innerHeight()){
                    // console.log(`페이지의 하단 입니다.`);
                    shScrollbtn('check');
                }
            }
            scrollTarget.off('scroll').on('scroll','',(e)=>{checkScrollPoint();});
        });
    }

    // 하단 스크롤 컨텐츠  CHPFMTASK-870
    const getScrollBarContent = $('[scrollbar-wrap]');
    if (getScrollBarContent.length > 0 ) {
        getScrollBarContent.each(function(){
            const This = $(this), innerScroll = This.closest('.page-inner-scroll'),
            scrollTarget = (innerScroll.length > 0) ? innerScroll : This.closest('.ui-popup'),
            innerScrollTarget = This.find('[scrollbar-content]'),
            ThisOffsetTop = This.offset().top,
            headerH = This.closest('.page-inner-scroll').find('.component-header').length > 0 ? This.closest('.page-inner-scroll').find('.component-header').height() : 0;
            scrollTarget.off('scroll.scrollBC').on('scroll.scrollBC','',(e)=>{
                const $this = $(e.target);
                if ($this.scrollTop() + headerH> ThisOffsetTop) {
                    This.addClass('fixed-scroll')
                    $this.css('overflow','hidden')
                    for (var i = 0; i < innerScrollTarget.length; i++) {
                        console.log($(innerScrollTarget[i]))
                        $(innerScrollTarget[i]).css({
                            'overflowY': 'scroll',
                            'height':  `calc(100vh - ${headerH}px)`,
                            'padding-bottom': $(innerScrollTarget[i]).closest('.ui-tab-content').find('.component-btn.fixed-bottom').length > 0 ? ($(innerScrollTarget[i]).closest('.ui-tab-content').find('.component-btn.fixed-bottom').outerHeight(true)+headerH)+'px' : 130 + 'px'
                        })
                    }
                   
                } 
            });

            let startY;
            This.on('touchstart', (e) =>{
                startY = e.touches[0].clientY;
            })
            This.on('touchmove', (e) =>{
                if (typeof startY == 'number' && startY < e.touches[0].clientY  && This.hasClass('fixed-scroll')) {
                    if (innerScrollTarget.scrollTop() == 0 ) {
                        This.removeClass('fixed-scroll');
                        scrollTarget.removeAttr('style');
                        innerScrollTarget.removeAttr('style');
                        scrollTarget.scrollTop(ThisOffsetTop-headerH-1);

                    }
                }
            })
        });
    }
}

/**
 * @summary 퍼블확인용 함수 개발소스에서 제외됨
 */
export function listViewer(type) {
    let $list, $popList;
    

    function init() {
        $list = $('.ui-kbank-page-control');
        $popList = $('.ui-popup') //230720 dateSpinner value 값이 있는경우 listViewer 에 들어가져서 not('[data-type="dateSpinner"]') 추가  240312 : :not() 제외
        render();

        // 불필요시 삭제 : 퍼블 페이지 작업용
        // location.href.indexOf(':8888') > -1 && getLastPage();
    }

    // 불필요시 삭제 : 퍼블 페이지 작업용
    function getLastPage() {
        // if (localStorage.getItem("list") != null) {
        //     $('.ui-widget').data('ui').goToSlide($list.eq(localStorage.getItem("list"))[0].classList[0]);
        // }
        // if (localStorage.getItem("popList") != null) {
        //     getjQueryEl($('.ui-popup').eq(localStorage.getItem("popList")).data('ui').open());
        // }
    }

    function render() {

        $('.ui-widget').append(`
            <div class="listViewer">
<!--                <div class="list-box">-->
<!--                    <label for="ui-list" title="123">List</label>-->
<!--                    -->
<!--                </div>-->
<!--                <div class="popup-box">-->
<!--                    <label for="ui-pop">PopUp</label>-->
<!--                    -->
<!--                </div>-->
                <select class="ui-list" id="ui-list"><option value="">List</option></select>
                <select class="ui-pop" id="ui-pop"><option value="">Popup</option></select>
            </div>
        `);

        $('.listViewer').css({
            'position': 'fixed',
            'display':'flex',
            'left': 0,
            'right': 0,
            'bottom': 0,
            // 'width': '150px',
            // 'height': '30px',
            'z-index': '500',
            'opacity':'.75'
        });

        $('.listViewer select').css({
           'alignItems': 'center',
            'color':'#c8f03e',
            'background': '#0f0060',
            'border':'none',
            // 'border-top': '2px solid #c8f03e',
            'flex':2
        });



        for (let i=0; i<$list.length; i++) {
            $('.ui-list').append(`<option value=${i}>Page ${i + 1}</option>`);
        }
        for (let j=0; j<$popList.length; j ++){
            if ($popList[j].className.indexOf('kbank-popup-') == 0 ) { //240312 : 하드코딩으로 들어간 팝업들만  'kbank-popup-' 들어간 
                $('.ui-pop').append(`<option value=${j}>PopUp ${j + 1}</option>`);
            }
            
        }

        //list
        $('.ui-list').on('change', (e) => {
            const $this = e.currentTarget;

            if($this.value == '') return;

            $('.ui-popup').each((index, item) => {
                if ($(item).data('ui') !== undefined) {
                    $(item).data('ui').close();
                }
            });

            $('.ui-widget').data('ui') && $('.ui-widget').data('ui').goToSlide($list.eq($this.value)[0].classList[0]);

            // 불필요시 삭제 : 퍼블 페이지 작업용
            // localStorage.setItem("list", $this.value);
        });

        //popup
        $('.ui-pop').on('change', (e) => {
            const $this = e.currentTarget;
            let $currentId = getjQueryEl($('.ui-popup').eq($this.value));
            if($this.value == '') return;

            if($currentId.data('ui').$popup.find('.ui-swipeAction').length){
                $currentId.data('ui').open().callback(function(){
                    $('.ui-swipeAction').data('ui').update();
                });
            }else{
                $currentId.data('ui').open();
            }

            // 불필요시 삭제 : 퍼블 페이지 작업용
            // localStorage.setItem("popList", $this.value);
        });
    }
    // s: 페이지 좌우 이동  20230118
    // if (window.frameElement?.nodeName != "IFRAME") {

    //     let gap = 0;
    //     let cv;
    //     $("body").on('touchstart', function(e){
    //         if ($(e.target).closest('.swiper-container').length == 1) return;
    //         const sX = e.touches[0].clientX;
    //         const sY = e.touches[0].clientY;

    //         // cv = document.createElement('canvas');
    //         // cv.style.pointerEvents = 'none';
    //         // cv.width = window.outerWidth;
    //         // cv.height = window.outerHeight;
    //         // cv.style.top = 0;
    //         // cv.style.left = 0;
    //         // cv.style.position = 'fixed';
    //         // cv.style.zIndex = 9999;

    //         // $(this).append(cv);

    //         // const ctx = cv.getContext('2d');

    //         // ctx.lineWidth = 10;
    //         // ctx.lineCap = 'round';
    //         // ctx.strokeStyle = '#007aff50';

    //         $(this).on('touchmove', function(ev){
    //             const mX = ev.touches[0].clientX;
    //             const mY = ev.touches[0].clientY;
    //             gap = sX - mX;
                

    //             // const lg = ctx.createLinearGradient(sX, sY, mX, mY);
    //             // lg.addColorStop(0, '#007aff00');
    //             // lg.addColorStop(1, '#007aff80');
    //             // ctx.strokeStyle = lg;
    //             // ctx.clearRect(0, 0, cv.width, cv.height);
    //             // ctx.beginPath();
    //             // ctx.moveTo(sX, sY);
    //             // ctx.lineTo(mX, mY);
    //             // ctx.stroke()
    //         })
    //     }).on('touchend', function(e){
    //         $(this).off('touchmove');
    //         const activeElem = $(".ui-kbank-page-control.activeSlide");
    //         if (gap > 80) {
    //             // next
    //             const nextElem = activeElem.next();
    //             if(nextElem.length == 1) {
    //                 const idx = nextElem.data('slide-index');
    //                 $(".ui-list").val(idx).trigger('change');
    //             }
    //         } else if (gap < -80) {
    //             // prev
    //             const prevElem = activeElem.prev();
    //             if(prevElem.length == 1) {
    //                 const idx = prevElem.data('slide-index');
    //                 $(".ui-list").val(idx).trigger('change');
    //             }
    //         }
    //         gap = 0;
            
    //         // const ctx = cv.getContext('2d');
    //         // ctx.clearRect(0, 0, cv.width, cv.height);
    //         // cv.remove();
    //         // cv = null;
    //     })
    // }
    // e: 페이지 좌우 이동 20230118


    // s: FETASK-575 URL으로 초기 화면 셋팅
    if (location.search) {
        const params = location.search.slice(1).split('&').reduce((p, c) => {
            const [k, v] = c.split('=');
            return {
                ...p,
                [k]: v
            }
        }, {});


        if (params.page) {
            setTimeout(function(){
                $("#ui-list").val((params.page * 1) - 1).trigger('change');
            }, 500);
        }
        if (params.popup) {
            setTimeout(function(){
                $("#ui-pop").val((params.popup * 1) - 1).trigger('change');
            }, 500);
        }
    }
    // e: FETASK-575 URL으로 초기 화면 셋팅

    return {
        init: init()
    }
}

let bgClass;
let bgClassChk = false;
/**
 * @summary .page-inner-scroll 요소가 스크롤중일때 \
 * (속성과 클래스 5개의 조건 분기로 각기 다른 ui액션을 실행함) 
 */
export function pageInnerScroll() {
    const $stickyOffsetTop = $('.ui-kbank-page-control [data-sticky-item]').length > 0 ? $('.ui-kbank-page-control [data-sticky-item]').offset().top : ''; //FETASK-1868
    // console.log('$stickyOffsetTop',$stickyOffsetTop)
    $('.page-inner-scroll').off('scroll.pageInnerScr').on('scroll.pageInnerScr', '', (e) => {
        const $this = $(e.target);
        const $title = $this.find('.header-group .tit-header');
        if($this.find('.component-header').length && bgClassChk == false) {
            bgClassChk = true;
            $this.find('.component-header')[0].classList.value.split(' ').filter((val) => {
                if (val.includes('bg-')) {
                    bgClass = val;
                }
            });
        }

        if ($this.find('.card-layout-group')[0]) {
            const $cardBefore = $this.find('.card-layout-group').first();
            const $cardAfter = $this.find('.card-layout-group').last();
            const cardState = $cardAfter.data('visible') || false; // fixed 영역 노출(false) 숨김(true) 지정
            if ($cardBefore[0] !== $cardAfter[0] && !$cardAfter.closest('[data-sticky-item]').length > 0) {
                if ($this.scrollTop() >=  $cardBefore.outerHeight() - $cardAfter.outerHeight()) {
    
                    $cardAfter.css({
                        'position': 'fixed',
                        'top': $this.find('.component-header').innerHeight(),
                        'left': 0,
                        'right': 0,
                        'z-index': 1
                    });
    
                    setTimeout(() => {
                        if (cardState === false) $cardAfter.show();
                    }, 0);
    
    
                } else {
                    if (cardState === false) $cardAfter.hide();
                    else $cardAfter.removeAttr('style');
                }
            }
        }
        if ($this.find('[data-sticky-item]')[0]) { //FETASK-1868
            if ($this.scrollTop() >= $stickyOffsetTop - $title.outerHeight(true) && $this.find('[data-sticky-item] .card-layout-group').length > 0 && !$this.find('[data-sticky-item]').hasClass('stickyOn')) {
                if (!$this.find('[data-sticky-item] .card-layout-group').is(':visible')){
                    $this.find('[data-sticky-item] .card-layout-group').css({
                        'display':'block'
                    })
                }
            } else {
                if ($this.find('[data-sticky-item] .card-layout-group').is(':visible')){
                    $this.find('[data-sticky-item] .card-layout-group').css({
                        'display':'none'
                    })
                }
                // if ($this.find('[data-sticky-item]').closest('.inandout-list-wrap').length > 0 ) { // CHPFMTASK-890  // 240920  CHPFMTASK-1403 이슈 제거  CHPFMTASK-890에서도 사용안함
                //     if ($this.scrollTop() + $('[data-id="fixedCont"]').outerHeight() >= $stickyOffsetTop) {
                //         if (!$this.find('[data-sticky-item]').hasClass('fixed')) {
                //             $this.find('[data-sticky-item]').addClass('fixed')
                //         } 
                //     } else {
                //         if ($this.find('[data-sticky-item]').hasClass('fixed')) {
                //             $this.find('[data-sticky-item]').removeClass('fixed')
                //         } 
                //     }
                // }
                if ($this.find('[data-sticky-item]').attr('data-sticky-item') == 'tab') {  // tab fixed
                    var $header = $this.find('.component-header');
                    var headerH = 0;
                    var $stickItem = $this.find('[data-sticky-item]');
                    var _class = $stickItem.attr('sticky-item-class') == undefined ? 'fixed' : $stickItem.attr('sticky-item-class');
                    if ($stickItem.attr('sticky-item-header') == 'true') {
                        headerH = $header.outerHeight(true)
                    }
                    if ($stickItem.attr('sticky-item-wrap') != undefined) {
                        if ($this.find(`.${$stickItem.attr('sticky-item-wrap')}`).length == 0) {
                            $stickItem.wrap(`<div class="${$stickItem.attr('sticky-item-wrap')}" style="width:100%;height:${$stickItem.height()}px"></div>`)
                        }
                        
                    }
                    let plusScroll = $stickItem.attr('data-scroll-plus') == undefined ? 0 : Number($stickItem.attr('data-scroll-plus'));
                    if ($this.scrollTop() + headerH + plusScroll>= $stickyOffsetTop) {
                        if (!$stickItem.hasClass(_class)) {
                            $stickItem.addClass(_class);
                            $stickItem.css('background-color', $stickItem.attr('sticky-item-bg'));
                            // $stickItem.css('background-color', 'red');
                            //$header.attr('style',`background-color: ${$stickItem.attr('sticky-item-bg')} !important; z-index:100;transition:none;`); // CHPFMTASK-1582
                        }
                    } else {
                        if ($stickItem.hasClass(_class)) {
                            $stickItem.removeClass(_class);
                            $stickItem.removeAttr('style');
                            //$header.removeAttr('style'); // CHPFMTASK-1582
                        }
                    }
                } 
            }
        }
        // 헤더 애니메이션
        if ( $this.find('.ui-animate')[0] ) {
            if($this.scrollTop() >= $this.find('.header-group').outerHeight()) {
                if($title.hasClass('show')) return false;
                $title.addClass('show');
            } else if ($this.scrollTop() < $this.find('.header-group').outerHeight()) {
                if(!$title.hasClass('show')) return false;
                $title.removeClass('show');
            }
        }
        // scroll시 bg 제거
        if ( $this.find('.ui-background')[0] ) {
            var scroll = $this.scrollTop();
            var targetInner1 = $this.find('.ui-background').parent().next('.component-benefit-carousel').outerHeight() || 0;
            var targetInnerData = $this.find('[data-background-inner]').outerHeight() || 0;
            var targetInner2 = $this.find('.component-header').outerHeight();
            var target;

            $this.find('[data-background-inner]').length > 0 ? target = targetInnerData : target = targetInner1 - targetInner2;

            if($this.scrollTop() >= target) {
                $this.find('.ui-background').parent('.component-header').attr('class', 'component-header');
            } else {
                $this.find('.ui-background').parent('.component-header').attr('class', `component-header ${bgClass}`);
            }
        }
    });    
}

/**
 * @summary .page-inner-scroll 요소가 스크롤중일때 \
 * .component-header 요소를 [data-bottom-fixed] 요소의 스크롤 높이에 맞춰 fixed시킴
 */
export function fixedBottom() { // CHPFMTASK-890   | 인앤아웃용으로  처음 만들어졌지만  운영배포전에 기능 수정을 하면서 의도와 다르게 사용중 
    if (!$('[data-bottom-fixed]').length > 0) {
        return false;
    }
    const $wrap = $('[data-bottom-fixed]');
    const $header = $('.ui-kbank-page-control.activeSlide .component-header')
    const fixedPos =  $wrap.offset().top + $(window).scrollTop();
    const $target = $wrap.attr('data-bottom-fixed') == '' ? $wrap : $(`[data-id="${$wrap.attr('data-bottom-fixed')}"]`)
    let headerH = $header.outerHeight();
    let headerCheck = true;
    if (!$wrap.attr('bottom-fixed-header')) {
        headerH = 0
        headerCheck = false;
    }
    let iosH= 0;
    if ($wrap.closest('html').hasClass('ios statusExpension')) {
        iosH = 50
    }
    console.log(headerH, fixedPos)
    $('.ui-kbank-page-control.activeSlide .page-inner-scroll').on('scroll',  function(){
        // if ($(this).scrollTop() + headerH >= fixedPos) {
        //     if (!$target.hasClass($wrap.attr('bottom-fixed-class'))) {
        //         $target.addClass($wrap.attr('bottom-fixed-class'));
        //         // if (!headerCheck) {
        //         //     $header.css('display','none')
        //         // }
        //     }
            
        // } else {
        //     if ($target.hasClass($wrap.attr('bottom-fixed-class'))) {
        //         $target.removeClass($wrap.attr('bottom-fixed-class'))
        //         // if (!headerCheck) {
        //         //     $header.css('display','block')
        //         // }
        //     }
        // }

        if (!headerCheck) {
            if ($(this).scrollTop() + $header.outerHeight() + iosH >= fixedPos) {
                console.log(111)
                $header.removeClass('blur')
                $header.addClass($wrap.attr('bottom-fixed-class'));
            } else {
                $header.addClass('blur')
                $header.removeClass($wrap.attr('bottom-fixed-class'));
            }
        }
    })
}

// 인앤아웃용 테스트함수 (사용안함)
export function textTest() {
    $('.inandout-calendar-inner').attr('data-bottom-fixed', 'fixedCont')
    $('.inandout-calendar-inner').attr('bottom-fixed-class', 'fixed')
    $('.inandout-calendar-fixed-area').attr('data-spinner-group')
    $('.inandout-calendar-fixed-area').attr('data-id', 'fixedCont')
    $('.inandout-calendar-fixed-area').find('.inandout-calendar-group').removeAttr('data-spinner-group')
    $('.inandout-tab-wrap').find('.ui-tab-nav').attr('data-sticky-item')
}

// toast
/**
 * @summary 토스트 팝업 options = {...} \
 * callback = 콜백함수 설정 \
 * target = jquery 셀렉터 $('#content-mmk > div')\
 * delay = 생성 딜레이 number \
 * duration = 애니메이션 속도 number \
 * icon = 아이콘 사용 여부 string (positive, negative)\
 * buttonText = .toast-btn 요소 안에 택스트 string \
 * focusBackSelector = 닫을때 포커스 할 요소 string css '.target'\
 * buttonCallback = .toast-btn 요소 클릭시 콜백함수 설정 \
 * @param {string} msg  토스트 메세지 
 * @param {object} options
 * @param {Number} idx 각 토스트팝업 인덱스 판별 
 *
 */
export function toast(msg, options = {}, idx = 1){
    const {callback, delay, target, duration, icon, buttonText, focusBackSelector, buttonCallback} = {
        callback: () => {},
        delay: 0,
        target: $('#content-mmk > div'),
        duration:2000,
        icon:'positive',
        buttonText : '확인',
        focusBackSelector: '',   // ** buttonText, addClassName == 'withdraw-type' 일때  필수 
        buttonCallback: ()=>{},
        ...options
    };
    const toastTmpl = getToastTmpl({
        msg:msg,
        idx:idx,
        icon: options.icon,
        buttonText:options.buttonText,
        addClassName:options.addClassName,
        wdIcon:options.wdIcon,  // 이체하기 아이콘  ex) logo-bank090
        wdAcName:options.wdAcName, // 이체하기 계좌명  ex) 카카오뱅크
        wdAcNum:options.wdAcNum, // 이체하기 계좌번호   addClassName == 'withdraw-type' 일때  필수 
        wdAcMoney: options.wdAcMoney, // 이체하기 금액   addClassName == 'withdraw-type' 일때  필수 
    }); //231229  옵션 파라미터 변경  //240412 이체하기 토스트팝업 추가 


    
    setTimeout(() => {
        if($(`.toast-wrap[toast-idx="${idx}"]`).length > 0) {
            console.log('error : toast duplicate')
            return;
        }
        
        target.append(toastTmpl);
        /*! s: FETASK-a11y toast 접근성 추가 v.1.0.0 */
        let isA11yCheck;
        $(document).ready(() => {
            isA11yCheck = isA11yCheckVersion(); //파라미터값을 기준으로 분기처리, html hasClass로 돔 로드후 toast체크스 스크린리더 동작 문제 발생
            
            if(isA11yCheck){
                Popup.a11yDetctClosePopup();
            }
        })
        /*! e: FETASK-a11y toast 접근성 추가 v.1.0.0 */

        /*
        let focusEle = null;
        */

        /*! s: FETASK-a11y toast 접근성 추가 v.1.0.0 */
        $(document).ready(() => {
            isA11yCheck = isA11yCheckVersion(); //파라미터값을 기준으로 분기처리, html hasClass로 돔 로드후 toast체크스 스크린리더 동작 문제 발생
            if(isA11yCheck){
                /*
                focusEle = new FocusTrap({
                    containerDomNode: `[toast-idx="${idx}"]`, //해당 기준 빼고 포커스 다 막는로직 실행
                    initialFocusDomNode: '.toast-txt', //팝업 열렸을때 보낼곳
                    sourceDomNode: 'body',
                    useFocus:false //키보드 이벤트 적용여부
                });
        
                focusEle.activate();
                */
                
                //토스트 팝업 동작시 텍스 읽게하기
                const isCreateLiveText = document.createElement('div');
                isCreateLiveText.setAttribute('role', 'alert');
                isCreateLiveText.setAttribute('aria-live','polite');
                isCreateLiveText.setAttribute('style', `position:fixed;top:-9999px;left:-9999px;font-size:1px;`);

                target.append(isCreateLiveText);
                isCreateLiveText.innerHTML = msg;

                setTimeout(() => {
                    isCreateLiveText.remove();
                },msg?.length * 150);
            }
        });

        /*! e: FETASK-a11y toast 접근성 추가 v.1.0.0 */
        // if (options.buttonText != undefined || options.addClassName == 'withdraw-type') { // FETASK-1865 : 버튼케이스 
        if (options.buttonText != undefined || options.addClassName != undefined) { // FETASK-1865 : 버튼케이스  // 240717 수정
            
            $(`.toast-wrap[toast-idx="${idx}"]`).stop().fadeIn();
            // if (options.addClassName == 'withdraw-type') {
            if (options.addClassName != undefined && options.addClassName.includes('withdraw-type')) {
                if ($('.chatbot-wrap').length> 0) {  //CHPFMTASK-1011
                    $('.chatbot-wrap').addClass('chatbot-toast')
                }
                $('.toast-wrap').find('.toast-group').attr('data-focus-s','')
                $('.toast-wrap').find('.toast-group').attr('tabindex', 0).focus()
            } else if (options.buttonText != undefined) { // 241008 : 안닫히는 이슈 추가
                $('.toast-wrap').find('.toast-txt').attr('data-focus-s','')
                $('.toast-wrap').find('.toast-txt').attr('tabindex', 0).focus()
                $(`.toast-wrap[toast-idx="${idx}"] .toast-group`).append('<button type="button" class="toast-close-btn" data-focus-e  title="팝업 닫기"></button>');
                $('.toast-close-btn').css({
                    position:'absolute',
                    top:0,
                    left: $(`.toast-wrap`).css('padding-left'),
                    height: '100%',
                    width: `${$(`.toast-wrap[toast-idx="${idx}"] .toast-group .toast-txt`).outerWidth() + Number($(`.toast-wrap[toast-idx="${idx}"] .toast-group`).css('padding-left').replace('px',''))}px`,
                })
            } else {  // 241008 : 안닫히는 이슈 추가
                setTimeout(() => {
                    $(`.toast-wrap[toast-idx="${idx}"]`).stop().fadeOut(() => {
                        $(`.toast-wrap[toast-idx="${idx}"]`).remove();
                        callback.call(null);
                    });
                },duration);
            }
            $('.ui-widget').length>0 ? $('.ui-widget').attr('aria-hidden', true) : '';
            $('.popup-wrap').length>0 ? $('.popup-wrap').attr('aria-hidden', true) : '';

            $(document).off('click').on('click','.toast-close-btn', ()=>{
                frontUI.toastClose(options.focusBackSelector)

                /*
                if(isA11yCheckVersion()){
                    focusEle.deactive();
                }
                */
            })
            $('html').on('click.etcAtionClick touchstart.etcAtionTouch', function(e){
                if ($(e.target).closest('.toast-btn').length > 0) {
                    $(document).off('click.toastBtn').on('click.toastBtn','.toast-btn', ()=>{
                        //frontUI.toastClose(options.focusBackSelector)
                        buttonCallback.call(null);

                        /*
                        if(isA11yCheckVersion()){
                            focusEle.deactive();
                        }
                        */
                    })
                } else if ($(e.target).closest('.withdraw-type').length > 0){
                    //frontUI.toastClose()
                } else {
                    frontUI.toastClose();

                    /*
                    if(isA11yCheckVersion()){
                        focusEle.deactive();
                    }
                    */
                }
                
            })
            $('.ui-widget .activeSlide .page-inner-scroll').on('scroll.etcAtionScroll', function(e){
                frontUI.toastClose();

                /*
                if(isA11yCheckVersion()){
                    focusEle.deactive();
                }
                */
            })
            
            return false;
        }

        $(`.toast-wrap[toast-idx="${idx}"]`).stop().fadeIn();
        if ($(`.toast-wrap[toast-idx="${idx}"]`).siblings('.toast-wrap').length>0) {
            $(`.toast-wrap[toast-idx="${idx}"]`).siblings('.toast-wrap').stop().fadeOut();
        }

        setTimeout(() => {
            $(`.toast-wrap[toast-idx="${idx}"]`).stop().fadeOut(() => {
                $(`.toast-wrap[toast-idx="${idx}"]`).remove();
                callback.call(null);
            });
        },duration);

    }, delay);
}

/**
 * @summary 토스트 팝업 닫기
 * @param {string} focusBackSelector  닫기 후 포커스될 요소 
 *
 */
export function toastClose(focusBackSelector){
    $('.toast-wrap').each((idx,el)=>{
        $(el).stop().fadeOut(() => { // 240213 : 일반 토스트와 같은 속도로 삭제 수정
            $(el).remove();
        });
    });
    $('.toast-dimm').remove();
    if ($(focusBackSelector).length > 0) {
        $(focusBackSelector).focus();
    }

    if(isA11yCheckVersion() && !$(focusBackSelector).length){
        //셀렉터 입력 안됬을시 임의 헤더 타이틀로 focus이동
        $('.activeSlide .tit-header > span').attr({'aria-hidden':'false', 'tabindex':'0'});
        
        setTimeout(() => {
            $('.activeSlide .tit-header > span').focus();
        },500);
    }
    
    $('.ui-widget').length>0 ? $('.ui-widget').removeAttr('aria-hidden') : '';

    $('html').off('click.etcAtionClick touchstart.etcAtionTouch')
    $('.ui-kbank-page-control.activeSlide .page-inner-scroll').off('scroll.etcAtionScroll')

    if ($('.chatbot-wrap').length> 0) {  // CHPFMTASK-1011
        $('.chatbot-wrap').removeClass('chatbot-toast')
    }
}

//drag (홈편집)
/**
 * @summary 메인 계좌 노출 순서변경 (홈편집) \
 * 각각의 그룹은 유니크한 id를 갖습니다. \
 * 각 그룹의 아이템들은 유니크한 data-id를 갖습니다. \
 * 순서를 바꾸거나 노출/미노출을 변경할시 해당 그룹id와 아이템data-id를 리턴합니다. \
 * (해당 id와 data-id는 임의입니다.)
 * 
 * @example
 * // 초기화
 * var editHomeDragInst = frontUI.editHomeDrag();
 * 
 * // 순서변경 콜백
 * editHomeDragInst.updateSort(function(element, groupId, itemId, arrElements){
 *     console.log('순서변경', element, groupId, itemId, arrElements);
 * })
 * // 두번쨰 그룹에서 2번아이템을 드래그하여 3아이템 자리에 위치시켰을 경우
 * // 결과예시:
 * // 순서변경 [HTMLElement], sortable_2, unique_id_2, ['unique_id_1', 'unique_id_3', 'unique_id_2', 'unique_id_4', 'unique_id_5', 'unique_id_6', 'unique_id_7']
 * 
 * // 노출/미노출 콜백
 * editHomeDragInst.updateView(function(element, groupId, itemId, oldState, newState){
 *     console.log('노출/미노출', element, groupId, itemId, oldState, newState);
 * })
 * // 두번째 그룹에서 2번 아이템의 노출/미노출 클릭시
 * // 결과예시:
 * // 노출/미노출 [HTMLElement],​ sortable_2, unique_id_2, true, false
 * 
 * 
 */
export function editHomeDrag() {
    let updateSortCallback = function(element, groupId, itemId, arrElements, showItem, hideItem){
        console.log('element:',element, '| groupId:',groupId, '| itemId:',itemId, '| arrElements:',arrElements, '| showItem,:',showItem, '| hideItem,:',hideItem,);
    }
    let updateViewCallback = function(element, groupId, itemId, oldState, newState){
        //console.log(element, groupId, itemId, oldState, newState);
    }
    let clickIfOneCallback = function(){
        console.log('보이는 계좌가 1개 이상 필요합니다.')
    }
    let changeCallback = function(){
        
    }

    var obj = {
        updateSort: function(fn){
            updateSortCallback = fn;
        },
        updateView: function(fn){
            updateViewCallback = fn;
        },
        clickIfOne: function(fn){
            clickIfOneCallback = fn;
        },
        changeSort: function(fn){
            changeCallback = fn;
        },
    };

    let $showBtn = $('.btn-finance-view01');
    let $cardArea = $('.component-card');
    if ($cardArea.length > 0) {
        $cardArea.each((index, item) => {
            if ($(item).find('.home-edit-card-group').length < 2){
                setTimeout(() => {
                    // $(item).find('.btn-finance-view01 > i').attr('class', 'ico-edit-view-disabled');
                    $(item).find('.btn-finance-view02 > i').attr('class', 'ico-edit-list-off');
                    //$(item).find('.btn-finance-view01').off('click');
                    return false;
                }, 0);
            }
        });
    }
    // FETASK-1406 : 순서변경 선택자 속성값으로 적용하기 위해 수정
    let $juiSortable, $juiSortableItem, $juiDraggable;
    if ($('[jui-sortable]').length > 0) {
        console.log(1111111)
        $juiSortable = $('[jui-sortable]');
        $juiSortableItem = $juiSortable.find('[jui-sortable-item]');
        $juiDraggable = '[jui-draggable]'
    } else { 
        console.log(2222)
        $juiSortable = $('.jui-sortable');
        $juiSortableItem = '.home-edit-card-group:not(.home-edit-card-disabled)'
        $juiDraggable = '.jui-draggable'
    }

    let currentWrap
    let currentPrev
    let startPos
    let endPos
    $juiSortable.each((i,sortable)=>{
        $(sortable).sortable({
            items: $juiSortableItem,
            revert: 100,
            animation: 150,
            axis: 'y',
            //grid: false,
            containment: $(sortable).closest('[jui-sortable-container]').length > 0 ? $(sortable).closest('[jui-sortable-container]')[0] : null,
            handle: $juiDraggable,
            //tolerance: 'pointer',
            connectWith: $(sortable).attr('data-connect') == undefined ? '' : `[data-connect="${$(sortable).attr('data-connect')}"]`,
            start (event,ui){
                if ($(ui.item).closest('[jui-sortable]').attr('data-connect') == undefined){
                    currentWrap = $(ui.item).closest('[jui-sortable]').attr('id')
                } else {
                    currentWrap = $(ui.item).closest('[jui-sortable]').attr('data-connect');
                    if ($(ui.item).closest('.type-show').length > 0 ) {
                        startPos = 'show'
                    } else {
                        startPos = 'hide'
                    }
                }
                
                currentPrev = $(ui.item).prev()
            },
            stop (event, ui) {
                if ($(ui.item).closest('[jui-sortable]').attr('data-connect') == undefined){
                    if ($(ui.item).closest('[jui-sortable]').attr('id') !== currentWrap) {
                        if (currentPrev.length == 0 ) {
                            $(`#${currentWrap}`).prepend($(ui.item))
                        } else {
                            currentPrev.after($(ui.item))
                        }
                    }
                } else {
                    if ($(ui.item).closest('[jui-sortable]').attr('data-connect') !== currentWrap) {
                        if (currentPrev.length == 0 ) {
                            $(`[data-connect="${currentWrap}"]`).prepend($(ui.item))
                        } else {
                            currentPrev.after($(ui.item))
                        }
                    } else {
                        if ($(ui.item).closest('.type-show').length > 0 ) {
                            endPos = 'show'
                        } else {
                            endPos = 'hide'
                        }
                    }
                }
                // if ($(event.target).hasClass('type-show') && $(event.target).find('[jui-sortable-item]').length == 0) { // 숨긴계좌이동시 보이는계좌 1개있을경우
                //     if (currentPrev.length == 0 ) {
                //         $(`[data-connect="${currentWrap}"]`).prepend($(ui.item))
                //     } else {
                //         currentPrev.after($(ui.item))
                //     }
                //     $(`.type-hide[data-connect="${currentWrap}"]`).find($(ui.item)).remove()
                //     clickIfOneCallback();
                // }
            },
            change(event, ui){
                changeCallback();
            },
            update(event, ui){
                const target = event.target;
                const $target = $(target);
                var listItem
                var showItem
                var hideItem
                var showConect
                var hideConect
                setTimeout(() => {
                    showConect = $(`.type-show[data-connect="${$(ui.item).closest('[jui-sortable]').attr('data-connect')}"]`)
                    hideConect = $(`.type-hide[data-connect="${$(ui.item).closest('[jui-sortable]').attr('data-connect')}"]`)
                    if ($(ui.item).closest('[jui-sortable]').hasClass('type-hide')){
                        if ($(ui.item).closest('[jui-sortable]').find('[jui-sortable-item]').length > 0) {
                            $(ui.item).addClass('disabled')
                        }
                    }
                    if ($(ui.item).closest('[jui-sortable]').hasClass('type-show')){
                        $(ui.item).removeClass('disabled')
                    }
                    if ($target.find('[jui-sortable-item]').length >= 0) {
                        //console.log('접근성 html')
                        if (startPos != endPos) {
                            if (startPos == 'show') {
                                showItem =showConect.find('[jui-sortable-item]').not('.disabled').map(function(){
                                    return $(this).attr('data-id')
                                }).get() 
                                hideItem =hideConect.find('[jui-sortable-item].disabled').map(function(){
                                    return $(this).attr('data-id')
                                }).get() 
                            }  else {
                                showItem =showConect.find('[jui-sortable-item]').not('.disabled').map(function(){
                                    return $(this).attr('data-id')
                                }).get() 
                                hideItem =hideConect.find('[jui-sortable-item].disabled').map(function(){
                                    return $(this).attr('data-id')
                                }).get() 
                            }
                        } else {
                            listItem = $(ui.item).closest('[jui-sortable]').find('[jui-sortable-item]').map(function(){
                                return $(this).attr('data-id')
                            }).get() 
                        }
                        // listItem = $(ui.item).closest('[jui-sortable]').find('[jui-sortable-item]').map(function(){
                        //     return $(this).attr('data-id')
                        // }).get() 
                       
                    } else {
                        //console.log('구 html')
                        listItem = $target.sortable('toArray', {attribute: 'data-id'})
                    }

                    if ($(ui.item).closest('[jui-sortable]').hasClass('type-hide')){
                        if ($(ui.item).closest('[jui-sortable]').find('[jui-sortable-item]').length > 0) {
                            $(ui.item).find('.txt-move').text('보기')
                            $(ui.item).closest('[jui-sortable]').find('.order-sortable-nodata').hide()
                        }
                        if ( showConect.find('[jui-sortable-item]').length == 0) {
                            showConect.find('.order-sortable-nodata').stop().slideDown(200)
                        }
                    }
                    if ($(ui.item).closest('[jui-sortable]').hasClass('type-show')){
                        $(ui.item).find('.txt-move').text('숨김');
                        if ($(ui.item).closest('[jui-sortable]').find('[jui-sortable-item]').length > 0) {
                            $(ui.item).closest('[jui-sortable]').find('.order-sortable-nodata').hide()
                        }
                        if ( hideConect.find('[jui-sortable-item]').length == 0) {
                            hideConect.find('.order-sortable-nodata').stop().slideDown(200)
                        }
                    }
                    if ($target.find('[jui-sortable-item]').length == 0) {
                        listItem = undefined ;
                    }
                    updateSortCallback(target, $target.attr('id'), $(ui.item).attr('data-id'), listItem,showItem,hideItem);
                    
                }, 10);

                //updateSortCallback(target, $target.attr('id'), ui.item.attr('data-id'), listItem);
            },
        });
    })
    
    if ($showBtn.length > 0) {
        $showBtn.each((index, item) => {
            $(item).off().on('click', (e) => {
                const target = e.target;
                const $target = $(target);
    
                if(!$target.hasClass('ico-edit-view-disabled')){
                    $target.hasClass('ico-edit-view-on') ?  $target.attr('class', 'ico-edit-view-off') :  $target.attr('class', 'ico-edit-view-on');
                }
    
                updateViewCallback(
                    target, 
                    $target.closest('.component-card').attr('id'), 
                    $target.closest('.home-edit-card-group').attr('data-id'),
                    !$target.hasClass('ico-edit-view-on'),
                    $target.hasClass('ico-edit-view-on')
                );
            });
        });
    }
    // if ($showBtn.length > 0) {
    //     $showBtn.each((index, item) => {
    //         $(item).off().on('click', (e) => {
    //             const target = e.target;
    //             const $target = $(target);
    
    //             if(!$target.hasClass('ico-edit-view-disabled')){
    //                 $target.hasClass('ico-edit-view-on') ?  $target.attr('class', 'ico-edit-view-off') :  $target.attr('class', 'ico-edit-view-on');
    //             }
    
    //             updateViewCallback(
    //                 target, 
    //                 $target.closest('.component-card').attr('id'), 
    //                 $target.closest('.home-edit-card-group').attr('data-id'),
    //                 !$target.hasClass('ico-edit-view-on'),
    //                 $target.hasClass('ico-edit-view-on')
    //             );
    //         });
    //     });
    // }
    if ($showBtn.length > 0) {
        $showBtn.each((index, item) => {
            /*! s: FETASK-a11y page sort 접근성 v.1.0.0 */
            /*
            if(isA11yCheckVersion()){
                const isDisableCard = $(item).hasClass('ico-edit-view-disabled');
                const isViewOn = $(item).find('i').hasClass('ico-edit-view-on');

                if(!isDisableCard){
                    if(isViewOn){
                        $(item).find('i').attr('class', 'ico-edit-view-on');
                        $(item).find('.hide-txt').text('보기');
                        $(item).closest('.home-edit-card-group').removeClass('disabled');
                    }else{
                        $(item).find('i').attr('class', 'ico-edit-view-off');
                        $(item).find('.hide-txt').text('숨김');
                        $(item).closest('.home-edit-card-group').addClass('disabled');
                    }
                }
            }
            */
            const isDisableCard = $(item).hasClass('ico-edit-view-disabled');
                const isViewOn = $(item).find('i').hasClass('ico-edit-view-on');

                if(!isDisableCard){
                    if(isViewOn){
                        $(item).find('i').attr('class', 'ico-edit-view-on');
                        $(item).find('.hide-txt').text('보기');
                        $(item).closest('.home-edit-card-group').removeClass('disabled');
                    }else{
                        $(item).find('i').attr('class', 'ico-edit-view-off');
                        $(item).find('.hide-txt').text('숨김');
                        $(item).closest('.home-edit-card-group').addClass('disabled');
                    }
                }
            /*! e: FETASK-a11y page sort 접근성 v.1.0.0 */

            $(item).off().on('click', (e) => {
                const target = e.target;
                const $target = $(target);

                /*! s: FETASK-a11y page sort 접근성 v.1.0.0 */
                /*
                if(isA11yCheckVersion()){
                    const isDisableCard = $target.hasClass('ico-edit-view-disabled');
                    const isViewOn = $target.hasClass('ico-edit-view-on');

                    if(!isDisableCard){
                        if(isViewOn){
                            $target.attr('class', 'ico-edit-view-off');
                            $target.find('.hide-txt').text('숨김');
                            $target.closest('.home-edit-card-group').addClass('disabled');
                        }else{
                            $target.attr('class', 'ico-edit-view-on');
                            $target.find('.hide-txt').text('보기');
                            $target.closest('.home-edit-card-group').removeClass('disabled');
                        }
                    }
                }else{
                    //기존 소스
                    console.log('?????')
                    if(!$target.hasClass('ico-edit-view-disabled')){
                        $target.hasClass('ico-edit-view-on') ?  $target.attr('class', 'ico-edit-view-off') :  $target.attr('class', 'ico-edit-view-on');
                    }
                }
                */
                const isDisableCard = $target.hasClass('ico-edit-view-disabled');
                const isViewOn = $target.hasClass('ico-edit-view-on');

                if(!isDisableCard){
                    if(isViewOn){
                        $target.attr('class', 'ico-edit-view-off');
                        $target.find('.hide-txt').text('숨김');
                        $target.closest('.home-edit-card-group').addClass('disabled');
                    }else{
                        $target.attr('class', 'ico-edit-view-on');
                        $target.find('.hide-txt').text('보기');
                        $target.closest('.home-edit-card-group').removeClass('disabled');
                    }
                }
                /*! e: FETASK-a11y page sort 접근성 v.1.0.0 */
    
                updateViewCallback(
                    target, 
                    $target.closest('.component-card').attr('id'), 
                    $target.closest('.home-edit-card-group').attr('data-id'),
                    !$target.hasClass('ico-edit-view-on'),
                    $target.hasClass('ico-edit-view-on')
                );
            });
        });
    }
    

    return obj;

}

//drag click (홈편집 txt-move-btn 요소 클릭시)
/**
 * @summary 메인 계좌 노출 순서변경 (홈편집 txt-move-btn 요소 클릭시) \
 * 각각의 그룹은 유니크한 id를 갖습니다. \
 * 각 그룹의 아이템들은 유니크한 data-id를 갖습니다. \
 * 순서를 바꾸거나 노출/미노출을 변경할시 해당 그룹id와 아이템data-id를 리턴합니다. \
 * (해당 id와 data-id는 임의입니다.)
 * 
 * @example
 * // 초기화
 * var editHomeDragClickInst = editHomeDragClickEvent()
 * 
 * // 순서변경 콜백
 * editHomeDragClickInst.updateClickSort(function(element, groupId, itemId, arrElements){
 *     console.log('순서변경', element, groupId, itemId, arrElements);
 * })
 * 
 * 
 */
export function editHomeDragClickEvent(){
    let updateSortCallback = function(element, groupId, itemId, arrElements){
        console.log('element:',element, '| groupId:',groupId, '| itemId:',itemId, '| arrElements:',arrElements);
    }
    let clickIfOneCallback = function(){
        console.log('보이는 계좌가 1개 이상 필요합니다.')
    }

    var obj = {
        updateClickSort: function(fn){
            updateSortCallback = fn;
        },
        clickIfOne: function(fn){
            clickIfOneCallback = fn;
        },
    };
    let sortable, sortableItem

    $(document).on('click', '[data-connect] .txt-move-btn', function(){
        let $item;
        if ($(this).closest('[jui-sortable-item]').length > 0) {
            $item =  $(this).closest('[jui-sortable-item]');
        } else if ($(this).closest('[sortable-item]').length > 0) {
            $item = $(this).closest('[sortable-item]');
        }
        sortable = $item.closest('[jui-sortable]').length > 0 ? '[jui-sortable]' : '.ui-sortable';
        sortableItem = $item.closest('[jui-sortable]').length > 0 ? '[jui-sortable-item]' : '[sortable-item]';
        // if ($(this).closest(sortable).find(sortableItem).length == 1 && $(this).closest('.type-show').length > 0) {
        //     clickIfOneCallback();
        //     return false
        // }
        const $connect = $(this).closest('[data-connect]');
        if ($connect.hasClass('type-show')) {
            $(`.type-hide[data-connect="${$connect.attr('data-connect')}"]`).append($item);
        } else {
            $(`.type-show[data-connect="${$connect.attr('data-connect')}"]`).append($item);
        }
        textShowHideChk($item);

        $(`[data-connect="${$connect.attr('data-connect')}"]`).each((i,connect)=>{
            let listItem = [];
            if ($(connect).find(sortableItem).length > 0) {
                //console.log('접근성 html')
                listItem = $(connect).find(sortableItem).map(function(){
                    return $(this).attr('data-id')
                }).get() 
            }
           updateSortCallback(connect,$(connect).attr('id'),$($item).attr('data-id'),listItem);  // 콜백
        })

        if ($(this).closest(sortableItem).length > 0) { // 위아래 클릭 접근성 포커스 이동
            $item.find('.txt-move-btn').focus();
        }
        if (sortable == '.ui-sortable') {
            $(`.type-hide[data-connect="${$connect.attr('data-connect')}"]`).find('[sortable-item]').each(function(i,e){
                $(e).attr('sortable-item-index',i+1)
            })
            $(`.type-show[data-connect="${$connect.attr('data-connect')}"]`).find('[sortable-item]').each(function(i,e){
                $(e).attr('sortable-item-index',i+1)
            })
        }

    })



    function textShowHideChk($item) {
        
        if ($item.closest(sortable).hasClass('type-hide')){
            if ($item.closest(sortable).find(sortableItem).length > 0) {
                $item.addClass('disabled')
                $item.find('.txt-move').text('보기')
                $item.closest(sortable).find('.order-sortable-nodata').hide();
                if ( $(`.type-show[data-connect="${$item.closest(sortable).attr('data-connect')}"]`).find(sortableItem).length == 0) {
                    $(`.type-show[data-connect="${$item.closest(sortable).attr('data-connect')}"]`).find('.order-sortable-nodata').stop().slideDown(200);
                }
                if (isA11yCheckVersion()) {
                    textShowHideChkA11y('hide', $item)
                }
                
            }
        }
        if ($item.closest(sortable).hasClass('type-show')){
            $item.removeClass('disabled')
            $item.find('.txt-move').text('숨김')
            if ( $(`.type-hide[data-connect="${$item.closest(sortable).attr('data-connect')}"]`).find(sortableItem).length == 0) {
                $(`.type-hide[data-connect="${$item.closest(sortable).attr('data-connect')}"]`).find('.order-sortable-nodata').stop().slideDown(200);
            }
            if ($item.closest(sortable).find(sortableItem).length > 0) {
                $item.closest(sortable).find('.order-sortable-nodata').hide();
            }
            if (isA11yCheckVersion()) {
                textShowHideChkA11y('show', $item);
            }
            
            
        }
        if ($item.closest('.ui-sortable').length > 0 ) { // 위아래 클릭 버튼  순서 재정의
            $(`[data-connect="${$item.closest(sortable).attr('data-connect')}"]`).each((i,e)=>{
                $(e).data('ui').update(undefined, 'showhide');
            })
        }
    }

    function textShowHideChkA11y(type, item) {
        let itemTxt = ''
        itemTxt = item.find('.list-row-name .txt').text()
        const liveDiv = document.createElement('div');
        liveDiv.classList.add('sort-item-text');
        const sortAreaEle = document.querySelector('.sort-live');
        let readLiveText = '';
        if (type == 'hide') {
            const hideTxt = item.closest(sortable).prev('[sortable-hide-text]').length > 0 ? item.closest(sortable).prev('[sortable-hide-text]').text() : '숨김으';
            readLiveText = `${itemTxt}은(는) ${hideTxt}로 이동했습니다.`;
        } else {
            const showTxt = item.closest(sortable).prev('[sortable-show-text]').length > 0 ? item.closest(sortable).prev('[sortable-show-text]').text() : '보기';
            readLiveText = `${itemTxt}은(는) ${showTxt}로 이동했습니다.`;
        }
        liveDiv.textContent = readLiveText;
        sortAreaEle.append(liveDiv);
        setTimeout(() => {
            liveDiv.remove();
        }, 100 * readLiveText?.length);
    }

    return obj;
}

/**
 * @summary 지정요소에 지정된 자식들 삽입
 * @param {jQuery} $el 자식들을 추가할 부모요소 
 * @param {string} items 부모요소에 추가될 자식들 
 *
 */
export function wrapInnerScroll($el, items){
    const selectedItems = $el[0].querySelectorAll(items);
    const divScroll = document.createElement('div');
    divScroll.className = 'inner-scroll';
    if(selectedItems.length){
        Array.from(selectedItems).forEach(item => divScroll.appendChild(item));
        $el[0].prepend(divScroll);
    }
}

/**
 * @summary ui-amount 요소안에 sum-check 요소를 fadeOut시키고 3초후 fadeIn시킴
 *
 */
export function confirmAmount() {
    let amountBtn = $('.ui-amount');

    $('body')?.on('click', '.ui-amount .sum-check', function(){
        const $uiAmount = $(this).closest('.ui-amount');
        if($uiAmount.hasClass('on')) return false;
        $uiAmount.addClass('on');
        $uiAmount.find('.sum-check').show().stop().fadeOut(500);
        // let _number = 1
        // if ($uiAmount.find('[data-interest-num]').length > 0) {
        //     $uiAmount.find('.txt-count-wrap').css('opacity',1)
        //     _number = $uiAmount.find('[data-interest-num]').attr('data-interest-num');
        //     $uiAmount.find('[data-interest-num]').attr('data-interest-num', 0)
        //     setTimeout(() => {
        //         console.log(_number)
        //         $uiAmount.find('[data-interest-num]').attr('data-interest-num', Number(_number))
        //     }, 10);
        // }
        
        //PBK-APP-IOS-16
        $uiAmount.find('.sum').focus();
        
        setTimeout(() => {
            // if ($uiAmount.find('.txt-count-wrap').length > 0 ) {
            //     $uiAmount.find('.txt-count-wrap').css('opacity',0)
            // }
            $uiAmount.find('.sum-check').hide().stop().fadeIn(450);

            $uiAmount.removeClass('on');
            
            //PBK-APP-IOS-16
            // 240708 포커스 회귀 막기
            // $uiAmount.find('.sum-check').focus();
            // console.log('클릭한 요소로 포커스 이동됨')
        }, 3000);
    })
    
    // if (amountBtn.find('.count-item').length > 0) {
    //     amountBtn.each((idx,el)=>{
    //         if ($(el).find('.count-item').length > 0 ){
    //             $(el).find('[data-interest-num]').text(decimal($(el).find('[data-interest-num]').attr('data-interest-num')))
    //         }
    //     })
    // }

    // amountBtn.each((index, item) => {
    //     $(item).off().on('click', () => {
    //         if($(item).hasClass('on')) return false;

    //         $(item).addClass('on');
    //         $(item).find('.sum-check').show().stop().fadeOut(500);

    //         setTimeout(() => {
    //             $(item).find('.sum-check').hide().stop().fadeIn(450);

    //             $(item).removeClass('on');
    //         }, 3000);
    //     });
    // });
}

/**
 * @summary [data-item] 요소의 style.top을 [data-item-obj] 요소의 (상대위치 + 높이) 값으로 변경 
 *
 */
export function fixedDataItem() { 
    if ($(document).find('[data-item]').length > 0 && $(document).find('[data-item-obj]').length > 0) {
        var $dataItem = $(document).find('[data-item]').not('.ui-input, select'); // 230828 : 셀렉트, ui-input  속성값에 data-item 중복이라 추가
        for (var i = 0; i< $dataItem.length; i++) {
            $dataItem[i].style.top = $(document).find('[data-item-obj]').offset().top+ $(document).find('[data-item-obj]').outerHeight(true) + 'px';
        }
    }
}

/**
 * @summary [data-fade-wrap] 요소안의 [data-fade-item] 요소를 [data-fade-button] 클릭 트리거로 순차 애니메이션 시킴 
 *
 */
export function fadeAction(index) {
    if (!$('[data-fade-wrap]').length > 0){
        return false;
    }
    const $wrap = $('[data-fade-wrap]');
    const $item = $wrap.find('[data-fade-item]');
    $wrap.attr('fade-active-index', index != undefined ? index : 0)
    $item.each((idx, el)=>{
        $(el).attr('fade-item-num', idx)
    })

    let activeIndex = 0
    if (index != undefined) {
        activeIndex = index
    }
    $(document).on('click', '[data-fade-button]', function(){
        if($(this).attr('fade-index') != undefined){
            activeIndex = $(this).attr('fade-index')
        } else {
            activeIndex++
        }
        attachEvent()
    })
    attachEvent()
    function attachEvent(){
        $item.each((idx, el)=>{
            $(el).stop().animate({
                'opacity': 0,
            },200, function(){
                $(el).css('display', 'none')
            })
        })
        $item.eq(activeIndex).css({
            'display':'block',
            'position':'relative',
            'opacity': 0,
            'top': $item.eq(activeIndex).attr('fade-item-top') == undefined ? '50px' : $item.eq(activeIndex).attr('fade-item-top') +'px'
        }).stop().animate({ 
            'opacity': 1,
            'top': '0'
        },400 , function(){
            $wrap.attr('fade-active-index', activeIndex)
        })
        $(`[data-fade-index="${activeIndex}"]`).each(function(idx, el){
            $(el).css({
                'display':'block',
                'opacity': 0,
            }).stop().animate({ 
                'opacity': 1,
            },400)
        })
    }
}

// 사용안함
export function scrollTriggerAnim(obj, options) {
    const _options = $.extend({
        trigger: obj,
        start: 'top-=50px bottom',
        end: 'bottom top',
        onEnter: function (st) {
            const $trigger = $(st.trigger);
            if ($trigger.hasClass('ui-animation')) {
                return;
            }
            $trigger.addClass('ui-animation');

            if (options.onEnterAction && $.isFunction(options.onEnterAction)) {
                options.onEnterAction();
            }
        },
        markers: false
    }, options);

    ScrollTrigger.create(_options);
}

// 사용안함
export function animateBtn(){
    $('.ui-btn-animate').on('click', function(e){
        const $this = $(this);
        $this.addClass('animate-btn');
        $this.on('animationend', () => {
            $this.removeClass('animate-btn');
            $this.off('animationend');
        });
    })
}

// 사용안함
export function isInViewport(element, target){
    if (!$(element).is(':visible')) return false;

    const rect = element.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    return rect.top <= targetRect.height
}

/**
 * @summary asis 홈일때 하단 탭 로띠 이미지 json 링크 불러오는 함수
 */
export function skeletonTabAnimation () {
    frontUI.lottieAnimation('lottieHomeTab1','/resource/js/mmk/json/homebar/home-tab1.json',false, '1.5')
    frontUI.lottieAnimation('lottieHomeTab2','/resource/js/mmk/json/homebar/home-tab2.json',false, '1.5')
    frontUI.lottieAnimation('lottieHomeTab3','/resource/js/mmk/json/homebar/home-tab3.json',false, '1.5')
    frontUI.lottieAnimation('lottieHomeTab4','/resource/js/mmk/json/homebar/home-tab4.json',false, '1.5')
}

/**
 * @summary 스켈레톤 js실행
 * @param {string} direction   'forward' or 'backward'
 * @param {string} skeletonHtml   페이지 네이밍 ex)'home1'
 * @param {function} callback    스켈레톤 동작 완료후 콜백
 * @example
 * frontUI.fakePageTransition('forward', 'home1', function(){})
 */
export function fakePageTransition(direction = 'forward', skeletonHtml = 'default', callback = () => {}){
    gsap.registerPlugin(CustomEase);
    CustomEase.create("customEase", "M0,0 C0.5,0 0.2,1 1,1")

    let $dimm = $('.dimm.skeleton');
    let $page = $('#wrap-mmk');
    let $skeleton = $;
    let zIdx = 1000;
    if(!$dimm.hasClass('skeleton')){
        $('body').append($('<div class="dimm skeleton" style="display: block; position: fixed;top:-100px;right:-100px;bottom:-100px;left:-100px; z-index: 100; background: #000; opacity: 0.1;"></div>'))
        $dimm = $('.dimm.skeleton')
    }

    if(!$skeleton[0]){
        switch (skeletonHtml) {
            case 'none':
                $skeleton = $(getSkeletonNoneTmpl());
            break;
            case  'main1': // 홈_my
                $skeleton = $(getSkeletonMainTmpl1());
                setTimeout(() => {
                    frontUI.lottieAnimation('lottieHomeTab1','/resource/js/mmk/json/homebar/home-tab1.json',false, '1.5')    
                }, 10);
                
            break;
            case  'main2': //홈_상품
                $skeleton = $(getSkeletonMainTmpl2());
                setTimeout(() => {
                    frontUI.lottieAnimation('lottieHomeTab2','/resource/js/mmk/json/homebar/home-tab2.json',false, '1.5')    
                }, 10);
                
            break;
            case  'main3': // 홈_타임라인
                $skeleton = $(getSkeletonMainTmpl3());
                setTimeout(() => {
                    frontUI.lottieAnimation('lottieHomeTab3','/resource/js/mmk/json/homebar/home-tab3.json',false, '1.5')    
                }, 10);
            break;
            case  'main4': //홈 메뉴
                $skeleton = $(getSkeletonMainTmpl4());
                $skeleton = $(getSkeletonMainTmpl4());
                setTimeout(() => {
                    frontUI.lottieAnimation('lottieHomeTab4','/resource/js/mmk/json/homebar/home-tab4.json',false, '1.5')    
                }, 10);
            break;
            case  'main5': //홈 간편홈모드
                $skeleton = $(getSkeletonMainTmpl5());
            break;
            case  'sub1': //서브 혜택
                $skeleton = $(getSkeletonSubTmpl1());
            break;
            case  'sub2': //서브 계좌목록
                $skeleton = $(getSkeletonSubTmpl2());
            break;
            case  'sub3': //서브 거래내역
                $skeleton = $(getSkeletonSubTmpl3());
            break;
            case  'sub4': //서브 이체
                $skeleton = $(getSkeletonSubTmpl4());
            break;
            case  'sub5': //서브 부동산자산관리 홈
                $skeleton = $(getSkeletonSubTmpl5());
            break;
            case  'sub6': //서브 공모주 청약
                $skeleton = $(getSkeletonSubTmpl6());
            break;
            case  'sub7': //서브 요즘케뱅 [FETASK-1896]
                $skeleton = $(getSkeletonSubTmpl7());
            break;
            case  'sub8': // CHPFMTASK-1167 one 체크카드 
                $skeleton = $(getSkeletonSubTmpl8());
            break;
            case  'home1':  // 홈개편 홈탭
                $skeleton = $(getSkeletonHomeTmpl1());
            break;
            case  'home2':  // 홈개편 혜택탭
                $skeleton = $(getSkeletonHomeTmpl2());
            break;
            case  'home3':  // 홈개편 발견탭 foru
                $skeleton = $(getSkeletonHomeTmpl3());
            break;
            case  'home4':  // 홈개편 발견탭 상품
                $skeleton = $(getSkeletonHomeTmpl4());
            break;
            case  'home5':  // 홈개편 사장님홈
                $skeleton = $(getSkeletonHomeTmpl5());
            break;
            case  'home6':  // 홈개편 간편홈
                $skeleton = $(getSkeletonHomeTmpl6());
            break;
            case  'home7':  // 홈개편 전체탭
                $skeleton = $(getSkeletonHomeTmpl7());
            break;
            case  'home8':  // 홈 - 투자탭 - 투자하기
                $skeleton = $(getSkeletonHomeTmpl8());
            break;
            case  'home9':  // // 홈 - 투자탭 - 내종목
                $skeleton = $(getSkeletonHomeTmpl9());
            break;
            case  'home10':  // 홈 - 투자탭 - 인사이트
                $skeleton = $(getSkeletonHomeTmpl10());
            break;
            case  'home_sub1':  // 홈개편 내 자산(전체계좌조회)
                $skeleton = $(getSkeletonHomeTmplSub1());
            break;
            default: // 동그라미 로딩 애니메이션
                $skeleton = $(getSkeletonDefaultTmpl());
            break;
        }
        gsap.set($skeleton, {xPercent: 100});
        if(direction === 'forward'){
            gsap.set($dimm, {duration: .3, display: 'block', autoAlpha: 0.1, zIndex: zIdx+1})
        }else if(direction === 'backward'){
            gsap.set($dimm, {duration: .3, display: 'block', autoAlpha: 0.1, zIndex: zIdx+1})
        } else if (direction === 'none') {
            gsap.set($skeleton, {xPercent: 0});
        }
        $('body').append($skeleton);
    }
    gsap.killTweensOf(this.$dimm);

    if(direction === 'forward'){
        gsap.to($dimm, {duration: .4, autoAlpha: 0.1, ease: Power4.ease}, 0);
        gsap.fromTo($skeleton, {xPercent: 100, zIndex: zIdx+2},{duration: .3, xPercent: 0, ease: 'customEase'});
        gsap.fromTo($page,{xPercent: 0, zIndex:zIdx}, {
            duration: .3, xPercent: -20, ease: 'customEase', onComplete: () => {
                /*! s: FETASK-a11y page isA11yFakeSkeleton v.1.0.0 */
                isA11yCheckVersion() && isA11yFakeSkeleton($skeleton);
                /*! e: FETASK-a11y page isA11yFakeSkeleton v.1.0.0 */

                setTimeout(() => {
                    callback && $.isFunction(callback) && callback();
                }, 50);
            }
        });
    }else if(direction === 'backward'){
        gsap.to($dimm, {duration: .4, autoAlpha: 0.1, ease: 'customEase'}, 0);
        gsap.fromTo($page, {position: 'relative', xPercent: 0, zIndex: zIdx},{duration: .3, xPercent: 100, ease: 'customEase'});
        gsap.fromTo($skeleton,{xPercent: -100, zIndex:zIdx+2}, {
            duration: .3, xPercent: 0, ease: 'customEase', onComplete: () => {
                /*! s: FETASK-a11y page isA11yFakeSkeleton v.1.0.0 */
                isA11yCheckVersion() && isA11yFakeSkeleton($skeleton);
                /*! e: FETASK-a11y page isA11yFakeSkeleton v.1.0.0 */
                gsap.to($dimm, {duration: .4, display: 'none', autoAlpha: 0});
                setTimeout(() => {
                    callback && $.isFunction(callback) && callback();
                }, 50);
            }
        });
    }
}

// 사용안함
export function radioPropChange() {
    if ($('.input-radio').length > 0) {
        $('.input-radio').each( (idx, el) => {
            const $this = $(el).find('input[type="radio"]');
            disabled($this);

            $this.on('customDisabled', function(e){
                const $this = $(e.currentTarget);
                disabled($this);
            })
        });
    };

    function disabled(el){
        if (el.prop('disabled') === true) {
            el.closest('.input-radio-group').addClass('disabled');
        } else {
            el.closest('.input-radio-group').removeClass('disabled');
        }
    }
}

// 사용 안함
function format_number(x) {
return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

/**
 * @summary 지정된 wrap 안에 [data-ani-delay] 요소에 css 'animation-delay' : `0.01s` 동적 추가
 * @param {jquery} wrap 기본값 [data-ani-delay] 요소의 부모 body
 */
export function aniDelay(wrap){
    let $wrap = wrap != undefined ? wrap : $('[data-ani-delay]').closest('body');
    if (!$wrap.find('[data-ani-delay]').length > 0) {
            return false;
    }
    
    const num = 0.01
    $wrap.find('[data-ani-delay]').each(function(i,e){
        $(e).removeClass('on')
        
    })
    $wrap.find('[data-ani-delay]:visible').each(function(i,e){
        $(e).removeClass('active')
        $(e).addClass('active', 'on')
        $(e).css({
            'animation-delay' : `0.01s`
        })
        
    })
}

/**
 * @summary 기존에 사용중이던  숫자 카운트 애니메이션 
 * @param {sting} target  defalut -> [data-ani-count]
 * @param {boolean} _scroll  deflaut -> false   [ani-count-scroll] 속성값이 있으면 true값 변경됨  
 */
export function numberCountAni(target = null, _scroll = false){ // CHPFMTASK-862 : 240418 _scroll 추가 
    gsap.registerPlugin(CustomEase);
    //CustomEase.create("numberSlow", "M0,0 C0.108,0.454 -0.055,0.1920.145,0.79 0.228, 1.038 0.818,1.001 1,1")
    CustomEase.create("numberSlow", "M0,0 C0.043,0.455 -0.087,0.768 0.132,0.858 0.377,0.941 0.818,1.001 1,1")
    if (target === null) { //param el이 없으면
        const counters = document.querySelectorAll('[data-ani-count]');
        if ($(counters).closest('[ani-count-wrap]').length > 0 ) { 
            return false
        }
        counters.forEach( counter => {
            if (!$(counter).closest('.ui-popup').length>0) {// FETASK-1641 팝업내에 있는 숫자카운팅 한번 실행되면 0으로 시작이 아니여서 조건으로 막음
                counting(counter);
            }
            
        });
    } else {//param el이 있으면 그 el만 애니메이션
        const $el = getjQueryEl(target);
        if ($el.attr('ani-count-scroll') == undefined) { // CHPFMTASK-862 : 240418 팝업내 넘버카운트 있을경우  팝업open시 1회 실행되는거 방지 
            counting($el[0]);
        } else {
            if (_scroll == true) {
                counting($el[0]);
            }
        }
        
        
    } 
    function counting(el) {
        const value = {
            number: parseInt(el.getAttribute('data-ani-count')),
        }
        
        // 240415 속도조정값 추가
        let _easing = 'circ.power', _duration = 3;
        if ($(el).attr('ani-count-easing') != undefined) {
            _easing = $(el).attr('ani-count-easing');
        }
        if ($(el).attr('ani-count-speed') != undefined) {
            _duration = $(el).attr('ani-count-speed');
        }
        gsap.from(value, {
            duration:_duration, //240415 기본값 변수로 뺌
            ease: _easing,
            number: 0,
            roundProps: 'number',
            onUpdate:function(){
                el.innerText = format_number(value.number);
            },
            onComplete:function(){
            }
        });
    }
}

/**
 * @summary [data-ani-count][ani-count-scroll] 속성을 가진요소를 조건에 따라 스크롤에 맞춰 애니메이션 시킴
 */
export function numberCountAniScroll(){
    if (!$('[data-ani-count][ani-count-scroll]').length > 0) {
        return false
    }
    const counters = $('[data-ani-count][ani-count-scroll]');
    const countersOffsetTop = []

    if (counters[0].closest('html').classList.contains('pc') ){ // pc화면에 모달팝업인 경우에 (layout-pddetail-pc.html)
        counters.each(function(idx, element){
            counters.text(0)
            countersOffsetTop.push($(element).offset().top)
        })
    } else {
        counters.each(function(idx, element){
            $(element).text(0)
            countersOffsetTop.push($(element).offset().top)
        })
    }
    
    
    if (counters[0].closest('.ui-popup') != undefined){
        let _index = 0;
        if (counters[0].closest('html').classList.contains('pc') ){ // pc화면에 모달팝업인 경우에 (layout-pddetail-pc.html)
            counters.parents('.popup-group').off('scroll.cascrollpc').on('scroll.cascrollpc', function(){
                if ($(this).scrollTop() + $(this).height() + $('html').scrollTop() > countersOffsetTop[_index] && _index < counters.length) {
                    $(counters[_index]).addClass('active')
                    frontUI.numberCountAni($(counters[_index]), true)
                    _index++
                }
            })
        } else {
            counters.parents('.ui-popup').off('scroll.cascroll').on('scroll.cascroll', function(){
                if ($(this).scrollTop() + $(this).height() > countersOffsetTop[_index] + 120 - $(window).scrollTop() && _index < counters.length) {
                    $(counters[_index]).addClass('active')
                    frontUI.numberCountAni($(counters[_index]), true)
                    _index++
                }
            })
        }
    } else {
        let _index = 0;
        $('.page-inner-scroll').off('scroll.cascrollAll').on('scroll.cascrollAll', function(){
            if ($(this).scrollTop() + $(this).height() > countersOffsetTop[_index] - $(window).scrollTop() && _index < counters.length) {
                $(counters[_index]).addClass('active')
                frontUI.numberCountAni($(counters[_index]), true)
                _index++
            }
        })
    }
}

/**
 * @summary [FETASK-1970] 체크 input  부모의 클래스 넣는 이벤트 \
 * [input-checkbox] 클릭시  input-checkbox="test"의 값을  [input-checkbox-wrap] 값의 addClass('test')  값이 없으면  active값 
 */
export function inputCheckBoxWrapActive() {  //FETASK-1970 : 체크 input  부모의 클래스 넣는 이벤트 
    $(document).on('click', '[input-checkbox] ', function(){
        const _class = $(this).attr('input-checkbox') == '' ? 'active' : $(this).attr('input-checkbox');
        const isA11yCheck = isA11yCheckVersion();
        if ($(this).is(':checked')){
            $(this).closest('[input-checkbox-wrap]').addClass(_class);
            //CHPFMTASK-2283 : 접근성대응 (2025.05.23)
            if(isA11yCheck){
                $(this).attr('aria-expanded', false)
            }
        } else {
            $(this).closest('[input-checkbox-wrap]').removeClass(_class);
            //CHPFMTASK-2283 : 접근성대응 (2025.05.23)
            if(isA11yCheck){
                $(this).attr('aria-expanded', true)
            }
        }
    });
    // CHPFMTASK-722 : 체크 input  부모의 disabled 속성확인 추가
    const icBox = $('[input-checkbox]');
    if(icBox.length > 0){
        icBox.each(function(){
            if($(this).attr('disabled')) $(this).closest('[input-checkbox-wrap]').addClass('disabled');
        });
    }
}

/**
 * @summary [A11YTASK-466] 라디오 input  부모의 클래스 넣는 이벤트 \
 * [input-radiobutton] 클릭시  input-radiobutton="test"의 값을  [input-radiobutton-wrap] 값의 addClass('test')  값이 없으면  active값 
 */
export function inputRadiobuttonWrapActive() {  //A11YTASK-466 : 라디오 input  부모의 클래스 넣는 이벤트 
    $(document).on('click', '[input-radiobutton] ', function(){
        const _class = $(this).attr('input-radiobutton') == '' ? 'active' : $(this).attr('input-radiobutton');

        $(this).closest('.input-radio-card-group').find('[input-radiobutton]').removeAttr('checked');
        $(this).closest('.input-radio-card-group').find('[input-radiobutton-wrap]').removeClass('active');

        if($(this).attr('checked') == 'undefined' || $(this).attr('checked') == undefined){
            $(this).attr('checked', [])
            $(this).closest('[input-radiobutton-wrap]').addClass('active');
        } 
        // if ($(this).is(':checked')){
        //     $(this).closest('[input-radiobutton-wrap]').addClass(_class);
        // } else {
        //     $(this).closest('[input-radiobutton-wrap]').removeClass(_class);
        // }
    });
    const icBox = $('[input-radiobutton]');
    if(icBox.length > 0){
        icBox.each(function(){
            if($(this).attr('disabled')) $(this).closest('[input-radiobutton-wrap]').addClass('disabled');
        });
    }
}

/**
 * @summary value값에 따라 [data-inputcheck-obj] 속성의 요소와 input-checkbox 요소를 제어
 * @param {string} value show / hide
 */
export function inputCheckobj(value){
    const checkWrap = $('[data-inputcheck-obj]');
    if(checkWrap){
        const setClass = 'input-checkobj-wrap', inputcheckObj = checkWrap.find(`.${checkWrap[0]?.dataset?.inputcheckObj}`)[0];
        if(inputcheckObj){
            const getValue = value,
            checkInput = checkWrap.find('.input-checkbox input[type="checkbox"]');
            let checkNum = 0;
            if(getValue){
                showhideObj(value);
                if(getValue != 'show'){
                    checkInput.prop('checked',false);
                    addChangeEvent();
                }
                return false;
            }else{
                if(checkWrap[0]?.classList.contains(setClass)) return false;
                checkWrap[0]?.classList.add(setClass);
                inputcheckObj.style.display = 'none';
                addChangeEvent();
            }
            function addChangeEvent() {
                checkNum = 0;
                checkInput.off('change customChange');
                setTimeout(()=>{
                    checkInput.on('change customChange', function(e){
                        const inputChecked = $(this).is(':checked');
                        (inputChecked) ? checkNum++ : checkNum--;
                        (checkNum > 0) ? showhideObj('show') : showhideObj('hide');
                    });
                },200);
            }
            function showhideObj(sh){
                (sh == 'hide' || sh == '' || sh == undefined) ? inputcheckObj.style.display = 'none' : inputcheckObj.style.display = 'block';
            }
        }
    }
    // 240229 수정
};

/**
 * @summary [data-role="agree-box"], [data-role="agree-all"] 속성을 사용한 요소의 checked 제어 
 */
export function checkAgree(){
    const allCheckWrap = '[data-role="agree-wrap"]';
    const defaultCheckbox = '.input-checkbox input[type="checkbox"]'
    
    $('[data-role="agree-box"]').find(defaultCheckbox).on('change customChange', function(e){
        const eve = e;
        allCheck(e, 'box');
    });

    $('[data-role="agree-all"]').find(defaultCheckbox).on('change customChange', function(e){
        const eve = e;
        allCheck(e, 'all');
    });

    function allCheck(event, type, force){
        const target = $(event.currentTarget);
        const $wrap = target.closest(allCheckWrap);
        const inpAll = $wrap.find('[data-role="agree-all"]').find(defaultCheckbox);
        const inpBox = $wrap.find('[data-role="agree-box"]');
        const inp2depth = inpBox.find(defaultCheckbox);
        const inp2depthLength = inp2depth.length;
        const checkedLength = inp2depth.filter(':checked').length;
        // s: 동작대기 추가
        const isAwait = target.attr('data-stop-event') !== undefined;
        
        if (isAwait && !force && target.is(":checked")) {
            target.data('ui', {
                go: function(){allCheck(event, type, true)},
                back: function(){target.prop('checked', false).trigger('change');}
            });
            return;
        } else {
            target.data('ui', {});
        }
        // s: 동작대기 추가

        if (type === 'all') {
            if (inpAll.is(':checked')) {
                if (inp2depth !== checkedLength && !inpAll.hasClass('each')) {
                    inp2depth.prop('checked', true);
                }
                if ($wrap.attr('data-box-fold') !== 'false') {
                    setTimeout( () => {
                        inpBox.slideUp(200);
                    },150)
                }
            } else {
                if (!inpAll.hasClass('each')) {
                    inp2depth.prop('checked', false);
                }
                if ($wrap.attr('data-box-fold') !== 'false') {
                    inpBox.slideDown(200);
                }
            }
        } else {
            inpAll.addClass('each');
            if (inp2depthLength === checkedLength) {
                inpAll.prop('checked', true);
            } else {
                inpAll.prop('checked', false);
            }
            setTimeout(function(){
                inpAll.removeClass('each');
                inp2depth.removeClass('depEach')  // FETASK-1442 약관 2뎁스 3뎁스  추가
            }, 200);
        }
    }
}

/**
 * @summary [data-role="agree-depth2 ~ 3"] 속성을 사용한 요소의 checked 제어
 */
export function checkAgreeDepth2(){ // FETASK-1442 약관 2뎁스 3뎁스 
    const depth2 = '[data-role="agree-depth2"]';
    const depth3 = '[data-role="agree-depth3"]';
    const defaultCheckbox = '.input-checkbox input[type="checkbox"]'
    let $inputDepth2,$inputDepth3, inputDepth3Length, inputDepth3ChkLength;
    $(depth2).find(defaultCheckbox).on('change customChange', function(e){
        allCheck(e,'dep2')
    });
    $(depth3).find(defaultCheckbox).on('change customChange', function(e){
        allCheck(e,'dep3')
    })

    function allCheck(event, type, force){
        const target = $(event.currentTarget);
        if (type == 'dep2') {
            $inputDepth2 = target;
            $inputDepth3 = target.closest(depth2).next(depth3).find(defaultCheckbox)
            inputDepth3Length = $inputDepth3.length;
            inputDepth3ChkLength = $inputDepth3.filter(':checked').length;
        } else {
            $inputDepth2 = target.closest(depth3).prev(depth2).find(defaultCheckbox)
            $inputDepth3 = target.closest(depth3).find(defaultCheckbox)
            inputDepth3Length = $inputDepth3.length;
            inputDepth3ChkLength = $inputDepth3.filter(':checked').length;
        }
    
        // s: 동작대기 추가
        const isAwait = target.attr('data-stop-event') !== undefined;
        
        if (isAwait && !force && target.is(":checked")) {
            target.data('ui', {
                go: function(){allCheck(event, type, true)},
                back: function(){target.prop('checked', false).trigger('change');}
            });
            return;
        } else {
            target.data('ui', {});
        }
        // s: 동작대기 추가
    
        if (type === 'dep2') {
            if ($inputDepth2.is(':checked')) {
                if (inputDepth3Length !== inputDepth3ChkLength && !$inputDepth2.hasClass('depEach')) {
                    $inputDepth3.prop('checked', true);
                    // $inputDepth2.closest(depth2).removeClass('open')
                    // $inputDepth2.closest(depth2).next(depth3).hide();
                }
            } else {
                if (!$inputDepth2.hasClass('depEach')) {
                    $inputDepth3.prop('checked', false);
                }
            }
        } else {
            $inputDepth2.addClass('depEach');
            if (inputDepth3Length === inputDepth3ChkLength) {
                $inputDepth2.prop('checked', true);
            } else {
                $inputDepth2.prop('checked', false);
            }
            setTimeout(function(){
                $inputDepth2.removeClass('depEach');
            }, 200);
        }
    }

    $(depth2).find('.ico-arrow-open').on('click', function(e){
        if ($(this).closest(depth2).hasClass('open')) {
            $(this).closest(depth2).removeClass('open')
            $(this).closest(depth2).next(depth3).hide();
        } else {
            $(this).closest(depth2).addClass('open')
            $(this).closest(depth2).next(depth3).show();
        }
        openEvent()
    });
}

/**
 * @summary [data-scroll-anchor] 속성값 클릭시  data-anchor-target="" 값으로  스크롤  이동 
 */
export function scrolllAnchor(){
    $(document).on('click', '[data-scroll-anchor]', function(e){
        e.preventDefault();
        const anchorTarget = $(e.currentTarget).attr('data-scroll-anchor');
        const targetEl = $(`[data-anchor-target="${anchorTarget}"]`);
        if (targetEl.closest('.ui-accordion-list').length > 0 && !targetEl.closest('.ui-accordion-list').hasClass('open')) {
            targetEl.closest('.ui-accordion-list').find('.ui-accordion-btn').trigger('click');
        }

        // s: 2023-01-06 anchor 타깃이 화면에 일정이상 노출되었다면 스크롤하지 않음
        if (e.currentTarget.hasAttribute('data-anchor-visible') && targetEl.position().top < $(".component-header").height()) {
            return;
        }
        // e: 2023-01-06
        setTimeout(() => {
            scrollTo(targetEl);
        }, 150)
    })
}

/**
 * @summary 홈개편 내 신용정보 그래프 
 * @param {object} data  {id:'id', max:number, min:number, delay:number, reset:boolean}
 * @example
 * max: defalut -> document.querySelector(`#${data.id}`).getAttribute('stroke-dasharray').split(' ')[1]
 * min: defalut -> document.querySelector(`#${data.id}`).getAttribute('stroke-dasharray').split(' ')[0]
 * delay: defalut -> 0  : 그래프 처음 시작하는 delay 값
 * reset: 홈개편 신용정보 그래프에서 탭<->탭 이동시 사용   true일때 동작x ( 동작완료시  data-reset="true")
 * frontUI.svgGraph({id:$('.finding-credit-chart [data-id]').attr('data-id')})
 */
export function svgGraph (data) { 
    var _max = data.max == undefined ? document.querySelector(`#${data.id}`).getAttribute('stroke-dasharray').split(' ')[1] : data.max;
    var _min = data.min == undefined ? document.querySelector(`#${data.id}`).getAttribute('stroke-dasharray').split(' ')[0] : _max * data.min / 100;
    var _val;
    var _duration;
    var _delay = data.delay == undefined ? 0 : data.delay;
    var timeOut01,timeOut02,timeOut03;
    if ($(`#${data.id}`).attr('data-value') == undefined) {
        _val = data.value
    } else {
        _val = $(`#${data.id}`).attr('data-value')
    }
    if ($(`#${data.id}`).attr('data-duration') == undefined) {
        _duration = 2000
    } else {
        _duration = Number($(`#${data.id}`).attr('data-duration'))
    }
    var _value = _max * _val / 100;
    if (data.reset == true || data.reset == 'true'){
        _value = 0;
    }
    var _keyframes = [
        {strokeDasharray: `${_min} ${_max}`},
        {strokeDasharray: `${_value} ${_max}`}
    ]
    // 'cubic-bezier(0.22, 0.95, 0.7, 1)' , $(`#${data.id}`).attr('data-easing')
    var _options = {
        duration : _duration,
        easing: data.easing == undefined ? 'linear' :data.easing ,
        fill:'forwards',
    }
    if ($(`#${data.id}`).attr('data-easing') != undefined) {
        _options.easing = $(`#${data.id}`).attr('data-easing')
    }
    if ($(`#${data.id}`).attr('data-type') == 'question') {
        _options.duration = _duration * 2;

        _keyframes = [
            {strokeDasharray: `0 ${_max}`},
            {strokeDasharray: `${_max} ${_max}`}
        ]
        setTimeout(()=>{
            if ($(`#${data.id}`).attr('svg-play') == 'true' || data.reset != undefined) {
                return false
            }
            document.querySelector(`#${data.id}`).animate(_keyframes,_options);
            timeOut01 = setTimeout(()=>{
            // $(`#${data.id}`).attr('svg-play', true)
                returnEvent()
            },_duration * 2)
        },_delay)
    } else {
        _options.duration = _duration
        // $(`#${data.id}`).attr('svg-defalut-play', true) 
        setTimeout(()=>{
            document.querySelector(`#${data.id}`).animate(_keyframes,_options);
        },_delay)
        
    }
    function returnEvent(){
        // if ($(`#${data.id}`).attr('svg-defalut-play') == 'true') {
        //     return false
        // }
        _keyframes = [
            {strokeDasharray: `${_max} ${_max}`},
            {strokeDasharray: `0 ${_max}`}
        ]
        _options.duration = _duration * 2;
        document.querySelector(`#${data.id}`).animate(_keyframes,_options);
        $(`#${data.id}`).attr('svg-play',true) 
    }
    // function step02(){
    //     if ($(`#${data.id}`).attr('svg-defalut-play') == 'true') {
    //         return false
    //     }
    //     _keyframes = [
    //         {strokeDasharray: `${_max} ${_max}`},
    //         {strokeDasharray: `0 ${_max}`}
    //     ]
    //     document.querySelector(`#${data.id}`).animate(_keyframes,_options);
    // }
}

/**
 * @summary 홈개편 내 신용정보 그래프 리셋
 * @param {string} rollingId 
 * @param {string} svgPathId 
 */
export function findingGraphReset(rollingId, svgPathId) {  
    $(rollingId).attr('num-reset',false)
    $(rollingId).find('[interset-num-short]').removeAttr('interest-num-type');
    $(rollingId).find('.number-rolling').removeClass('question');
    $(svgPathId).removeAttr('data-type');
    //$(svgPathId).attr('svg-defalut-play', true)
    frontUI.svgGraph({id:$(svgPathId).attr('data-id')})
}

/**
 * @summary progress 원형타입
 */ 
export function progressCircle(){
    if (!$('.progress-chart').length > 0) {
        return false
    }
    $('.progress-chart').each(function(idx,element){ // CHPFMTASK-781   240403 : bgColor 옵션 추가 및   kcb 타입 추가 
        const $wrap = $(element);
        const $bar = $wrap.find('.progress-bar')
        const barColor = $wrap.attr('bar-color');
        const bgColor = $wrap.attr('bg-color');
        let numValue = $wrap.find('.item-txt .num').text();
        let barColorValue;
        let bgColorValue;
        switch(barColor) {
            case 'blue':
                barColorValue = '#0150ff'
                break;
            case 'gray':
                barColorValue = '#7d7d7d'
                break;
            case 'navy':
                barColorValue = '#0114a7'  // kcb = 신용평가등급 이요 
                break;
            default:
                barColorValue = '#0150ff'
            break;
        }
        switch(bgColor) {
            case 'blue':
                bgColorValue = '#0150ff'
                break;
            case 'gray':
                bgColorValue = '#7d7d7d'
                break;
            default:
                bgColorValue = 'transparent'
            break;
        }
        if ($wrap.attr('data-type') == 'kcb') {
            barColorValue = '#EDF1F7';
            bgColorValue = '#0114a7';
            numValue = 100-numValue
        }
        $bar.css({
            background : `conic-gradient(${barColorValue} ${360/(100/numValue)}deg, ${bgColorValue} ${360/(100/numValue)}deg)`
        })
    })
}

/**
 * @summary .progress-group의 자식 요소중 .progress-value 의 stlye 값이 변경되면 옵저버 동작, 말풍선 위치 조정 
 */
export function progressPosition(){
    [...document.querySelectorAll('.progress-group')]?.forEach((prgGroup) => {
        let prgContentchk = prgGroup.querySelector('.progress-content');
        let prgContent = prgContentchk;

        // console.log('----------------------------------------');
        // console.log(prgContentchk);

        if(prgContentchk == null){
            prgContent = prgGroup.querySelector('.progress-bar');
        }
        // 가시성 관찰(viewport 진입시 한번만 실행되도록 수정) 

        callByObserver({

            target: prgGroup, 

            showFn: (target) => {
                const progressWrap = $(prgContent).closest('.progress-group')[0]
                // console.log(prgContent)

                const wEl = progressWrap.offsetWidth;

                const elVal = progressWrap.querySelector('.progress-value');

                // const wElVal = elVal.offsetWidth;

                const wElVal = !!elVal.style.width ? parseInt(elVal.style.width) : elVal.offsetWidth;

                const wElVal2 = (wEl * wElVal) / 100;

                const wElTooltip = prgContent.offsetWidth;

                const cPosTooltip = wElTooltip/2;

                const prDay = prgContent.querySelector('.progress-day');
                
                $(progressWrap).addClass('on', function(){
                    elVal.style.setProperty('width', `${wElVal}%`, 'important');
                });

                if(prDay != null){
                    const itemAfter = window.getComputedStyle(prDay, "::after");
                    if (wElVal2 > cPosTooltip && (wEl-wElVal2) > cPosTooltip) {

                        $(progressWrap).addClass('pos_center').removeClass('pos_right');
    
                        // [FETASK-890] 말풍선위치 수정
    
                        !!prgContent.style.marginLeft && (prgContent.style.marginLeft = '0px');
    
                    } else if ((wEl-wElVal2) < cPosTooltip) {
    
                        $(progressWrap).addClass('pos_right').removeClass('pos_center');
    
                        // [FETASK-890] 말풍선위치 수정
    
                        let right = parseInt(itemAfter.right); 
    
                        let width = parseInt(itemAfter.width)/2;
    
                        prgContent.style.marginLeft = `-${wElTooltip - (right + width)}px`;
    
                    } else {
    
                        $(progressWrap).removeClass('pos_center pos_right');
    
                        // [FETASK-890] 말풍선위치 수정
    
                        let left = parseInt(itemAfter.left);
    
                        let width = parseInt(itemAfter.width)/2;
    
                        prgContent.style.marginLeft = `-${left }px`;
    
                    } 
                    prgContent.style.setProperty('left', `${wElVal}%`, 'important');
                }

                prgContent.style.visibility = 'visible';

                
                if($(progressWrap).data('observer') !== undefined) return false;

                
                const observerBar = new MutationObserver((mutations) => {

                    mutations.forEach((mutation) => {

                        frontUI.progressPosition();

                    });

                });

                observerBar.observe(elVal, {attributes: true});

                

                $(progressWrap).data('observer', observerBar);

            }, 

            // hideFn: resetRolling

        });


    });

}

/**
 * @summary onclick="" 이벤트로 팝업을 오픈
 * @param {string} pop 
 * @example
 *  onclick="frontUI.openLyPop('.prd-view-pop02')"    .prd-view-pop02 -> <div class="ui-popup prd-view-pop02">
 */
export function openLyPop(pop){
    const isA11yCheck = isA11yCheckVersion();
    let targetEle = null;
    if(isA11yCheck){
        if(window?.event){
            targetEle = window?.event?.target
        }

        if(!$(pop).hasClass('none-virtual-closebtn')){ //A11YTASK-543 : 접근성대응 - class추가 (2025.05.13)
            const closeBtn = document.createElement('div');

            closeBtn?.setAttribute('role','button');
            closeBtn?.setAttribute('aria-hidden','false');
            closeBtn?.setAttribute('aria-label','팝업 닫기');
            closeBtn?.setAttribute('tabindex','0');

            closeBtn?.classList.add('close-btn');
            //closeBtn.classList.add('btn-popup-close');

            if($(pop).find('.interest-group-top')[0]){
                $(pop).find('.popup-content').parent().after(closeBtn);
            }else{
                if($(pop).find('.popup-content').length){
                    if($(pop).find('.popup-content').parent()?.length){
                        $(pop).find('.popup-content').parent().after(closeBtn);
                    }else{
                        $(pop).children().after(closeBtn);
                    }
                }else if($(pop).find('.title-group .title-field-popup').length){
                    if($(pop).find('.popup-content').parent()?.length){
                        $(pop).find('.popup-content').parent().after(closeBtn);
                    }else{
                        $(pop).children().after(closeBtn);
                    }
                }else if($(pop).find('.popup-group').length){
                    if($(pop).find('.popup-section')?.length){
                        $(pop).find('.popup-section').after(closeBtn);
                    }else{
                        $(pop).children().after(closeBtn);
                    }
                }else{
                    $(pop).after(closeBtn);
                }
            }

            $(closeBtn).off('click').on('click', (e) => {
                e.preventDefault();
                //e.stopPropagation();

                $(pop).data('ui').close();

                //팝업 회귀 타겟
                if(targetEle){
                    Popup.a11yDetctClosePopup();
                    $(targetEle)?.closest('[onclick]').focus();
                }
            });
        }
    }
        
    
    if ($(pop).length > 0) {
        if ($('.component-banner-feeling').length > 0) { // FPMDPT1300000200S 기분통장 팝업 오픈시 첫화면 로드
            $('.carousel-group .swiper-pagination-bullet:first').trigger('click')
        }

        $(pop).data('ui').closeSelector = targetEle;

        $(pop).closest('.popup-wrap').addClass('popActive');
        $(pop).data('ui').open();
        $(pop).data('ui').beforeCloseCallback(function(){
            $(pop).closest('.popup-wrap').removeClass('popActive');
            $(pop).data('ui').close();

            //팝업 회귀 타겟
            if(targetEle){
                Popup.a11yDetctClosePopup();
                $(targetEle)?.closest('[onclick]').focus();
            }
        });
        if ($(pop).find('.prd-pop-close').length > 0) {
            $(pop).find('.prd-pop-close').off('click.prdOff').on('click.prdOff', function(){
                $(pop).closest('.popup-wrap').removeClass('popActive');
                $(this).closest('.ui-popup').data('ui').close();

                //팝업 회귀 타겟
                if(targetEle){
                    Popup.a11yDetctClosePopup();
                    $(targetEle)?.closest('[onclick]').focus();
                }
            })
        }
    }
}

/**
 * @summary pc 디바이스 일때 조건에 따라 요소들의 position을 셋팅
 */
export function fixedCtaPosition(){
    const filter = 'win16|win32|win64|mac|macintel';
    let pcFlag = null;
    if(navigator.platform){
        if(filter.indexOf(navigator.platform.toLowerCase()) >= 0 && screen.width >= 699){
            pcFlag = true;
        } else {
            pcFlag = false;
        }
    }
    if (pcFlag === false && $('.fnclPdDetail').length > 0) {
		const _headerCheck = $('#header').find('.header');
        if( _headerCheck.hasClass('typeMweb')){
            $('.prd-detail-wrap').find('.mob_show').remove();
        }
        $('.prd-detail-wrap').find('.component-btn.fixed-bottom.only_m').show();
        $('.prd-detail-wrap').find('.component-btn.fixed-bottom.mobmweb_show').show();
    }
    let fixedCta, lastBox;
    if (pcFlag === true && $('.fnclPdDetail').length > 0 && $('.prd-detail-wrap').find('.component-btn.fixed-bottom.pc_show').length > 0) {
        fixedCta = $('.prd-detail-wrap').find('.component-btn.fixed-bottom.pc_show');
        lastBox = $('.prd-detail-wrap.txt-add');
        positionChange();
        $(window).off('scroll.prdScroll').on('scroll.prdScroll', function(){
            positionChange();
        });
    }
    if (pcFlag === true && $('.benefit-detail-wrap').length > 0 && $('.benefit-detail-wrap').find('.component-btn.fixed-bottom.pc_show').length > 0) {
        fixedCta = $('.benefit-detail-wrap').find('.component-btn.fixed-bottom.pc_show');
        lastBox = $('.benefit-detail-wrap').find('.component-text-simple.txt-add');
        positionChange();
        $(window).off('scroll.beneScroll').on('scroll.beneScroll', function(){
            positionChange();
        });
    }
    function positionChange(){
        const scrollNow = $(window).scrollTop();
        const changePoint = lastBox.offset().top;
        const fixedCtaMt = Number(fixedCta.css('margin-top').replace('px',''));
        if (scrollNow + $(window).innerHeight() - lastBox.innerHeight() - fixedCta.innerHeight() - fixedCtaMt >= changePoint) {
            if(!fixedCta.hasClass('noFixed')) {
                fixedCta.addClass('noFixed');
                fixedCta.css(
                    'position', 'relative'
                );
            }
        } else {
            if(fixedCta.hasClass('noFixed')) {
                fixedCta.removeClass('noFixed');
                fixedCta.css(
                    'position', ''
                )
            }
        }
    }
}

let roundTimerId = null;
/**
 * @summary 타겟 el 의 btn-refresh 요소의 값들 초기화
 * @param {jquery} el 
 */
export function fillReset(el){
    const circleItem = el.find('.fill-item');
    const totalLength = 2*Math.PI*Number(circleItem.attr('r'));
    if (roundTimerId !== null) {
        clearInterval(roundTimerId)
        roundTimerId = null;
    }

    circleItem.removeClass('active');
    circleItem.css({
      'stroke-dasharray': totalLength,
      'stroke-dashoffset': totalLength
    });
    el.find('.btn-refresh .txt').text('60초');
    const eventBind = fillActive.bind(el);
    el.find('.btn-refresh').off('click.fill').on('click.fill', eventBind);
}

/**
 * @summary 타겟 el 의 btn-refresh 요소에 클릭시 refresh 이벤트 바인딩
 * @param {jquery} el 
 */
export function fillActive(el){
    let fillTarget;
    if (typeof el.currentTarget !== 'undefined') {
        fillTarget = $(el.currentTarget).closest('[data-time-fill]');
    } else {
        fillTarget = el;
    }
    fillReset(fillTarget);
    setTimeout(() => {
        fillTarget.find('.fill-item').addClass('active');
        if (fillTarget.data('refreshFn') && $.isFunction(fillTarget.data('refreshFn'))) {
            fillTarget.data('refreshFn')();
        }
        let nowSec = 1;
        roundTimerId = setInterval(() => {
            let sec = nowSec++;
            if (60-sec < 0) {
                clearInterval(roundTimerId);
                fillActive(fillTarget);
            } else {
                fillTarget.find('.btn-refresh .txt').text(`${60-sec}초`);
            }
        }, 1000);
    }, 30);
}

/**
 * @summary 타겟 fillEl 의 data ui > refreshFn 객체에 콜백함수 추가
 * @param {jquery} fillEl 
 * @param {function} fn 
 */
export function fillRefresh(fillEl, fn) {
    fillEl.data('refreshFn', fn);
}

/**
 * @summary [data-calcAni] 선택자 사용  기분통장 캘린더 동작 이벤트 \
* data-calcAni 동작 데이터값 \
* data-calcAni-delay: 시작 시간 설정 \
* data-calcAni-s: 스타스 시간 yyyy.mm \
* data-calcAni-s: 엔드 시간  yyyy.mm
 */
export function calcAnimation(){
    const $this = $('[data-calcAni]');
    const _delay = $this.attr('data-calcAni-delay');
    const thisStartY = $this.attr('data-calcAni-s').split('.')[0];
    const thisStartM = $this.attr('data-calcAni-s').split('.')[1];
    const thisEndY = $this.attr('data-calcAni-e').split('.')[0];
    const thisEndM = $this.attr('data-calcAni-e').split('.')[1];
    const _html = `<div class="calcAni-wrap">
        <div class="calcAni-y-wrap" aria-hidden="true"></div>
        <div class="calcAni-mark" aria-hidden="true">. </div>
        <div class="calcAni-m-wrap" aria-hidden="true">
            <div class="calcAni-m"></div>
        </div>
        <div class="calcAni-date"></div>
    </div>`;
    $this.html(_html);
    $this.addClass('played')
    const $yearWrap = $this.find('.calcAni-y-wrap');
    const $monthWrap = $this.find('.calcAni-m-wrap');
    const $calcDate = $this.find('.calcAni-date');
    $calcDate.html(`${thisEndY}년 ${thisEndM}월`);
    let yearArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const _yearArr = yearArr.join(' ')
    for (var y = 0; y < thisStartY.split('').length; y++) {
        $yearWrap.append('<div class="calcAni-y" calcAni-start-num="' + thisStartY.split('')[y]+ '" calcAni-end-num="'+thisEndY.split('')[y]+'"  data-year'+(y+1)+'><div class="calcAni-y-item">'+_yearArr+'</div></div>');
    }
    let monthArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const _monthArr = [...monthArr.splice(monthArr.indexOf(thisEndM),monthArr.length),...monthArr.splice(0,monthArr.indexOf(thisStartM)), thisStartM]
    for (var m = 0; m < _monthArr.length; m++){
        $monthWrap.find('.calcAni-m').append('<div class="calcAni-m-item">'+_monthArr[m]+'</div>');
    }

    const $year = $yearWrap.find('.calcAni-y');
    const $month = $monthWrap.find('.calcAni-m');
    const _yearHeight = Number($year.css('line-height').replace('px', ''));
    const _monthHeight = Number($month.css('line-height').replace('px', ''));
    for(var i  = 0; i < $this.find('.calcAni-y').length; i++){
        $year.eq(i).css('margin-top', (Number($year.eq(i).attr('calcAni-start-num'))) * _yearHeight * -1 + 'px')
    }
    // for(var i  = 0; i < thisStartY.split('').length; i++){
    //     $year.eq(i)
    // }
    $month.css('margin-top', (_monthArr.length-1) * _monthHeight * -1 + 'px');
    let monthNum = _monthArr.length;
    let monthInterval;
    let year4Interval;
    // let conterCicle = false;

    function moveMonth(){
        $month.css('margin-top', (monthNum - 1) * _monthHeight * -1 + 'px');
        monthInterval = setInterval(() => {
            $month.css('margin-top', (monthNum-1) * _monthHeight * -1 + 'px');
            monthNum--
            if (monthNum  === _monthArr.indexOf('12')) {
                moveYear();
            } else if (monthNum === 0){
                clearInterval(monthInterval);
                setTimeout(()=>{
                    $month.css({
                        'transition': '',
                        marginTop : 0,
                    });
                    monthNum = _monthArr.length;
                },500)
            }
        }, 100)
    };
    function moveYear(){
        const $yere4 = $yearWrap.find('[data-year4]');
        let yere4Num = $yere4.attr('calcani-end-num');
        year4Interval = setInterval(() => {
            $yere4.css('margin-top', (Number(yere4Num)) * _yearHeight * -1 + 'px');
            clearInterval(year4Interval);
            $month.css('transition', '0.4s cubic-bezier(0.12, 0.78, 0.52, 1.3)');
        }, 120);
    }

    setTimeout(() => {
        $year.css('transition', '0.4s cubic-bezier(0.12, 0.78, 0.52, 1.2)');
        $month.css('transition', '0.4s cubic-bezier(0.12, 0.78, 0.52, 1.3)');
        moveMonth();
    }, _delay);
}

/**
 * @summary ui-ToggleRadio 요소의 data ui update
 */
export function asynFn() {
    if ($('.ui-ToggleRadio').length > 0) {
        $('.ui-ToggleRadio').each((idx,el)=>{
            $(el).data('ui').update();
        })
    }
}

/**
 * @summary icon-slide-prd 클래스 사용, 인피니트 로고 슬라이드 이벤트
 */
export function logoScrollLoop(){ 
    $(function(){
        if ($('.icon-slide-prd').length > 0) {
            // const dur = $('.icon-slide-prd').attr('logo-animation-speed') != undefined ? $('.icon-slide-prd').attr('logo-animation-speed') : 50
            const slidePrd = $('.icon-slide-prd'), speedAttr = 'logo-animation-speed';
            let dur = 50;
            if(slidePrd.attr(speedAttr) != undefined){
                //dur = slidePrd.attr(speedAttr),console.log('부모', dur);
            }else if(slidePrd.find(`[${speedAttr}]`).length > 0 && !slidePrd.find(`[${speedAttr}]`).hasClass('ico-item')){
                if(slidePrd.find(`[${speedAttr}]`).attr(speedAttr) != '') dur = slidePrd.find(`[${speedAttr}]`).attr(speedAttr),console.log('자식', dur);
            }
            const wrap = gsap.utils.wrap(0, 1);
            skeletonTabAnimation 
            $('.icon-slide-prd .logo-slide-box').each((idx, el) => {
                if ($(el).find('.logo-img-box').length > 1) {
                    $(el).find('.logo-img-box:not(:first)').remove();
                }
            });

            $('.icon-slide-prd .logo-img-box').each((idx, logoBox) => {
                let totalDistance,
                cloneItem = ($(logoBox.querySelectorAll('img')).length > 0) ? $(logoBox.querySelectorAll('img')) : $(logoBox.querySelectorAll('.ico-item'));
                if ($(logoBox.querySelectorAll('.logo-item')).length > 0) { // CHPFMTASK-1643 logo-item 추가
                    cloneItem = $(logoBox.querySelectorAll('.logo-item'));
                }
                if (!$(logoBox).hasClass('cloned')) { // 230706 중복실행시  클론이 중복 되어서 속도 빨라짐
                    $(logoBox).append(cloneItem.clone());
                    $(logoBox).addClass('cloned')
                }
                const items = logoBox.querySelectorAll('img');
                let anim;

                let dataZindex = $(logoBox).closest('.icon-slide-prd').attr('data-zindex-boost');

                let zIndex = dataZindex && dataZindex === 'false' ? false : true;

                let startPos;
                const draggable = new Draggable(logoBox, {
                    type: 'x',
                    trigger: logoBox,
                    throwProps: true,
                    cursor: 'default',
                    zIndexBoost: zIndex, 
                    onPressInit: function(){
                        anim.pause();
                        startPos = this.x;
                    },
                    onDrag: function(){
                        let prog = $(logoBox).hasClass('left') ? wrap(-this.x / totalDistance) : wrap(this.x / totalDistance)
                        anim.progress(prog);
                    },
                    onRelease: function(){
                        let prog = $(logoBox).hasClass('left') ? wrap(-this.x / totalDistance) : wrap(this.x / totalDistance)
                        anim.progress(prog);
                        
                        anim.play();
                        gsap.fromTo(anim, {timeScale:0}, {duration:0.2, timeScale:1, ease: "power1.in"})
                    },
                });
    
                function animInit(){
                    if (anim) anim.play(0);
                    totalDistance = $(logoBox).width() / 2;
                    const xPos = $(logoBox).hasClass('left') ? -totalDistance : totalDistance
                    anim = gsap.to(logoBox, {
                        duration: dur,
                        x : xPos,
                        ease: 'none',
                        repeat: -1,
                        overwrite: true,
                        cursor: 'default'
                    });
                }

                $(window).on('resize', animInit)
                animInit();
            })
        }
    })
}

/**
 * @summary 타겟 지정 로띠 애니메이션 실행
 * @param {string} aniTarget 
 * @param {string} aniPath 
 * @param {boolean} aniLoop 
 * @param {Number} speed 
 */
//front.lottieAnimation() ->  ui-lottie 변경으로  $(ui-lottie).data('ui') 형식으로 변경됨
export function lottieAnimation(aniTarget, aniPath, aniLoop, speed = 1){
	if( $('#' + aniTarget).length) {
        var lottieAnimation = bodymovin.loadAnimation({
            container: document.getElementById(aniTarget),
            path: aniPath,
            renderer: 'svg',
            loop: aniLoop,
            autoplay: true,
        });
        lottieAnimation.setSpeed(Number(speed));
    }
}

/** 
 * @summary ui-swiper [slide-tab-nav] 속성값 연동된  [slide-tab-nav="${name}"] > [slide-tab-item]의 접근성 대응
 * @param {string} name
 * @param {Number} index 
**/
export function tabSlide(name,index){
    if (name != undefined) {
        update(name,index);
    } else if ($('[slide-tab-nav]').length > 0) {
        $('[slide-tab-nav]')?.each((idx,el)=>{
            if(isA11yCheckVersion()){
                //접근성 대응
                // 초기 0 일때
                const isCheckMainNav = $(`[slide-tab-nav="${name}"]`).closest('.local-nav')?.length;

                let activeIndex = index || 0
                
                    $(el)?.find('[slide-tab-item]')
                    .find('.tab-link').attr('aria-selected','false')

                if(activeIndex === idx){
                    $(el)?.find('[slide-tab-item]')
                    .eq(idx)
                    .find('.tab-link')
                    .attr('aria-selected','false')
                    .append(`<span aria-hidden=${!!isCheckMainNav} style="font-size:0;">총 ${$(el).find('[slide-tab-item]')?.length}슬라이드 중 1번째 선택됨</span>`);
                }
            }else{
                //기존 소스
                // 초기 0 일때
            $(el).find('[slide-tab-item]').eq(0).addClass('active').append(`<span class="hide-txt">1번째 슬라이드 선택됨</span>`);
            }
        })
    }

	$(document).on('click', '[slide-tab-item] a, [slide-tab-item] button', (e) =>{
        e.preventDefault();
        const $this = $(e.target);
        const name = $this.closest('[slide-tab-nav]').attr('slide-tab-nav');
        const _tabIndex = $this.closest('[slide-tab-item]').index();
        const $slideList = $(`[slide-tab-list="${name}"]`); //swiper
        if (_tabIndex != index) {
            $slideList.data('ui').swiper.slideTo(_tabIndex)
        }
    })
    // Uiswiper 에서 가져오는 파라미터 (slide-tab-nav="name")  &&  (swiper.activeIndex = index)
    function update(name,index){ //탭 active
        if(isA11yCheckVersion()){
            //접근성
            const isCheckMainNav = $(`[slide-tab-nav="${name}"]`).closest('.local-nav')?.length;

            $(`[slide-tab-nav="${name}"]`).find('[slide-tab-item]').removeClass('active').find('span:not(".txt")').remove();
            $(`[slide-tab-nav="${name}"]`)
                .find('[slide-tab-item]')
                .eq(index)
                .addClass('active')
                .find('.tab-link')
                .attr({'aria-selected':'true'})
                .append(`<span aria-hidden=${!!isCheckMainNav} class="hide-txt" style="font-size:0;">총 ${$(`[slide-tab-nav="${name}"]`).find('[slide-tab-item]')?.length} 슬라이드 중 ${index+1}번째 선택됨</span>`);
        }else{
            //기존
            $(`[slide-tab-nav="${name}"]`).find('[slide-tab-item]').removeClass('active').find('.hide-txt').remove();
            $(`[slide-tab-nav="${name}"]`).find('[slide-tab-item]').eq(index).addClass('active').append(`<span class="hide-txt">${index+1}번째 슬라이드 선택됨</span>`);
        }
    }
}

/** 
 * @summary .data-checked-inp   change 이벤트로 [data-checked-cont] 속성 선택자 show / hide
**/
export function checkedShow() {
    const targetInp = 'data-checked-inp';
    
    if ($(`[${targetInp}]`).length > 0) {
        $(`[${targetInp}]`).each((idx, inp) => {
            const showBox = $(inp).attr(targetInp);
            boxDisplay($(inp).prop('checked'), showBox);
        });
    }

    $(`[${targetInp}]`).on('change customChange', function(e){
        const showBox = $(e.currentTarget).attr(targetInp);
        boxDisplay($(e.currentTarget).prop('checked'), showBox);
    });
    
    function boxDisplay(flag, box){
        if (flag) {
            $(`[data-checked-cont=${box}]`).show();
        } else {
            $(`[data-checked-cont=${box}]`).hide();
        }
    }
}

/**
 *  @summary SR-1962 추천탭 1.3 : 탭확장버튼 해상도별 노출 2022-10-05 \ 
 * update 2022-10-11 || 2022-12-14  main.ui.js ->  simple.ui.js
 */
export function tabMenuExtend(){
    var wtab = $('.component-tab.type-extend');
    function tabExtendActive(){
        wtab.each(function() {
            var scrollel = $(this).find('.tab-list-col')[0];
            var hasScrollEl = typeof scrollel != 'undefined' && scrollel != null;
            var wwin= $(this).width();

            if(hasScrollEl){
                wwin > scrollel.scrollWidth ? $(this).addClass('off') : $(this).removeClass('off');
            }
            var expendBtn = $(this).find('.btn-expend');
            expendBtn.off('click.tabExtend').on('click.tabExtend',function(){
                $(this).parent().toggleClass('extend');
            });
        });
    }
    if (wtab.length > 0) {
        tabExtendActive();
        $(window).on('resize',function() {
            clearTimeout(this.timeOutFunc);
            this.timeOutFunc = setTimeout(tabExtendActive, 200);
        });
    }
}

/** 
 * @summary .stamp-list-group  리스트안에  stamp-list 클릭 이벤트
**/
export function stampScrollList() {
    const stampList = $('.stamp-list-group');
    if(stampList.length > 0){
        stampList.each(function(idx,list){
            const cashBackNum = $(list).attr('cash-back-num'),
            getScrollSpeed = $(list).attr('scroll-speed'),
            getMultipleOf = $(list).attr('multiple-of'),
            itemsWrap = $(list).find('.stamp-list'),
            items = $(list).find('.stamp-list > li');
            let multipleOf = (getMultipleOf != undefined && getMultipleOf != '')  ? Number(getMultipleOf) : 3,
            scrollSpeed = (getScrollSpeed != undefined && getScrollSpeed != '')  ? Number(getScrollSpeed) : 400,
            multipleArr = [], timeOut = null;
            
            if(cashBackNum != undefined){
                if(cashBackNum != '') {
                    // resetItems();
                    for(let arraynum = multipleOf; arraynum < items.length; arraynum += multipleOf){multipleArr.push(arraynum);}
                    flipScroll(cashBackNum);
                }
            }

            items.off('click.checkstamp').on('click.checkstamp',function(e){
                e.preventDefault();
                const target = $(e.currentTarget);
                clearTimeout(keyframeid);
                if(!target.hasClass('finish')) flipAni(target);
            });

            function resetItems(){
                clearTimeout(timeOut);
                itemsWrap.stop().animate({scrollLeft:0},0);
                items.removeClass('finish');
                items.children(`button`).removeClass('active');
            }

            function activeItems(){
                items.each(function(idx,item){
                    if(idx < cashBackNum && !$(item).hasClass('finish')) $(item).addClass('finish');
                });
            }

            function flipAni(el){
                const flipArea = el.children(`button`);
                if(flipArea.length > 0){
                    frontUI.addKeyframeEl(flipArea, 1000, true);
                }
            }

            function flipScroll(value){
                const arrIndex = (el) => el > value;
                let multipleIndex = multipleArr.findIndex(arrIndex);
                if(multipleIndex == -1) multipleIndex = multipleArr.length-1;
                const chkIndex = multipleArr[multipleIndex];
                clearTimeout(timeOut);
                timeOut = setTimeout(()=>{
                    itemsWrap.stop().animate({scrollLeft:(itemsWrap.offset().left + itemsWrap.scrollLeft() + items.eq(chkIndex-1).offset().left) - (itemsWrap.width() / 2) + 25}, scrollSpeed);
                    activeItems();
                    flipAni(items.eq(chkIndex-1));
                },500);
            }
        });
    }
}

/**
 * @summary addKeyframeEl(target = html요소, time = 시간차, revert = 반대로설정) \
 * css keyframe이나 css transform 요소에 active 클래스 동적 토글하기위한 용도
 */
let keyframeid = null;
export function addKeyframeEl(target, time, revert, active) {
    let El = null, Time = 5, Active = 'active', Revert = false;
    for(let key in [...arguments]){
        if(typeof(arguments[key]) == 'number') Time = arguments[key];
        if(typeof(arguments[key]) == 'string') arguments[key].includes('#') || arguments[key].includes('.') ? El = $(arguments[key]) : Active = arguments[key];
        if(typeof(arguments[key]) == 'boolean') Revert = arguments[key];
    }
    if(!El) return;
    clearTimeout(keyframeid);
    (!Revert) ? El.removeClass(Active) : El.addClass(Active);
    keyframeid = setTimeout(()=>{
        El.outerWidth();
        (!Revert) ? El.addClass(Active) : El.removeClass(Active);
    },Time);
}

/** 
 * @summary [roll-y-num] 롤링  KeyframeEffect 이벤트 
**/
export function cashbackRolling() {
    const rollingWrap = document.querySelectorAll('[roll-y-num]');
    if(rollingWrap){
        rollingWrap.forEach((el)=>{
            const getNum = el.getAttribute('roll-y-num'),
            rollLength = el.children.length,
            chkVal = getNum <= rollLength && getNum !='' && getNum != 0,
            wrapHeight = Number(getComputedStyle(el.parentElement).height.replace('px','')).toFixed(2),
            rollHeight = (chkVal) ? wrapHeight * (rollLength - (getNum-1)) : wrapHeight * rollLength,
            rellEndContent = el.getAttribute('roll-y-content'), rollDelay = el.getAttribute('roll-y-delay'), 
            rollClone = el.getAttribute('roll-y-clone'), rollSpeed = el.getAttribute('roll-y-speed');
            let rollingAni = null, showEl= null, cloneNum = rollClone ? Number(rollClone) : 4;

            if(chkVal){
                if(rellEndContent) {
                    // console.log(rellEndContent);
                    // showEl = document.querySelector(rellEndContent);
                    // showEl?.classList.remove('show');
                    showEl = $(rellEndContent);
                    showEl?.removeClass('show');
                }

                console.log(wrapHeight)
                
                for(let i=0; i<cloneNum; i++){
                    [...el.children].forEach(item=>{
                        if(item.getAttribute('aria-hidden')) item.setAttribute('aria-hidden','true');
                        addClone(el,item);
                    });
                }

                rollingAni = new Animation(
                    new KeyframeEffect(
                        el,
                        [
                            {transform: `translateY(0)`},
                            {transform: `translateY(calc(-100% + ${rollHeight}px))`},
                        ],
                        {
                            duration:rollSpeed ? Number(rollSpeed) : 1500,
                            easing:'ease-in-out',
                            fill:'forwards',
                            delay: rollDelay ? rollDelay : '0'
                        }
                    )
                );
                
                rollingAni.play();
                rollingAni.onfinish = () =>{
                    [...el.children].forEach((item)=>{
                        if(item.classList.contains('clone')) item.remove();
                    });
                    [...el.children].forEach((item, index)=>{
                        if(index == getNum-1 && item.getAttribute('aria-hidden')) item.setAttribute('aria-hidden','false');
                    });

                    // removeEl('.top-gradient');
                    // removeEl('.bottom-gradient');
                    if(rellEndContent) {
                        // showEl?.classList.add('show');
                        showEl = $(rellEndContent);
                        showEl?.addClass('show');
                    }
                }

                function addClone(target,item){
                    if(!item.classList.contains('clone')){
                        target.append(item.cloneNode(true));
                        item.classList.add('clone');
                    }
                }

                function removeEl(target){
                    el.parentElement.querySelector(target)?.setAttribute('style','display:none;');
                }
            }
        });
    }
}

// keyframeChaining 변수들
let typingStack = [], keyframeStack = [], typingTimer = null;
/** 
 * @summary 순차적용 애니메니션 keyframe-chaining 클래스 사용 
 * @param {boolean} dir = 
**/
export function keyframeChaining(dir=false, typingheight=false) {
    const aniAttr = 'keyframe-chaining',
    aniTarget = document.querySelectorAll(`[${aniAttr}]`);
    let initSpeed = 400, aniArray = [], aniIndex = 0;
    if(dir) initSpeed = 0;
    if(aniTarget && aniTarget !=''){
        // console.log(keyframeStack, typingStack);
        if(keyframeStack.length > 0) keyframeStack.forEach((stack, index)=>{keyframeStack[index].cancel();});
        if(typingStack.length > 0) typingStack.forEach((typing, index)=>{clearInterval(typingStack[index]);});
        clearTimeout(typingTimer);
        keyframeStack = [];
        typingStack = [];
        
        aniTarget.forEach((item)=>{
            const getAttr = item.getAttribute(aniAttr);
            item.classList.remove('fade-out-hide');
            item.style.pointerEvents = 'none';
            if(getAttr == 'typing') {
                item.innerHTML = '';
                if(typingheight) {
                    const dummyEl = document.createElement('em'),
                    aniEl = document.createElement('em');
                    dummyEl.classList.add('dummy');
                    aniEl.classList.add('ani-txt');
                    item.append(dummyEl);
                    item.append(aniEl);
                    item.querySelector('.dummy').innerHTML = item.getAttribute('keyframe-text');
                    item.querySelector('.ani-txt').setAttribute('aria-hidden','true');
                }
            }
            aniArray.push(item);
        });
        if(aniArray.length > 0){
            addAnimation(aniArray[0], aniArray[0].getAttribute(aniAttr));
        }
    }

    function transformObj(target, name){
        const getSpeed = target.getAttribute('keyframe-speed'),
        getDelay = target.getAttribute('keyframe-delay'),
        delay = getDelay ? getDelay : 0; 
        let keyframes = null;
  
        if(name == 'fade-in') {
            keyframes = [
                {opacity: 0},
                {opacity: 1},
            ]
        } else if(name == 'fade-in-up') {
            keyframes = [
                {opacity: 0, transform: `translateY(100%)`},
                {opacity: 1, transform: `translateY(0)`},
            ]
        } else if(name == 'fade-in-down') {
            keyframes = [
                {opacity: 0, transform: `translateY(-100%)`},
                {opacity: 1, transform: `translateY(0)`},
            ]
        } else if(name == 'fade-in-left') {
            keyframes = [
                {opacity: 0, transform: `translateX(-50%)`},
                {opacity: 1, transform: `translateX(0)`},
            ]
        } else if(name == 'fade-in-right') {
            keyframes = [
                {opacity: 0, transform: `translateY(50%)`},
                {opacity: 1, transform: `translateY(0)`},
            ]
        } else if(name == 'fade-out') {
            keyframes = [
                {opacity: 1},
                {opacity: 0},
            ]
        }
      
        if(keyframes != null) initKeyframe();
        function initKeyframe(){
            let aniObj = new Animation(
                new KeyframeEffect(
                    target,
                    keyframes,
                    {
                        duration:getSpeed ? Number(getSpeed) : initSpeed,
                        easing:'ease-in-out',
                        fill:'forwards',
                        delay: delay
                    }
                )
            );
            keyframeStack.push(aniObj);
            aniObj.play();
            aniObj.onfinish = () =>{
                if(name == 'fade-out') {
                    target.parentElement.classList.add('fade-out-hide');
                    target.classList.add('fade-out-hide');
                }
                target.style.pointerEvents = 'auto';
                nextAnimation();
            }
        }
        return false;
    }

    function typingText(target){
        const txtAttr = target.getAttribute('keyframe-text'), txtString = txtAttr.replaceAll('<br>','\n'),
        getSpeed = target.getAttribute('keyframe-speed'),
        getDelay = target.getAttribute('keyframe-delay'),
        aniTarget = typingheight ? target.querySelector('.ani-txt') : target;
        let speed = getSpeed ? getSpeed : 40, 
        delay = getDelay ? getDelay : 0, txtIndex = 0;
        clearTimeout(typingTimer);
        if(dir){
            target.innerHTML = txtAttr;
            nextAnimation();
        }else{
            typingTimer = setTimeout(()=>{
                let timer = setInterval(typingEvent, speed);
                aniTarget.innerHTML = '';
                typingStack.push(timer);
                function typingEvent(){
                    let txtNow = txtString[txtIndex++];
                    aniTarget.innerHTML += txtNow === '\n' ? '<br>' : txtNow;
                    if(txtIndex >= txtString.length){
                        clearInterval(timer);
                        txtIndex = 0;
                        nextAnimation();
                    }
                }
            },delay);
        }
    }

    function nextAnimation(){
        aniIndex ++;
        if(aniArray[aniIndex]){
            addAnimation(aniArray[aniIndex], aniArray[aniIndex].getAttribute(aniAttr));
        }else{
            console.log('[keyframe-animation] next animation target none.');
        }
    }

    function addAnimation(target, name){
        if(target && name && name != ''){
            (name == 'typing') ? typingText(target) : transformObj(target, name);
        }
    }
}

//디데이 옵서버
let ddayObserver = null; 
/** 
 * @summary 디데이 계산 모션 [dday-num] 속성값 사용, MutationObserver 로 자동 동기화
**/
export function ddayTimer() {
    const timerEl = document.querySelectorAll('[dday-num]');
    if(!timerEl) return false;
    if(ddayObserver){
        ddayObserver.disconnect();
        timerEl?.forEach((item)=>{
            item.querySelector('.dday-text')?.remove();
            item.querySelector('.dummy')?.remove();
            item.closest('.number-box')?.classList.remove('active');
        });
    }
    timerEl?.forEach((item)=>{
        const textEl = document.createElement('div');
        textEl.classList.add('dday-text');
        item.append(textEl);
        item.querySelector('.dday-text').innerHTML = item.getAttribute('dday-num');
        item.closest('.number-box')?.classList.remove('active');
        changeNumber(item);
    });
    
    function changeNumber(el){
        const config = { 
            attributes: true,
            attributeOldValue: true,
        };

        ddayObserver = new MutationObserver((mutation) => {
            let { target } = mutation[0], dummyEl = document.createElement('div');
            target.closest('.number-box')?.classList.remove('active');
            target.removeEventListener('transitionend', tsEnd);
            target.addEventListener('transitionend', tsEnd);
            function tsEnd(){
                target.closest('.number-box')?.classList.remove('active');
                target.querySelector('.dummy')?.remove();
            }
            tsEnd();
            dummyEl.classList.add('dummy');
            target.append(dummyEl);
            target.querySelector('.dummy').innerHTML = mutation[0].oldValue;
            target.querySelector('.dday-text').innerText = target.getAttribute('dday-num');
            target.closest('.number-box').classList.add('active');
        });

        ddayObserver.observe(el, config);
    }
}

/** 
 * @summary cdn img 로드 애러시 /resource/img/mmk/common 로 경로 변경
**/
export function checkCdnimage(value){
    if(typeof(value) === 'object'){
        Object.keys(value).forEach((item)=>{
            const dummyImg = new Image(), target = document.querySelector(`[${item}]`);
            if(target){
                dummyImg.src = `${value[item]}`;
                dummyImg.addEventListener('load',(e)=>{
                    target.style.cssText = `background-image:url(${value[item]}); background-repeat: no-repeat;`;
                });
                dummyImg.addEventListener('error',(e)=>{
                    target.style.cssText = `background-image:url(${value[item].replace(value[item].substring(0, value[item].lastIndexOf('/')),'/resource/img/mmk/common')}); background-repeat: no-repeat;`;
                });
            }
        });
    }
}

// 당겨서 새로고침 타이머
let refreshDelayTimer = null, pullEndtime = null;
/** 
 * @summary 당겨서 새로고침 \
 * activeOffset = 로띠 노출과 refreshing 체크되는 수치, \
 * textOffset = 텍스트 노출되는 수치 \ 
 * delayOffset = refreshing 체크 후 되돌아가는 초기 수치, \
 * pullEndtime = refreshing 체크 후 최종 완료 까지의 딜레이
 * @param {element} target 스크롤되는 부모 엘리먼트 
 * @param {function} callback 완료시 콜백
 * @param {function} hapticCallback 로띠 노출과 refreshing 체크되는 시점에 콜백
**/
export function pullToRefresh(target, callback, hapticCallback){
    if(!target) return;
    const indicatorName = 'component-main-refresh', lottieName = `.${indicatorName} .refresh_twinkle`, indicatorEl = document.querySelector(`.${indicatorName}`);
    let startY = 0, refreshing = false, initialX = null, initialY = null, swipeDir='', 
    activeOffset = 96, textOffset = 24, delayOffset = 64, lastCallback = null;
    pullEndtime = (indicatorEl?.dataset?.resetDelay != undefined && indicatorEl?.dataset?.resetDelay != '') ? Number(indicatorEl?.dataset?.resetDelay) : 2000;
    
    if(!indicatorEl) return;

    refreshInit();
    
    function handleTouchStart (e){
        startY = e.touches[0].clientY;
        initTouch(e);
        (target.scrollTop <= 0) ? (removeTouchEvent() ,addTouchEvent()) : removeTouchEvent();
    }

    function handleTouchMove(e){
        const moveY = e.touches[0].clientY, pullDistane = (moveY - startY) / 2, lottieEl = $(lottieName);
        let pullingOffset = pullDistane;
        swipeDirection(e);
        if(swipeDir === 'bottom' || swipeDir === 'top'){
            if(indicatorEl?.dataset?.maxPull != undefined && indicatorEl?.dataset?.maxPull != '' && pullDistane >= Number(indicatorEl?.dataset?.maxPull)) pullingOffset = Number(indicatorEl?.dataset?.maxPull);
            if(pullDistane < 0) pullingOffset = 0;
            if(target.classList.contains('is-pulling') && target.scrollTop <= 0) pullingActive(indicatorEl, pullDistane, pullingOffset, textOffset, activeOffset);
            if(!refreshing && pullDistane > 0){
                target.classList.add('is-pulling');
                if(pullDistane >= activeOffset && target.scrollTop <= 0) {
                    if(lottieEl?.find('svg').length > 0) lottieEl.data('ui').play();
                    // console.log('로띠실행', hapticCallback);
                    if(hapticCallback && typeof(hapticCallback) == 'function') hapticCallback();
                    refreshing = true;
                }
            } 
        }
    }

    function handleTouchEnd(e){
        if(swipeDir === 'bottom' || swipeDir === 'top'){
            if(!target.classList.contains('is-pulling')) return;
            if(refreshDelayTimer) clearTimeout(refreshDelayTimer);
            const timer = new Promise((resolve) => setTimeout(resolve, 0)); // 터치 무브 끝날시 감도를 잡으려면 200정도의 Promise 필요
            timer.then(()=>{
                target.classList.remove('is-pulling');
                pullingReset(indicatorEl);
            });
        }
    }

    function pullingActive(target, distane, pulling, offset1, offset2){
        const pullingValue = pulling / 10, targrtOffset = (target.offsetHeight / 10) / 2;
        target.nextElementSibling.style.transform = `translateY(${pullingValue}rem)`;
        target.style.transform = `translate(-50%, calc((${pullingValue}rem / 2) - (${targrtOffset}rem)))`;
        if(pulling >= offset1){
            target.classList.remove('fadeout-text');
            target.classList.add('fadein-text');
        }
        if(pulling < offset1){
            target.classList.remove('fadein-text');
            target.classList.add('fadeout-text');
        }
        if(distane >= offset2){
            target.classList.remove('fadeout-bg');
            target.classList.add('fadein-bg');
        }
        if(distane < offset2){
            target.classList.remove('fadein-bg');
            target.classList.add('fadeout-bg');
        }
    }

    function pullingReset(target){
        const awaitOffset1 = delayOffset / 10, awaitOffset2 = awaitOffset1 / 2 + 0.2;
        if(refreshing){
                target.nextElementSibling.style.transform = `translateY(${awaitOffset1}rem)`;
                target.style.transform = `translate(-50%, -${awaitOffset2}rem)`;
                target.classList.remove('fadein-bg');
                target.classList.add('fadeout-bg');
                (hapticCallback && typeof(hapticCallback) == 'function') ? callback() : handleDelayAction();
        }else{
            endAction();
        }
    }

    function handleDelayAction(value, callback){
        if(value != undefined && typeof(value) === 'number') pullEndtime = value;
        if(callback && typeof(callback) == 'function') lastCallback = callback;
        indicatorEl.nextElementSibling.addEventListener('transitionend', delayAction);
    }

    function delayAction() {
        indicatorEl.nextElementSibling.removeEventListener('transitionend', delayAction);
        refreshDelayTimer = setTimeout(()=>{
            if(!hapticCallback && callback && typeof(callback) == 'function') callback();
            endAction();
        },pullEndtime);
    }

    function endAction(){
        const lottieEl = $(lottieName);
        if(lottieEl?.find('svg').length > 0) lottieEl.data('ui').stop();
        if(typeof(lastCallback) == 'function') lastCallback();
        indicatorEl.classList.remove('fadein-text');
        indicatorEl.classList.add('fadeout-text');
        indicatorEl.nextElementSibling.style.transform = `translateY(0rem)`;
        indicatorEl.style.transform = `translate(-50%, -7rem)`;
        refreshing = false;
    }

    function addTouchEvent(){
        target.addEventListener('touchmove',handleTouchMove);
        target.addEventListener('touchend',handleTouchEnd);
    }

    function removeTouchEvent(){
        target.removeEventListener('touchmove',handleTouchMove);
        target.removeEventListener('touchend',handleTouchEnd);
    }

    function refreshInit(){
        const lottieEl = $(lottieName);
        startY = 0;
        refreshing = false; 
        initialX = null;
        initialY = null; 
        swipeDir='';
        removeAllevents();
        target.addEventListener('touchstart',handleTouchStart);
        target.classList.remove('is-pulling');
        indicatorEl.classList.remove('fadeout-text','fadein-text','fadeout-bg','fadein-bg');
        indicatorEl.nextElementSibling.style.transform = `translateY(0rem)`;
        indicatorEl.style.transform = `translate(-50%, -7rem)`;
        if(lottieEl?.find('svg').length > 0) lottieEl.data('ui').stop();
        frontUI.refreshUI();
    }

    function removeAllevents(){
        if(refreshDelayTimer) clearTimeout(refreshDelayTimer);
        target.removeEventListener('touchstart',handleTouchStart);
        removeTouchEvent();
    }

    function initTouch(e){
        initialX = `${e.touches ? e.touches[0].clientX : e.clientX}`;
        initialY = `${e.touches ? e.touches[0].clientY : e.clientY}`;
    }

    function swipeDirection(e){
        if(initialX !== null && initialY !== null){
            const currentX = `${e.touches ? e.touches[0].clientX : e.clientX}`, currentY = `${e.touches ? e.touches[0].clientY : e.clientY}`;
            let diffX = initialX - currentX, diffY = initialY - currentY;
            Math.abs(diffX) > Math.abs(diffY) ? (0 < diffX ? swipeDir = 'left' : swipeDir = 'right'):(0 < diffY ? swipeDir = 'top' : swipeDir = 'bottom');
            initialX = null;
            initialY = null;
        }
    }

    return {
        reset(){
            refreshInit();
        },
        destory(){
            removeAllevents();
        },
        callendAction(){
            endAction();
        },
        callhandleDelay(value, callback){
            handleDelayAction(value, callback);
        }
    }
}

// 추천탭 변수
let tabTimer1=null, tabTimer2=null;
/** 
 * @summary SR-1962 추천탭 1.3 : 탭스크롤 기능 추가 2022-10-05 
**/
export function tabScrollnav() { // 2022-12-14  main.ui.js ->  simple.ui.js
    var $wtab = $('.component-tab.type-extend');
    $wtab.each(function(idx,el) {
        var $link = $(el).find('.tab-link');
        var $item = $(el).find('.tab-item');
        var tabArr = [];
        var tabOffset = [];
        var chkScroll = 0;
        var chkLength = 0;
        var chkScrollTarget = $(el).find('[scroll-content-target]');
        var chkScrollAttr = '', chkStickyClass = '';
        var componentTab = null, tabContent = null, resIndex = null, chkClick = false;
        var posArray = [], heightArray = [], headerGab = 0, scrollGab = 110, scrollSpeed = 300, notchGab = 0;
        var notchClass1 = 'ios', notchClass2 = 'statusExpension', chkNotch = $('html').hasClass(notchClass1) && $('html').hasClass(notchClass2);

        if ($(el).find('.local-nav').length > 0) {
            $item.each((idx,el)=>{
                tabArr.push($(window).scrollTop())
                //tabOffset.push($(el).find('.tab-link').offset().left + $(el).find('.tab-link').width())
            })
            $(el).find('.local-nav .tab-list-col').attr('scrollPosition', tabArr)
            //$(el).find('.local-nav .tab-list-col').attr('offsetRight', tabOffset)
        }

        if(chkScrollTarget.length > 0 && chkScrollTarget.attr('scroll-content-target') != '') {
            chkScroll = 1;
            chkScrollAttr = chkScrollTarget.attr('scroll-content-target');
        }
        
        if(chkScroll == 1){
            if(chkNotch) notchGab = 50, console.log('ios && statusExpension');
            if(tabTimer1 != null || tabTimer2 != null){
                clearTimeout(tabTimer1);
                clearTimeout(tabTimer2);
            }
            tabTimer1 = setTimeout(()=>{
                const dataTabContnet = $(el).find('[data-tab-content]'), chkSticky = chkScrollTarget.attr('sticky-class');
                componentTab = chkScrollTarget.closest('.component-tab');
                //console.log(`sticky-obj =>`, componentTab);

                if(chkSticky != undefined && chkSticky.length > 0) {
                    chkStickyClass = chkSticky;
                    componentTab.addClass(chkStickyClass);
                    headerGab = Number(componentTab.css('top').replace('px',''));
                    scrollGab = (chkNotch)? scrollGab + headerGab : scrollGab + headerGab*2;
                    if(!chkSticky.match('move-up')) {
                        const setScgab = (scrollGab*2+10);
                        (chkNotch)? setScgab + headerGab : setScgab + headerGab*2;
                    }
                }
                
                if(dataTabContnet.length > 0) {
                    tabContent = $('body').find(`[tab-content-id="${dataTabContnet.attr('data-tab-content')}"]`).find('> .tab-content');
                }else{
                    let targetTab = ($(el).find('.ui-subTab').length > 0) ? '.ui-subTab' : '.ui-tab';
                    tabContent = $(el).find(targetTab).find('.tab-content');
                }
                
                tabContent?.css('display','block');

                if(tabContent?.length < $item.length) chkLength = 1;

                $(el).closest(`.${chkScrollAttr}`).off('scroll.targetTabScroll').on('scroll.targetTabScroll',function(e){
                    const scrollTarget = $(this);
                    (scrollTarget.scrollTop() > 0) ?  scrollTarget.addClass('scrolling') : scrollTarget.removeClass('scrolling');
                    if(chkClick == false){
                        if(scrollTarget.scrollTop() < (scrollTarget.scrollTop() + componentTab.offset().top) - scrollGab){
                            activeEvent($item.eq(0).find('.tab-link'));
                            resIndex = -1;
                        }
                        tabContent.each(function(index,el){
                            const startPos = scrollTarget.scrollTop() + $(el).offset().top - scrollGab,
                            endPos = startPos + $(el).height();
                            if(scrollTarget.scrollTop() > startPos && scrollTarget.scrollTop() < endPos){
                                if(index != resIndex) activeEvent($item.eq(index+chkLength).find('.tab-link'));
                                resIndex = index;
                            }
                        });
                    }
                });
            },300);
        }

        $link.off('click.tabScrollNav').on('click.tabScrollNav',function(e){
            // if ($(this).parent().hasClass('active')) {
            //     return false
            // }
            e.preventDefault();
            var $tabNav = $(this).closest('.tab-list-col');
            var left;
            if ($(this).closest('.ui-tab').attr('data-type') != 'home') { // 240529  홈개편 제외 추가 
                if ($(this).parents('.frm-prd').length > 0 || $(this).parents('.tab-item').attr('slide-tab-item')  != undefined) {
                    //$(this).closest('.page-inner-scroll').addClass('fixedBug')
                    if (!$(this).parent().hasClass('active')) {
                        $item.removeClass('active');
                        $(this).parent().addClass('active');
                        if ($(this).closest('.main-tab-content02').length != 1) {
                            if ($(this).offset().left + $(this).width() > $tabNav.width() / 1.8) {
                                left = $tabNav.find('.tab-item:last').offset().left+$(this).width()+ $tabNav.scrollLeft();
                                $tabNav.stop().animate({scrollLeft: left},300);
                            } else {
                                tabTimer2 = setTimeout(()=>{
                                    $tabNav.stop().animate({scrollLeft: 0},300);
                                },5)
                            }
                            frontUI.tabScrollnavLine($(this).closest('.tab-list-col').attr('slide-tab-nav'));
                            //frontUI.removeFixedBugClass();
                        }
                    }
                } else {
                    activeEvent($(this));
                }
            }

            if(chkScroll == 1){
                activeScroll($(this));
                chkClick = true;
                setTimeout(()=>{chkClick = false;},scrollSpeed);
            }
        });

        function activeScroll(target){
            let chkNum = (chkLength == 1)? 0 : -1, chkScrollGab = 0, value = $(el).closest(`.${chkScrollAttr}`).scrollTop() + tabContent.eq(target.parent().index()-chkLength).offset().top - notchGab;
            if($(el).find('.ui-expand').hasClass('open')){
                chkScrollGab = (chkNotch) ? scrollGab - (headerGab / 2) : scrollGab - headerGab
            }else{
                chkScrollGab = (scrollGab / 2);
            }
            (target.parent().index() == chkNum) ? gotoScroll(0) : gotoScroll(value - chkScrollGab);
        }

        function gotoScroll(value){
            $(el).closest(`.${chkScrollAttr}`).stop().animate({scrollTop:value},scrollSpeed);
        }

        function activeEvent(target){
            $item.removeClass('active');
            target.parent().addClass('active');
            var $scrolltab = $(el).find('.tab-round-group .tab-list-col');
            var left = target.parent().offset().left+ $scrolltab.scrollLeft()-22;
            if (target.parent().index() !== 0) {
                left = left - 30
            }
            $scrolltab.stop().animate({scrollLeft: left},300);
            // return false;
        }
    });
}

/**
 * @summary fixedBug 클래스를 가진 요소를 인자로 터치 이벤트로 동작
 */
export function removeFixedBugClass(){
    if ($('.fixedBug').length > 0) {
        $('.fixedBug').find('.carousel-group.ui-swiper').on('touchstart', function(){
            $(this).closest('.page-inner-scroll').removeClass('fixedBug')
        })
    }
}
/** 
 * @summary slide-tab-list의 스와이프 높이 체크
 * @param {element}	name	선택자
 * @param {number} index	슬라이드 인덱스
**/
export function swiperHeightCheck(name, index){
    if ($('[slide-tab-list="'+name+'"]').length > 0) {
        if ($(window).height() - $('.prd-list').outerHeight(true)  > $('[slide-tab-list="'+name+'"]').find('.swiper-slide').eq(index).outerHeight(true)) {
            $('[slide-tab-list="'+name+'"]').closest('.page-inner-scroll').css('overflow-y','hidden')
        } else{
            $('[slide-tab-list="'+name+'"]').closest('.page-inner-scroll').css('overflow-y','auto')
        }
    }
}

/** 
 * @summary slide-tab-list의 슬라이드 체인지 콜백 
 * @param {function}	callback	
**/
export function prdtSlideChange(callback){
    if ($.isFunction(callback)) {
        callback();
    } 
}

/** 
 * @param {string}	name	[slide-tab-nav="${name}"]
 * @param {number}	index   tab-item의 index 
**/
export function tabScrollnavLine(name,index) {
    if (name === undefined) {
        return
    }
    var $navWrap = $('.ui-tab-nav').find(`[slide-tab-nav="${name}"]`);
    if($navWrap.find('.tabline').length > 0){
        
        const _this = $navWrap.find('.tab-item.active');
        const tabLine = $navWrap.find('.tabline');
        var _left = 0
        var leftArr = [];
        var widthArr = [];
        $navWrap.find('.tab-item').each((idx,el)=>{
            leftArr.push($(el).outerWidth(true))
            widthArr.push($(el).outerWidth())
        })
        if (index != undefined){
            settingArr(true)
            tabLine.css({
                'width': widthArr[index] + 'px',
                'left' : _left +'px',
            });
        }else {
            settingArr(false)
            tabLine.stop().animate({
                'width': widthArr[_this.index()] + 'px',
                'left' : _left +'px',
            },200);
        }

        function settingArr(first){
            if (!first){
                index = _this.index();
            }
            if (index == 0) {
                _left = $navWrap.find('.tab-item:first').css('margin-left').replace('px','')
            } else {
                for (var i=0; i < index; i++) {
                    _left += leftArr[i]
                }
            }
            if (index === $navWrap.find('.tab-item').length - 1) {
                widthArr[index] = widthArr[index] - 20
            }
        }
    }
}

/** 
 * @summary pasteInfo param 롱탭 
 * 이체하기 계좌에서 롱탭시 적용 
 * @param {string}		bankname	은행이름 : ''
 * @param {number}		account		계좌번호 : ''
 * @param {number}		price		금액
 * @param {Object}		target		툴팁 적용될 부모창 (선택자)
 * @param {function}	callback	callback 함수
 * @param {function}	closeCallback	closeCallback 함수
 * @example
 *<div class="input-txt-group input-txt-trn no-input-label ui-input" data-hidden-cursor data-longtab="pasteInfo('#itx0001', '', '00000000000010', '붙여넣기', function(){console.log('콜백')} )">
 *   <input class="ui-text-del" type="text" id="itx0001" placeholder="계좌번호를 입력해주세요" title="계좌번호 입력" readonly maxlength="15">
 *   </div>
**/
export function pasteInfoTooltip(){
    // 롱탭 연결
    var _longtab = '[data-longtab] .ui-text-del';
    var pasteStartEvent = false;
    var longtabTimer;
    var _target;
    var _account;
    function pasteInfo(target, bankname, account, title,callback, closeCallback) {
        _target = target;
        _account = account;
        var _toastHtml = '';
        _toastHtml += `
        <div class="tooltip-focus-group paste-tooltip" aria-hidden="true" tabindex="-1">
            <div class="tooltip-area" data-paste-button="${target}">
                <div class="tooltip-box">
                    <div class="tooltip-content">
                        <span class="txt"> ${title}</span>
                    </div>
                </div>
            </div>
        </div>`
        $(`${target}`).parent().append(_toastHtml);

        $(document).on('click',`[data-paste-button="${target}"]` , function(e){
            e.stopPropagation()
            pasteAction()

            setTimeout(()=>{
                $('.paste-tooltip').stop().animate({
                    opacity:0
                }, ()=>{
                    $('.paste-tooltip').remove();
                })
                if(closeCallback){
                    closeCallback();
                }
            },50)
        });


        if(callback){
            callback();
        }
    }


    function pasteAction(e){
        $(`[data-output-target="${_target}"]`).data('ui').setValue(_account);
    }


    // LongTab Function
    function startLongTapTimer(_this) {
        var pasteInfoParm = $(_this).closest('[data-longtab]').attr('data-longtab');
        longtabTimer = setTimeout(function() {
            eval(pasteInfoParm)
            clearTimeout(longtabTimer)
        }, 1000);


    }
    function deleteLongTapTimer() {
        if( longtabTimer !== 'undefined' ) {
            clearTimeout(longtabTimer);
        }

    }
    function onStartLongTap(_this) {
        $(_this).addClass('active');
        startLongTapTimer(_this);

        pasteStartEvent = true;
    }
    function onMoveLongTap(e) {
        if( !pasteStartEvent ) {
            return;
        }
        deleteLongTapTimer();
    }
    function onEndLongTap(e) {
        if( !pasteStartEvent ) {
            return;
        }
        deleteLongTapTimer();
        pasteStartEvent = false;
    }


    $(document).off('touchstart._longtab').on('touchstart._longtab', _longtab,function(e) {
        onStartLongTap(this, e)
    });
    $(document).off('touchmove._longtab').on('touchmove._longtab', _longtab,function(e) {
        onMoveLongTap(this, e)
    });
    $(document).off('touchend._longtab').on('touchend._longtab', _longtab,function(e) {
        onEndLongTap(this, e)
    });


}
/**
 * @summary FPMPPY0200000100S.html 페이지 적용 현재 사용x \
 * onclick="frontUI.cardZoomEvent.zoomEvent(this)으로 사용했었음
 */
export const cardZoomEvent = { //FPMPPY0200000100S.html  페이지 사용
    zoomEvent : function (th) {
        $(th).closest('[data-zoom]').addClass('active-card-zoom');
        //$(`#${$(th).attr('data-zoom-btn')}`).focus();
        if ($('.component-text-simple').length > 0) {
            setTimeout(()=>{
                $(window).scrollTop(0);
                    // 높이값 임시 상태
                    if ($('html').hasClass('ios')) {
                        this.$el.closest('.page-inner-scroll').scrollTop($('.component-text-simple').offset().top);
                    } else {
                        this.$el.closest('.page-inner-scroll').scrollTop($('.component-text-simple').offset().top);
                    }
            },50);
        }
    },
    printName : function(th){
        $('[data-zoom-txt]').text($(th).val())
        $(th).val() != '' ? $('.eng-name-wrap').addClass('on') : $('.eng-name-wrap').removeClass('on');
    },
    printNameReset : function (){
        $('[printnameInput]').each((idx,el)=>{
            $(el).val('');
            setTimeout(() => {
                $(el).trigger('keyup')
            }, 10);
        })
    }
}

let chatBotTimer1, chatBotTimer2, chatBotTimer3, chatBotTimer4,chatBotTimer5, chatBotTimer6, chatBotTimer7, chatBotTimer8; // chatbotLooper 변수들
 /**
 * @summary [FETASK-434] 챗봇 자동 애니메이션 asis, tobe 요소가 조건으로 같이 있음 추후 asis 삭제 
 * btn-chatbot 요소에 속성값으로 삽입 \
 * data-loop-animation="{액션타입}{작동시간(초)},{액션타입}{작동시간(초)}"; 반복되는 액션 타입 및 시간 설정 \
 * data-loop-delay="{대기시간(초)}" 최초 실행 시 딜레이 타임 \
 * data-loop-stop 반복 정지(속성만 추가하면 됨)
 */
export const chatbotLooper = () => { // 2023-01-04
    
    let type = 'old'
    if (document.querySelectorAll(".chatbot-robot").length) {
        type = 'new'
    }
    if (type == 'old') {
        document.querySelectorAll("button.btn-chatbot").forEach((elem, i) => {
            if (elem.getAttribute('data-loop-animation')) {
                const loopAnimation = elem.getAttribute('data-loop-animation').split(",");
                const firstLoopDelay = elem.getAttribute('data-loop-delay') || 0;
    
                const doAnimation = (actions) => {
                    if (['ing', 'on'].reduce((p, c) => {
                        const isClass = [...elem.classList].indexOf(c) > -1;
                        if (isClass) {
                            elem.setAttribute('class', `btn-chatbot ${c}`);
                            return true;
                        } else return p;
                    }, elem.hasAttribute('data-loop-stop'))) return;
                    
                    const [action, sec] = actions[0].split('');
                    elem.style.animationPlayState = 'pause';
                    switch(action) {
                        case 'L': // 로고
                            elem.setAttribute('class', 'btn-chatbot');
                            break;
                        case 'I': // 문구노출
                            elem.setAttribute('class', 'btn-chatbot intro');
                            break;
                        case 'R': // 문구노출
                            elem.setAttribute('class', 'btn-chatbot intro2');
                            break;
                        case 'D': // ...
                            elem.setAttribute('class', 'btn-chatbot on-dot');
                            break;
                    }
                    elem.style.animationPlayState = 'play';
                    actions = actions.length > 1 ? [
                        ...actions.slice(1),
                        actions[0]
                    ] : actions;
                    setTimeout(() => {
                        doAnimation(actions);
                    }, sec * 1000);
                };
    
                setTimeout(() => {
                    doAnimation(loopAnimation);
                    
                    // elem.removeAttribute('data-loop-animation');
                    // elem.removeAttribute('data-loop-delay');
                    // elem.removeAttribute('data-loop-stop');
                }, firstLoopDelay * 1000);
            }
        });
    } else { // CHPFMTASK-1011
        document.querySelectorAll(".chatbot-robot").forEach((elem, i)=>{
            if (elem.getAttribute('data-loop-animation')) {
                const loopAnimation = $(elem).attr('data-loop-animation').split(",");
                const firstLoopDelay = $(elem).attr('data-loop-delay') || 0;
                const textGab = ($(elem).attr('data-text-gab') != undefined) ? Number($(elem).attr('data-text-gab')) : 13;

                const doAnimation = (actions) => {
                    const action = actions[0];
                    const sec1 = actions[1] == undefined ? 3 : actions[1];
                    const sec2 = actions[2] == undefined ? 3 : actions[2];
                    let activeWidth = 0;
                    $(elem).empty();
                    $(elem).closest('.chatbot-wrap').removeClass('chatbot-home');
                    clearTimeout(chatBotTimer1);clearTimeout(chatBotTimer2);clearTimeout(chatBotTimer3);clearTimeout(chatBotTimer4);clearTimeout(chatBotTimer5);
                    switch(action) {
                        case 'D': // 디폴트
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-default');
                            $(elem).append(`<i class="chatbot_wink ui-lottie" data-filename="chatbot_wink" aria-hidden="true"></i><span class="txt">상담</span>`)
                            activeWidth = 0
                            break;
                        case 'I': // 상담중
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-default');
                            $(elem).append(`<div class="dot-flashing-new type2" aria-hidden="true">
                            <span class="dot dot1"></span>
                            <span class="dot dot2"></span>
                            <span class="dot dot3"></span>
                          </div>
                          <span class="hide-txt">상담중</span>`)
                          activeWidth = 0
                            break;
                        case 'H': // 개편홈
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-home');
                            $(elem).append(`<i class="chatbot_wink ui-lottie" data-filename="chatbot_wink" data-auto="false" aria-hidden="true"></i>
                            <span class="txt"><span>${$(elem).attr('data-chatbot-text') == undefined ? '쉽고 빠른 챗봇상담' : $(elem).attr('data-chatbot-text')}</span></span>`);
                            $(elem).closest('.chatbot-wrap').addClass('chatbot-home');
                            chatBotTimer6 = setTimeout(()=>{
                                const textMaxLength = 20, getText = $(elem).find('.txt > span').text();
                                if ($(elem).attr('data-chatbot-text')  != undefined) {
                                    if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                }
                                // if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                activeWidth = $(elem).find('.txt > span').width() + textGab;
                            },10);
                            break;
                        case 'F': // 상담 종료 
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-counsel finish');
                            $(elem).append(`<i class="chatbot_wink ui-lottie" data-filename="chatbot_wink" data-auto="false" aria-hidden="true"></i>
                            <span class="txt"><span>${$(elem).attr('data-chatbot-text') == undefined ? '상담이 종료되었습니다' : $(elem).attr('data-chatbot-text')}</span></span>`);
                            clearTimeout(chatBotTimer7)
                            chatBotTimer7 = setTimeout(()=>{
                                const textMaxLength = 20, getText = $(elem).find('.txt > span').text();
                                if ($(elem).attr('data-chatbot-text')  != undefined) {
                                    if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                }
                                // if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                activeWidth = $(elem).find('.txt > span').width() + textGab;
                            },10);
                            break;
                        case 'C': // 1분후 상담 종료 
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-counsel');
                            $(elem).append(`
                            <div class="dot-flashing-new type2" aria-hidden="true">
                              <span class="dot dot1"></span>
                              <span class="dot dot2"></span>
                              <span class="dot dot3"></span>
                            </div>
                            <span class="hide-txt">상담중</span>
                            <span class="txt"><span>${$(elem).attr('data-chatbot-text') == undefined ? '1분 후 상담이 자동으로 종료됩니다' : $(elem).attr('data-chatbot-text')}</span></span>`);
                            clearTimeout(chatBotTimer8)
                            chatBotTimer8 = setTimeout(()=>{
                                const textMaxLength = 20, getText = $(elem).find('.txt > span').text();
                                if ($(elem).attr('data-chatbot-text')  != undefined) {
                                    if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                }
                                // if($(elem).attr('data-chatbot-text').length > textMaxLength) $(elem).find('.txt > span').text(getText.substr(0,textMaxLength)+'...');
                                activeWidth = $(elem).find('.txt > span').width() + textGab;
                            },10);
                            break;
                        case 'D': // ...
                            elem.setAttribute('class', 'chatbot-robot chatbot-robot-default');
                            $(elem).append(`<i class="chatbot_wink ui-lottie" data-filename="chatbot_wink" aria-hidden="true"></i><span class="txt">상담</span>`)
                            activeWidth = 0
                            break;
                    }
                    chatBotTimer1 = setTimeout(()=>{
                        frontUI.refreshUI();
                        chatBotTimer2 = setTimeout(() => {
                            if ($(elem).attr('data-loop-animation').split(",")[0] == 'I') {
                                return false;
                            }
                            chatbotAddAction(true);
                        }, firstLoopDelay * 1000);
                    },5)

                    function chatbotRemoveAction() {
                        
                        chatBotTimer3 = setTimeout(()=>{
                            if (action == 'D') {
                                chatBotTimer4 = setTimeout(() => {
                                    if ($(elem).find('.ui-lottie').length > 0) {
                                        $(elem).find('.ui-lottie').data('ui').play();
                                    }
                                }, 400);
                            }
                            $(elem).removeClass('active')
                            animateWidth();
                            chatbotAddAction(false)
                        },Number($(elem).attr('data-loop-animation').split(",")[1] == undefined ? 3 :$(elem).attr('data-loop-animation').split(",")[1]) * 1000)
                    }
                    function chatbotAddAction(first) {
                        if (first) {
                            if (action == 'D') {
                                if ($(elem).find('.ui-lottie').length > 0) {
                                    $(elem).find('.ui-lottie').data('ui').stop();
                                }
                            }
                            $(elem).addClass('active')
                            animateWidth();
                            if ( action == 'H') {
                                chatbotRemoveAction();
                            }
                        } else {
                            chatBotTimer5 = setTimeout(()=>{
                                if (action == 'D') {
                                    if ($(elem).find('.ui-lottie').length > 0) {
                                        $(elem).find('.ui-lottie').data('ui').stop();
                                    }
                                }
                                $(elem).addClass('active')
                                chatbotRemoveAction();
                                animateWidth();
                            },Number($(elem).attr('data-loop-animation').split(",")[2] == undefined ? 3 :$(elem).attr('data-loop-animation').split(",")[2]) * 1000)
                        }
                    }

                    function animateWidth(check){
                        
                        if (action == 'H' || action == 'F'|| action == 'C') {
                            if ($(elem).hasClass('active') ) {
                                $(elem).find('.txt').css('width',activeWidth)
                            } else {
                                $(elem).find('.txt').css('width',0)
                            }
                        }
                    }

                };

                doAnimation(loopAnimation);
            }
        })
    }
    


}

/**
 * @summary [ETASK-1271]
 * @summary [touch-animation] 속성값 사용
 */
export const touchAnimation = () => { // ETASK-1271 | 230809 추가
    if (!$('[touch-animation]').length > 0) {
        return false
    }
    let beforeX = 0, beforeY = 0;
    const wrap = document.querySelector('[touch-animation]')
    const effect = $(wrap).attr('touch-effect')
    const icon = $(wrap).attr('touch-icon')
    const duration = $(wrap).attr('touch-duration') == undefined ? 1000 : $(wrap).attr('touch-duration')
    $('[touch-animation]').on('click', function(e){
        if (!$('[touch-animation]').length > 0) {
            return false
        }
        
        const _html = `<div class="${effect} active" touch-animation-item=""><i class="${icon}"></i></div>`;
        $(this).append(_html)
        // const $item = $(this).find('[touch-animation-item]');
        // $item.removeClass('active')
        const rect = wrap.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        $(this).find(`.${effect}:last`).css({
            top : y +'px',
            left : x +'px',
        }).addClass('active')
        setTimeout(()=>{
            $(this).find(`.${effect}:first`).remove()
        },duration)
        beforeX = x;
        beforeY = y;
    })
}

/**
 * @summary Progress 애니메이션
 * @param {object} opt   const opt 안에 추가 옵션 필요시 사용 
 */
// s: Progress 애니메이션 2023-01-11
function animateProgress(opt = {}){
  const o = Object.assign({
      target: false,
      progressBar: false,
      minMax: [0, 100],
      defaultValue: 0,
      useComma: false,
      on: {
          initAfter: function(){},
          valueChanged: function(){},
      }
    }, opt);

  this.target = o.target;
  this.minMax = o.minMax;
  this.useComma = o.comma || false;
  this.progressBar = o.progressBar;
  this.initAfter = o.on.initAfter || function(){};
  this.valueChanged = o.on.valueChanged || function(){};
  this.defaultValue = o.defaultValue;


  this.setValue(o.defaultValue);
  this.init();
  return this;
};

animateProgress.prototype.init = function() {
  this.render();
  this.initAfter(this);
}
animateProgress.prototype.reset = function(){
    this.setValue(this.defaultValue);
}
animateProgress.prototype.render = function() {
    this.target.forEach((target) => {
        target.textContent = this._getPrintValue();
    });
    if (this.progressBar.length){
        this.progressBar.forEach((progressBar) => {
            progressBar.style.width = `${this._getValuePer()}%`;
        });    
    } 
}

animateProgress.prototype.setValue = function(val) {
  if (val < this.minMax[0]) this.value = this.minMax[0];
  else if (val > this.minMax[1]) this.value = this.minMax[1];
  else this.value = val;

  this.render();
  this.valueChanged(this.value, this);
}

animateProgress.prototype.animate = function(toValue, step) {
    if (this.value >= toValue) return;
    else {
      if (!step) step = Math.floor((toValue - this.value) * 0.03)
        let stepValue = this.value + Math.floor(Math.random() * step);
        this.setValue(stepValue > toValue ? toValue : stepValue);
        window.requestAnimationFrame(this.animate.bind(this, toValue, step));
    }
}

animateProgress.prototype._getPrintValue = function() {
    return this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
animateProgress.prototype._getValuePer = function() {
    return this.value / this.minMax[1] * 100;
}

export const AnimateProgress = animateProgress;
// e: Progress 애니메이션


/**
 * @summary Confetti
 * @param {element} target  컨페티 사용 부모요소 선택자
 * @param {object} opt   const option 안에 추가 옵션 필요시 사용 
 */
// s: Confetti 2023-01-11
export function Confetti(target, opt = {}) {
    
    const randomRange = (min, max) => Math.random() * (max - min) + min;
    const setCanvasSize = () => {
        canvas.style.position = 'absolute';
        canvas.style.top = option.top + 'px';
        canvas.style.left = option.left + 'px';
        canvas.style.zIndex = option.zIndex;
        canvas.width = option.width;
        canvas.height = option.height - option.top;
    }
    
    const canvasFrame = document.querySelector(target);

    const canvas = document.createElement('canvas');
    canvas.style.pointerEvents = 'none';
    const ctx = canvas.getContext('2d');

    const option = Object.assign({
        top: 0, left: 0,
        width: canvasFrame.clientWidth,
        height: canvasFrame.clientHeight,
        zIndex: 9999,
        count: 60,
        gravity: 1,
        velocity: 8,
        colors: [
            {front: '#0f0060', back: '#0a0046'},
            {front: '#c8f03e', back: '#a4c432'},
            {front: '#5163d1', back: '#404da7'},
            {front: '#7d7d7d', back: '#414141'},
            {front: '#69b405', back: '#538f04'},
            {front: '#0050ff', back: '#0447d8'},
        ],
        size: [8, 12],
        onComplete: function(){}
    }, opt);

    setCanvasSize();

    let confettiParticles = [];

    const initConfettiParticles = () => {

        for (let i = 0; i < option.count; i++) {
            confettiParticles.push({
                color: option.colors[Math.floor(randomRange(0, option.colors.length))],
                dimensions: {
                    x: randomRange(option.size[0], option.size[1]),
                    y: randomRange(option.size[0], option.size[1])
                },
                position: {
                    x: randomRange(-20, canvas.width + 20),
                    y: randomRange(-canvas.height, -20)
                },
                rotation: randomRange(0, 2 * Math.PI),
                scale: {x: 1, y: 1},
                velocity: {
                    x: randomRange(-2, 2),
                    y: randomRange(0, -25)
                }
            });
        }
        canvasFrame.appendChild(canvas);
    }
    
    const render = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        confettiParticles.forEach((confetto, index) => {
            let width = confetto.dimensions.x * confetto.scale.x;
            let height = confetto.dimensions.y * confetto.scale.y;

            ctx.translate(confetto.position.x, confetto.position.y);
            ctx.rotate(confetto.rotation);

            confetto.velocity.y = Math.min(confetto.velocity.y + option.gravity, option.velocity);
            // confetto.velocity.x += Math.random() * 0.5 ? Math.random() : -Math.random();

            confetto.position.x += confetto.velocity.x;
            confetto.position.y += confetto.velocity.y;

            if(confetto.position.y >= canvas.height) confettiParticles.splice(index, 1);

            if (confetto.position.x > canvas.width) confetto.position.x = 0;
            if (confetto.position.x < 0) confetto.position.x = canvas.width;

            confetto.scale.y = Math.cos(confetto.position.y * 0.1);
            ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;
            ctx.fillRect(-width / 2, -height / 2, width, height);

            ctx.setTransform(1, 0, 0, 1, 0, 0);
        });
        if (confettiParticles.length > 0) window.requestAnimationFrame(render);
        else{
            canvas.remove();
            if (typeof option.onComplete === 'function') option.onComplete();
        }
    }

    initConfettiParticles();
    render();
    

    return {
        terminate: function() {
            // 강제종료
            confettiParticles = [];
        }
    }
};
// e: Confetti

/**
 * @summary해당 영역에서 터치 무브 제거(스크롤 되지 않게)
 */
function removeTouchMoveAction(){
    $(".section-component-sticky").on("touchmove", function(){return false;});
}

// 사용하지 않음
function pageLoadKDS(){
    const urlParams = window.location.search.split('?').pop();
    if (urlParams.indexOf('a11y') > -1) {
        let strKey, strValue;
        let index = urlParams.indexOf('a11y');
        let selectedParams = urlParams.slice(index);

        index = selectedParams.indexOf('&');

        if(index > -1){
            selectedParams = selectedParams.slice(0, index);
        }

        strKey = selectedParams.split('=')[0];
        strValue = selectedParams.split('=')[1];

        if (strKey == 'a11y') {
            if (!$('body').hasClass(strKey)) {
                $('body').addClass(strKey).addClass(strValue);

                if ($('.et--component-menu-list').length > 0) {
                    $('.et--component-menu-list').find('a').each(function(idx,el){
                        $(el).attr('data-link',$(el).attr('href'))
                        $(el).attr('href','#none')
                        $(el).on('click', function(){
                            window.open(`${$(el).attr('data-link')}?a11y=a11y`);
                        })
                    })
                }
            }        
        }
    }
}

/**
 * @summary target 요소의 부모 page-inner-scroll 요소의 scrollTop을 0으로 만듬
 * @param {string} target 
 */
export function scrollToTop(target){
    if (target == undefined) {
        return false
    }
    let $target = $(`#${target}`).length > 0 ? $(`#${target}`) : $(`.${target}`) 
    $target.closest('.page-inner-scroll').stop().animate({
        scrollTop:0,
    },200)
}

/**
 * @summary [FETASK-1681] 셀렉트 팝업 선택된값이 있으면 btn-option.selected 위치로 스크롤 이동 
 * @param {element} target  .ui-popup 선택자
 * @param {nubmer} speed  defalut : 300
 */
export function selectScrollEvent (target, speed = 300) { // FETASK-1681
    const $wrap = typeof target == 'string' ? $(target) : target
    const $scroll = $wrap.find('.popup-content');
    const $target = $wrap.find('.btn-option.selected').parent();
    if (!$target.length>0 ) {
        return false;
    }
    //$scroll.stop().scrollTop($target.position().top)
    $scroll.stop().animate({scrollTop: $target.position().top}, speed)
}

/**
 * @summary popup zindex reset  초기값 150
 */
export function resetPopZindex(){ // popup zindex reset  초기값 150
    Popup.zIndex = 150;
    $('.ui-popup').closest('.popup-wrap').find('.dimm').removeAttr('style')
    $('.ui-popup').each(function(){
        $(this).removeAttr('style')
    })
}

/**
 *  @summary 숫자(금액) 을 3자리수 콤마로 표기
 *  @param {Number} 
 */
export function decimal(val){
    try {
        var parts = Number(val).toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] || parts.length === 2 ? "." + parts[1] : "");
    } catch (error) {
        return val
    }
}

/**
 *  @summary loader_spinner 아이디를 가진 요소를 인자로 동적으로 canvas를 그림
 */
export function fullSpinner(){
    let txt = '', darkmode = false;

    [...arguments].forEach(function(v){
      if (typeof v == 'boolean') {
        darkmode = v;
      } else {
        txt = v;
      }
    });

    
    if ($("#loader_spinner").length > 0) {
        $("#loader_spinner").remove();
    }
    const $componentLoader = $("<div></div>");
    $componentLoader.attr('id', 'loader_spinner');
    $componentLoader.addClass('component-loader');
    $componentLoader.css({
        position: "fixed",
        top: 0, left: 0, bottom: 0, right: 0,
        zIndex: 9999, margin: 0, padding: 0,
        display: "flex", justifyContent: "center", alignItems: "center",
        flexDirection: "column"
    });

    const canvas = document.createElement('canvas');

    const canvasSize = 40;

      canvas.style.animation = 'skeleton-loader .7s infinite linear';

      const ctx = canvas.getContext('2d');
      
      const deviceRatio = window.devicePixelRatio || 1;
      const backRatio = ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
      const ratio = deviceRatio / backRatio;

      canvas.style.width = canvasSize + 'px';
      canvas.style.height = canvasSize + 'px';

      canvas.width = ratio * canvasSize;
      canvas.height = ratio * canvasSize;

      ctx.scale(ratio, ratio);
      
      ctx.beginPath();
      let x = 20;
      let y = 20;
      let radius = 17;
      let startAngle = 0;
      let endAngel = Math.PI - (Math.PI * 0.3);

      ctx.strokeStyle = darkmode ? "#ffffff90" : "#E0E0E0";
      ctx.lineWidth = 6;
      ctx.lineCap = 'round';

      ctx.arc(x, y, radius, startAngle, endAngel, 1);

      ctx.stroke();

      $componentLoader.append(canvas);

      if (txt) {
          $componentLoader.append('<div class="txt" style="padding-top: 1.6rem;color: '+ (darkmode ? '#fff' : '#414141') +'">'+ txt +'</div>')
      }

      $("body").append($componentLoader);

      return {
          el: $componentLoader,
          close: function(){
              $componentLoader.fadeOut(function(){
                  $componentLoader.remove();
              });
          },
          next: function(func){
              if (typeof func == 'function') {
                  func(this.close);
              }
          }
      };
}

fullSpinner.checkShow = function(){
    return $("#loader_spinner").length ? true : false;
};

/**
 * @summary item-unregistered 클래스값 사용, 현재 사용하지 않는 함수
 */
export function unregisteredEvent(){
    if (!$('.item-unregistered').length > 0) {
        return false
    }
    // let startTime = [100, 800, 500] //delay
    // $('.item-unregistered').each(function(index) {
    //     setTimeout(function(index) {
    //     let unregistered = $('.item-unregistered').eq(index);
    //     unregistered.addClass('active') //카드 회전 애니메이션
    //     setTimeout(function(param1) {
    //         change(param1);
    //         setInterval(function(param2) {
    //         change(param2);
    //         }, 4000, param1); //4초동안 앞/뒤 2장
    //     }, 4000, index); //뒤 카드가 나오는 시점
    //     }, startTime[index], index);
    // });

    // function change(index) {
    //     let row = $('.item-unregistered').eq(index);
    //     row.append(row.find('i').eq(0)); //상단카드 하단이동 1
    //     row.append(row.find('i').eq(0)); //상단카드 하단이동 2
    // }
}

/**
 * @summary swiper 안에 어트리뷰트 cta-id, cta-end-text 값을 이용 cta버튼 클릭 이벤트
 * @param {number} index  index : defalut :0
 * @param {element} $swiper  ui-swiper 선택자
 */
export function actionCtaButton(index,$swiper){
    if (index == undefined) {
        index = 0;
    }
    let lastIndex = $swiper.$el.find('.swiper-slide').length - 1;
    if(lastIndex < 1){
        const ctaId = $swiper.$el.attr('cta-id'), ctaText = $swiper.$el.attr('cta-end-text');
        if(ctaId != undefined && ctaText != undefined) {
            $(`[cta-button="${ctaId}"] span`).text(ctaText);
            $(`[cta-button="${ctaId}"]`).attr('data-islast','true');
        }
    }

    $(document).off('click', `[cta-button="${$swiper.$el.attr('cta-id')}"]`).on('click', `[cta-button="${$swiper.$el.attr('cta-id')}"]`, function(e){
        const This = $(this);
        index = index+=1;
        if (index > lastIndex) {
            index = lastIndex;
            if(This.attr('end-close-popup') != undefined){
                const targetPopup = This.closest('.ui-popup').data('ui');
                if(targetPopup?.closeCallback) targetPopup?.closeCallback();
                targetPopup?.close();
            }
        }
        if ($swiper.$el.find('.swiper-slide').length > 1) {
            console.log('index,', index)
            $swiper.swiper?.slideTo(index)
        }
    })
}

/**
 * @summary rgb 값 hex 값으로 변경 
 * @param {string} rgb  'rgb(255,255,255)'
 * @returns {string}	result : #000
 */
export function rgb2hex (rgb){
    if (rgb.search('rgb') == -1){
        return rgb;
    } else {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
        function hex(x){
            return ('0'+parseInt(x).toString(16)).slice(-2);
        }
        return '#'+hex(rgb[1])+hex(rgb[2])+hex(rgb[3]);
    }
}

/**
 * @summary [FETASK-1198] 제휴신용카드 진입점 2단계 개선안
 * @summary [rotateCardEvent] 속성값 사용
 */
export function rotateCardEvent (){ //FETASK-1198  제휴신용카드 진입점 2단계 개선안
    if (!$('[rotateCardEvent]').length > 0){
        return false
    }
    $('.number-group2 li:first-child .section-link').addClass('animation')
    $('.number-group2 li:first-child .flip').addClass('active')
    setTimeout(()=>{
        $('.number-group2 li:first-child .section-link').removeClass('animation');
        eventInit()
    },2000)
    
      function eventInit() {
        $('.number-group2 .section-link').not('.animation')
        .on('touchstart', function(event) {
            $(this).addClass('active');
        })
        .on('touchend', function(event) {
            $(this).removeClass('active');
        });
      }
      eventInit();
}

/**
 * @summary [CHPFMTASK-689] 빙고 이벤트
 * @summary [bingo-wrap],[bingo-wrap],[bingo-button] 속성값 사용
 */
export function bingoSet() {  // CHPFMTASK-689 : 빙고이벤트
    if (!$('[bingo-wrap]').length > 0) {
        return false;
    }
    $('[bingo-wrap] [bingo-button]').each(function(idx, el) {
        $(el).attr('bingo-btn-index', idx);
        frontUI.bingoEvent({index:Number($(el).attr('bingo-btn-index'))})
    })
}

/**
 * @summary [CHPFMTASK-689] 빙고 이벤트 js  bingoSet()에서 실행
 */
export function bingoEvent(option={}) {  // CHPFMTASK-689 : 빙고이벤트
    if (!$('[bingo-wrap]').length > 0) {
        return false;
    }
    const bingoArr = [
        [0, 1, 2], //0 row1
        [3, 4, 5], //1 row2
        [6, 7, 8], //2 row3
        [0, 3, 6], //3 col1
        [1, 4, 7], //4 col2
        [2, 5, 8], //5 col3
        [0, 4, 8], //6 cross1
        [6, 4, 2], //7 cross2
    ]
    bingoArr.map(function(_bingoArr, mapIndex) {
        if (_bingoArr.indexOf(option.index) >= 0) {
            let trueLen = 0;
            for (var i = 0; i < bingoArr[mapIndex].length; i++) {
                if ($('[bingo-wrap] [bingo-item]').eq(bingoArr[mapIndex][i]).find('[bingo-button]').hasClass('active')) {
                    /*! s: FETASK-a11y 빙고 v.1.0.0 */
                    if(isA11yCheckVersion()){
                        $('[bingo-wrap] [bingo-item]').eq(bingoArr[mapIndex][i]).find('[bingo-button]').attr('aria-checked','true');
                    }
                    /*! e: FETASK-a11y 빙고 v.1.0.0 */
                trueLen++
                }
            }
            if (trueLen == 3) {
                for (var b = 0; b < bingoArr[mapIndex].length; b++) {
                $('[bingo-wrap] [bingo-item]').eq(bingoArr[mapIndex][b]).addClass('line')
                }
                $('[bingo-wrap]').addClass(`bingo-${bingoArr[mapIndex][0]+1}${bingoArr[mapIndex][2]+1}`)
                createLine(bingoArr[mapIndex][0], bingoArr[mapIndex][2], mapIndex);
                /*! s: FETASK-a11y 빙고 v.1.0.0 */
                if(isA11yCheckVersion()){
                    a11yDebounce(createA11yLiveText(bingoArr[mapIndex][0], bingoArr[mapIndex][2], mapIndex),500);
                }
                /*! e: FETASK-a11y 빙고 v.1.0.0 */
            }
        }
    })

    function createLine(_start, _end, arrIndex) {
        let arrCheck
        var lineClass = `${_start}to${_end}`;
        var $startBtn = $('[bingo-wrap] [bingo-item]').eq(_start).find('[bingo-button]');
        var $endBtn = $('[bingo-wrap] [bingo-item]').eq(_end).find('[bingo-button]');
        if (arrIndex <= 2) {
            arrCheck = 'row'
        } else if (arrIndex > 2 && arrIndex <= 5) {
            arrCheck = 'col'
        } else {
            arrCheck = 'cross'
        }
        if (!$('[bingo-wrap]').find(`.bingo-${lineClass}`).length > 0) {
            $('[bingo-wrap] [bingo-line]').append(`<div class="bingo-line bingo-${lineClass}"></div>`)
        }
        $('[bingo-wrap]').attr('bingo-line-len', $('[bingo-line]').find('.bingo-line').length)
    }

    function createA11yLiveText(_start, _end, arrIndex){
        //빙고 몇줄 완성됬는지 읽어주는 접근성 대응
        let directionText = '';
        if (arrIndex <= 2) {
            directionText = '가로'
        } else if (arrIndex > 2 && arrIndex <= 5) {
            directionText = '세로'
        } else {
            directionText = '대각선'
        }

        if(!$('.bingo-live')?.length){
            $('body').append('<div class="bingo-live" aria-live="polite" aria-relevant="additions text" aria-atomic="true" style="position:absolute;top:-99999px;left:-99999px;opacity:0;"></div>');
        }

        setTimeout(() => {
            const bingoLength = $('.bingo-item').length;

            $('.bingo-live').text(`빙고 총${(Math.sqrt(bingoLength) * 2) + 2}개 중 ${$('[bingo-line]').find('.bingo-line').length}줄 완성`);
        },500);
    }
}

export function isA11yBingo(){
    $('.bingo-box').attr('aria-hidden','true');

    $('.bingo-start-btn').on('click',() => {
        $('.bingo-box').removeAttr('aria-hidden');
        setTimeout(() => {
            $('.bingo-item').eq(0).find('button').focus();
        },500);
    });
}

/**
 * @summary 선택한 로띠 리플레이
 * @param {string} _this  로띠 선택자
 */
export function lottieReplay(_this){
    $(_this).data('ui').replay()
}

/**
 * @summary CHPFMTASK-1742 애니메이션용 함수 
 * @param {element} target [EX] target이 없으면 기본 '.money-mission'
 * @param {number}  gab 스크롤위치 오차 수정용 gab 
 */
 export function moneyMission(target,gab) {
    const htmlEl = document.querySelector('html'), 
    moneyMissionEl = (target) ? target.querySelector('.money-mission') : document.querySelector('.money-mission'),
    missionContainer = moneyMissionEl?.querySelector('.container-component'),
    missionHeader = moneyMissionEl?.querySelector('.component-header');
    if (moneyMissionEl === null) return;
    let iosGab = 0;
    // missionContainer.style.paddingTop = `${$(missionHeader)?.height()}px`;
    if(htmlEl.classList.contains('ios') || htmlEl.classList.contains('statusExpension')) {
        const iosPadding = Number(getComputedStyle(missionHeader).paddingTop.replace('px', ''));
        iosGab = iosPadding;
        // missionContainer.style.paddingTop = `${$(missionHeader)?.height() + iosGab}px`; // css 에서 제어
    }
    const missionTop = moneyMissionEl?.querySelector('.mission-top'),
    missionRolling = moneyMissionEl?.querySelector('.mission-rolling'),
    missionList = moneyMissionEl?.querySelector('.mission-list'),
    missionCard = missionRolling?.querySelector('.component-list.no-space'),
    missionGroup = missionRolling?.querySelector('.list-mission-group'),
    groupItem = missionGroup?.querySelectorAll('.list-item > a'),
    scrollGab = (gab != undefined ? gab : 3), //스크롤 되는 최종값 간격
    scrollValue = $(missionHeader)?.height() * 2 + missionTop.offsetHeight - scrollGab,
    scrollRef =  scrollValue - iosGab + iosGab,
    scrollSpeed = 500, //스크롤 스피드
    listAddclass1 = 'tooltip-open1',
    listAddclass2 = 'tooltip-open2';

    missionTop.style.top = `${missionHeader?.offsetHeight}px`;

    // 스크롤 이벤트 바인딩
    function missionScroll(e) {
        const attrKey = 'style',
        missionBg = moneyMissionEl.querySelector('.money-mission-background'),
        getfontSize = Number(getComputedStyle(document.body).fontSize.replace('px', '')) * 2;
        let getScrollTop = moneyMissionEl.scrollTop,
        diff = scrollRef - getScrollTop,
        move = (getScrollTop < 1) ? 0 : getScrollTop / getfontSize,
        setOpacity = Math.abs(diff / scrollRef);
        if(setOpacity < 0.01) setOpacity = 0;
        if(setOpacity > 1) setOpacity = 1;

        //if(moneyMissionEl.classList.contains('first-unlock-end')) missionList.classList.add(listAddclass2); CHPFMTASK-1742 수정(스크립트 삭제) 2025-02-21
        missionCard.setAttribute(attrKey, `opacity: ${setOpacity}; transform: translateY(${move}rem)`);
        
        if(getScrollTop >= scrollRef){
            missionTop.setAttribute(attrKey, `position:relative; top:${scrollValue}px`);
            missionBg?.setAttribute(attrKey, `opacity:0`);
            missionCard.setAttribute(attrKey, `opacity:0`);
            moneyMissionEl.classList.remove('scroll-down');
            moneyMissionEl.classList.add('scroll-top');
        }else{
            missionTop.setAttribute(attrKey, `position:sticky; top:${missionHeader?.offsetHeight}px`);
            missionBg?.setAttribute(attrKey, `opacity: ${setOpacity};`);
            moneyMissionEl.classList.remove('scroll-top');
            moneyMissionEl.classList.add('scroll-down');
        }
    }
    
    // 타겟스크롤 공용 함수
    function targetScroll(target, value, speed) {
      $(target)?.stop().animate({
        scrollTop: value
      }, speed ? speed : 0, function() {
        if ($(target).hasClass('first-unlock-entry')) {
          if ($(target).scrollTop() === 0) $(target).addClass('first-unlock-end');
        }
        if ($(target).hasClass('first-lock-entry')) {
            moneyMissionEl.classList.remove('scroll-down');
            moneyMissionEl.classList.add('scroll-top');
        }
      })
    };

    // 클래스 리셋
    function resetClass() {
      moneyMissionEl.classList.remove('first-unlock-entry', 'first-lock-entry', 'first-unlock-end');
      missionGroup.classList.remove('list-lock', 'list-unlock', 'list-click');
      missionList.classList.remove(listAddclass1, listAddclass2);
      missionGroup.querySelectorAll('.list-item').forEach((item) => {
        item.setAttribute('style', 'transition:none;')
      });
    }

    // 돈 모으기 전(부적 잠김 상태)
    async function beforeAction() {
      try {
        setInit('unlock');

        const timer1 = new Promise((resolve) => setTimeout(resolve, 400));
        await timer1;
        missionGroup.querySelectorAll('.list-item').forEach((item) => {
          item.setAttribute('style', '')
        });
        moneyMissionEl?.classList.add('first-lock-entry');

        const timer2 = new Promise((resolve) => setTimeout(resolve, 800));
        await timer2;
        targetScroll(moneyMissionEl, scrollRef, scrollSpeed);
      } catch (error) {
        throw new Error(error);
      }
    }

    // // 돈 모은 후(부적잠김 해제 상태)
    async function afterAction() {
      try {
        setInit('lock');

        const timer1 = new Promise((resolve) => setTimeout(resolve, 800));
        await timer1;
        targetScroll(moneyMissionEl, 0, scrollSpeed);

      } catch (error) {
        throw new Error(error);
      }
    }

    function setInit(value) {
        resetClass();
        if (value && value === 'lock') {
            missionGroup.classList.add('list-unlock');
            moneyMissionEl.classList.add('first-unlock-entry');
            targetScroll(moneyMissionEl, scrollRef);
        } else {
            missionGroup.classList.add('list-lock');
            targetScroll(moneyMissionEl, 0);
        }
        // click 이밴트 핸들러 주석처리   
        clickClasschinge();
    }

    function clickClasschinge() {
      missionGroup.classList.contains('list-lock') ? groupItemClick(listAddclass1) : groupItemClick(listAddclass2);

      function groupItemClick(value) {
        missionGroup.removeEventListener('click', clickAddClass);
        missionGroup.addEventListener('click', clickAddClass);

        function clickAddClass() {
          missionGroup.classList.add('list-click');
          missionList.classList.add(value);
        }
      }
    }

    moneyMissionEl.removeEventListener('scroll', missionScroll);
    moneyMissionEl.addEventListener('scroll', missionScroll);

    return {
      init(value) {
        value && value === 'lock' ? setInit('lock') : setInit('unlock');;
      },
      lockEntry() {
        beforeAction()
      },
      unlockEntry() {
        afterAction()
      }
    }
  }

/**
 * @summary 로띠 완료시 시간차 적용 순차 재생
 * @param {object} option option=[{target: css string (로띠 타겟 요소), \
 * addClassTarget: css string (로띠 타겟 재생 완료 후 addclass할 타겟), \
 * addClassName: string (로띠 타겟 재생 완료 후 addclass할 타겟의 클래스 name | 기본 active), \ 
 * delay: number (시작 딜레이) \
 * }]
 */
export function lottieChaining(option=[]){
    let index = 0;
    if(typeof option != 'object') return;
    for(let key in [...option]){
        const target = option[key]?.target ? option[key].target : null;
        if(target) $(target)?.data('ui')?.stop();
    }
    addChaining();

    function addChaining(){
        if(option[index] === undefined) return;
        const timer = new Promise((resolve) => setTimeout(resolve, option[index]?.delay ? option[index].delay : 0));
        timer.then(()=>{
            // console.log(index,' = 로띠시작');
            const target = option[index]?.target ? option[index].target : null;
            if(target && $(target).length > 0){
                $(target).data('ui').play();
                $(target).data('ui').completeCallbackAction(function() {
                    const addClassTarget = option[index].addClassTarget ? option[index].addClassTarget : null;
                    if(addClassTarget != null){
                    const addClassName = option[index].addClassName ? option[index].addClassName : 'active';
                    $(addClassTarget).addClass(addClassName);
                    }
                    // console.log(index,' = 로띠완료');
                    index++;
                    addChaining();
                });
            }
        });
    }
}

/**
 * @summary 스크롤 타겟 비교 클래스 추가 scrollAddClass(chktarget, addtarget, addcalss)
 * @param {string} chktarget = 스크롤 높이를 비교할 요소, \
 * @param {string} addtarget = 스크롤 높이를 비교해서 addClass 될 요소, \
 * @param {string} addcalss = addClass 될 클래스 명, \ 
 */
 export function scrollAddClass(chktarget, addtarget, addcalss){
    if(!chktarget) return;
    const scrollTarget = document.querySelectorAll('.page-inner-scroll');
    scrollTarget.forEach(el => {
        const chkTarget = el.querySelector(chktarget), addTarget = el.querySelector(addtarget),
        headerGab = (addTarget?.offsetHeight * 2) + Number(getComputedStyle(addTarget)?.paddingTop?.replace('px',''));
        $(el)?.off('scroll.scrollAddClass').on('scroll.scrollAddClass',(e)=>{
            if(e.target.scrollTop >= (chkTarget?.getBoundingClientRect().top + chkTarget?.offsetHeight) + headerGab){
                $(addTarget)?.addClass(addcalss);
                console.log(`${chktarget} 영역만큼 스크롤됨`);
            }else{
                $(addTarget)?.removeClass(addcalss);
                console.log(`${chktarget} 영역보다 작게 스크롤됨`);
            }
        });
    });
}

/**
 * @summary transformCalendar CHPFMTASK-2304 개발에서 사용할 함수
 * setFolding(value, speed) \ 
 * @param {string} value = (toogle : 토글, folding : 접기, unfolding : 펼치기) \ 
 * @param {number} speed 속도 설정, \
 * dateActive(event, value); \ 
 * @param {event} event = value값이 없으면 event.target \ 
 * @param {string} value = 원하는 날짜 설정 EX 2025-04-25 \
 * changeWeek(callback) \ 
 * @param {function} callback = 주가 바뀔때 마다 active된 week 요소의 인덱스를 콜백에 반환 \
 * stickyCallback(event,datecallback,endcallback) \  
 * @param {event} event \ 
 * @param {function} datecallback = 날짜 sticky 시점에 자신의 data-date 속성값을 콜백에 반환 함 \ 
 * @param {function} endcallback = 스크롤 멈췄을때 현재 sticky된 요소의 data-date 속성값을 콜백에 반환 \
 * clickScroll(event, value) \ 
 * @param {event} event = value값이 없으면 event.target \ 
 * @param {string} value = 원하는 날짜 설정 EX first or 2025-04-25 \
 */
export function transformCalendar(target){
    if(!target) return;

    const htmlEl = document.querySelector('html'), componentHeader = target.parentElement.querySelector('.component-header'), 
    targetPaddingTop = Number(getComputedStyle(target)?.paddingTop.replace('px','')),
    targetPaddingBottom = Number(getComputedStyle(target)?.paddingBottom.replace('px','')),
    targetPadding = targetPaddingTop + targetPaddingBottom,
    targetGrop = target.querySelector('.calendar-group'),
    container = target.nextElementSibling,
    tabRoundGroup = container?.querySelector('.tab-round-group'),
    tabGroupHeight = tabRoundGroup?.offsetHeight,
    investPaddingTop = Number(getComputedStyle(container.querySelectorAll('.invest-content')[1])?.paddingTop.replace('px','')),
    header = target.querySelector('.calendar-header'), 
    body = target.querySelector('.calendar-content'),
    week = target.querySelectorAll('.week-item'),
    weekMarginTop = Number(getComputedStyle(week[week.length-1])?.marginTop.replace('px','')),
    foldingHeight = header.offsetHeight + week[0].offsetHeight + (weekMarginTop),
    unfoldingHeight = header.offsetHeight + (week[0].offsetHeight * week.length) + (weekMarginTop * week.length - 1);

    let iosGab = 0;
    if(htmlEl.classList.contains('ios') || htmlEl.classList.contains('statusExpension')) iosGab = 44;

    let scrollGab = 110, scrollSpeed = 500, stickyGab = investPaddingTop > 0 ? investPaddingTop : 1 , currentstickyDate='', scrollTimer = null, scrollTimer2 = null, scrollTimer3 = null,
    stickyDate = null, transformVal = null, chkDate = null, foldingCheck = false, saveWeekY =[], scrollArray = [],
    foldingGab = (componentHeader.offsetHeight + foldingHeight + targetPadding) + iosGab, 
    unfoldingGab = (componentHeader.offsetHeight + unfoldingHeight + targetPadding) + iosGab;

    week.forEach((item , index)=>{scrollArray.push(item.offsetWidth * index);});

    // 랜더링시 스크롤 트리거 시킴
    // setTimeout(()=>{calendarClickScroll(null,'first');});

    container?.removeEventListener('transitionend', tsEnd);
    container?.addEventListener('transitionend', tsEnd);

    function setTransform(value, setspeed){
        const checkVal = value === 'folding' && value !== 'toogle', checkHorizontal = target.classList.contains('horizontal'), 
        speed = typeof(setspeed) === 'number' ? setspeed === 0 ? setspeed + .01 : setspeed : 0.8;
        transformVal = checkVal;
        clearTimeout(scrollTimer);
        clearTimeout(scrollTimer2);
        clearTimeout(scrollTimer3);
        if(!foldingCheck && checkVal && checkHorizontal && setspeed != 0 || !foldingCheck && !checkVal && !checkHorizontal && setspeed != 0) return;
        checkVal ? saveWeekY = [] : target.classList.remove('horizontal');
        foldingAction(checkVal, speed);
        foldingCheck = true;
    }

    function foldingAction(checkvale, speed){
        week.forEach((item , index)=>{
        let gab = 100, duration = speed / (week.length - 1), zIndex = 0, checkActive = item.classList.contains('active'), chkMarginTop = index > 0 ? weekMarginTop : 0;
        checkActive ? (gab = gab * index, duration = duration * index, zIndex = week.length) : (gab = gab * (index + 1), duration = duration * (index + 1), zIndex = index === 0 ? 0 : week.length - index);
        checkvale ? (
            saveWeekY.push(gab),
            item.setAttribute('style', `margin-top:0; transition: transform ${speed}s linear; transform: translateY(-${gab}%); transition-duration: ${duration}s; z-index:${zIndex};`)
        ) : (
            target.classList.remove('horizontal'),
            checkActive && body.setAttribute('style', `transition: none; transform: translateY(-${(week[index].offsetHeight + chkMarginTop) * index}px);`),
            item.setAttribute('style', `margin-top:${chkMarginTop}px; transform: translateY(0); transition-duration: 0s; z-index:1;`)
        );
        });

        setTimeout(()=>{!checkvale && body.setAttribute('style', `transition: transform ${speed}s linear; transform: translateY(0);`);});
        targetGrop.setAttribute('style', `transition: height ${speed}s linear; height: ${checkvale ? foldingHeight : unfoldingHeight}px;`);
        container?.setAttribute('style', `transition: padding-top ${speed}s linear; padding-top: ${checkvale ? foldingGab : unfoldingGab}px;`);
        tabRoundGroup?.setAttribute('style', `transition: top ${speed}s linear; top: ${checkvale ? foldingGab : unfoldingGab}px;`);
        container?.querySelectorAll('[data-date]')?.forEach((item)=>{item.setAttribute('style', `transition: top ${speed}s linear; top: ${checkvale ? foldingGab + tabGroupHeight : unfoldingGab + tabGroupHeight}px;`);});
    }

    function tsEnd(e){
        if(e.propertyName === 'padding-top') {
            transformVal && target.classList.add('horizontal'), foldingScroll();
            foldingCheck = false;
            // console.log(`transitionend`, transformVal ? '축소' : '확장');
        }
    }

    function foldingScroll(){
        if(transformVal){
            let activeIndex = 0;
            week.forEach((item , index)=>{
                if(item.classList.contains('active')) activeIndex = index;
                item.setAttribute('style', `transform: translateY(${0}%); transition-duration: ${0}s; z-index:${0}`);
            });
            body.scrollTo({top:0,left:week[activeIndex].offsetWidth * activeIndex,behavior:'smooth'});
        }
    }

    function foldingScrollCallback(callback){
        if(transformVal){
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(()=>{
            const findIdx = scrollArray.findIndex(item => item === body.scrollLeft); 
            if(findIdx != -1){
                week.forEach((item)=>{item.classList.remove('active');});
                week[findIdx].classList.add('active');
                callback && typeof(callback) === 'function' && callback(findIdx);
            }
        });
        }
    }

    function calendarClickScroll(event,setscrolldate){
        if(setscrolldate) stickyDate = null, chkDate = null;
        if(setscrolldate === 'first'){
            const scrollTarget = $(target).closest('.page-inner-scroll');
            scrollMove(scrollTarget,0);
            scrollTarget.trigger('scroll');
            return;
        }
        scrollcheck(event,setscrolldate);
    }

    function calendarStickyCallback(event,datecallback,endcallback){
        clearTimeout(scrollTimer2);
        clearTimeout(scrollTimer3);
        scrollTimer2 = setTimeout(()=>{
            scrollcheck(event,null,datecallback);
        });
        scrollTimer3 = setTimeout(()=>{
            endcallback && typeof(endcallback) === 'function' && endcallback(currentstickyDate);
            setDateActive(null,currentstickyDate);
        },200);
    }

    function scrollcheck(event,setscrolldate,datecallback){
        let $event = null, eventTargrt = null;
        if(event){
            $event = event, eventTargrt = $event.target;
            $event.preventDefault();
            $event.stopPropagation();
        }

        const scrollTarget = $(target).closest('.page-inner-scroll'), 
        topGab = scrollTarget.find('.component-header').innerHeight() + $(target).innerHeight() + scrollGab,
        targetDate = setscrolldate ? setscrolldate : eventTargrt.getAttribute('data-date'),
        scrollWrap = $(`.component-invest-calendar + .section-component.section-invest .ui-tab`);

        if(scrollWrap.length){
            const targetContent = scrollWrap.find('.ui-tab-content').eq(scrollWrap.data('ui')?.chkIndex),
            targetObj = targetDate === 'first' ? targetContent.find(`[data-date]:first-child`) : targetContent.find(`[data-date="${targetDate}"]`),
            targetObjAll = targetContent.find(`[data-date]`),
            firstDate = targetContent.find(`[data-date]:first-child`)?.attr('data-date');

            if(targetObjAll.length){
                targetObjAll.each((index,item)=>{
                    const $item = $(item), checkY = scrollPos(scrollTarget,$item,topGab), setY = index === 0 ? checkY : checkY - stickyGab;
                    if(scrollTarget.scrollTop() >= setY && scrollTarget.scrollTop() < setY + $item.closest('.invest-content').innerHeight()){
                        const dateAttr = $item.attr('data-date');
                        stickyDate != dateAttr && datecallback && typeof(datecallback) === 'function' && (datecallback(dateAttr), currentstickyDate = dateAttr);
                        stickyDate = dateAttr;
                    }
                });
            }
            
            if(firstDate && chkDate != targetDate && targetObj.length){
                targetObj.attr('data-date') === firstDate ? scrollMove(scrollTarget,0) : scrollMove(scrollTarget,scrollPos(scrollTarget,targetObj,topGab));
            }
        }
        chkDate = targetDate;
    }

    function scrollPos(target,obj,gab){
        const getOffset = obj.next('.component-card.invest')?.offset().top,
        pos = target.scrollTop() + (getOffset - gab);
        return pos;
    }

    function scrollMove(target,value) {
        target.stop().animate({scrollTop:value},scrollSpeed);
    }

    function setDateActive(event,value){
        let activeTarget = null;
        document.querySelectorAll('.week-item .day')?.forEach((item)=>{item.classList?.remove('active');});
        value ? target.querySelector(`.week-item .day[data-date="${value}"]`).classList.add('active') : event?.target?.classList.add('active');
    }

    return {
        setFolding(value, setspeed){
            value && value === 'toogle' ? !target.classList.contains('horizontal') ? setTransform('folding', setspeed) : setTransform('unfolding', setspeed) :
            value && value === 'folding' && setTransform('folding', setspeed), value && value === 'unfolding' && setTransform('unfolding', setspeed)
        },
        changeWeek(callback){
            foldingScrollCallback(callback);
        },
        clickScroll(event,setscrolldate){
            calendarClickScroll(event,setscrolldate);
        },
        stickyCallback(event,datecallback,endcallback){
            calendarStickyCallback(event,datecallback,endcallback);
        },
        dateActive(event,value){
            setDateActive(event,value);
        }
    }
}

// 복권긁기 타이머
let lottoTimer = null;
/**
 * @summary 복권 긁기 이벤트
 * @param {element} _id  canvas 선택자
 * @param {object} option  option={init:boolean, callback: Fn, beforeCallback: Fn }
 * @example
 * frontUI.lotteryEvent('canvas', {
 *      drawingSize:20,
 *      finishDrawing:50,
 *     'beforeCallback': function() {
 *       console.log('이전콜백')
 *     },
 *     'callback': function() {
            console.log('콜백')
        }
 * })
 */
export function lotteryEvent(_id, option ={}) {
    
    const canvas = (typeof _id === 'string') ? document.getElementById('lottery') : _id.querySelector('#lottery');
    if(!canvas) return;
    canvas.style.display = 'block';

    let ctx = canvas.getContext('2d')
    let width = canvas.width;
    let height = canvas.height;
    let size = (option.drawingSize != undefined && option.drawingSize != '') ? Number(option.drawingSize) : 30;
    let reSize = size / (size / 10);
    let row = Math.ceil(height / (size + reSize));
    let column = Math.ceil(width / (size + reSize));
    let maxSize = row * column - reSize - 0.5;
    let maxValue  = (option.finishDrawing != undefined && option.finishDrawing != '') ? Number(option.finishDrawing) : 100;
    let inSideArr = [];
    let dataArr = [];
    let _image = new Image();
    let callbackChk = false;
    let startCallbackChk = false;
    let stopDrawing = false;
    let drawingValue = Number(0);
    let offsetX = 0.5;
    let offsetY = 0.5;
    let drawNum = 1;
    let scrollTarget = $(canvas).closest('.page-inner-scroll');
    if($(canvas).closest('.ui-popup').length > 0) scrollTarget =  $(canvas).closest('.ui-bottom').length > 0 ? $(canvas).closest('.popup-content') :  $(canvas).closest('.ui-popup');

    function render(){
        
        inSideArr = [];
        dataArr = [];
        callbackChk = false;
        startCallbackChk = false;
        stopDrawing = false;
        drawingValue = Number(0);
        offsetX = 0.5;
        offsetY = 0.5;
        drawNum = 1;

        _image.src=canvas.getAttribute('backgroundSrc')
        canvas.setAttribute('init',option.init)
        function drawImageProp (ctx, img, x, y, w, h, offsetX, offsetY) {
            if (arguments.length === 2) {
                x = y = 0;
                w = ctx.canvas.width;
                h = ctx.canvas.height;
            }

            offsetX = typeof offsetX === "number" ? offsetX : 0.5;
            offsetY = typeof offsetY === "number" ? offsetY : 0.5;

            if (offsetX < 0) offsetX = 0;
            if (offsetY < 0) offsetY = 0;
            if (offsetX > 1) offsetX = 1;
            if (offsetY < 1) offsetY = 1;

            let iw = img.width,
                ih = img.height,
                r = Math.min(w/iw, h/ih),
                nw = iw * r,
                nh = ih *r,
                cx,cy ,cw,ch,ar = 1;
            
            if (nw < w) ar = w/ nw;
            if (Math.abs(ar-1) < 1e-14 && nh < h) ar = h / nh;
            nw *= ar;
            nh *= ar;

            cw = iw / (nw / w);
            ch = ih / (nh / h);

            cx = (iw - cw) * offsetX;
            cy = (ih - ch) * offsetY;

            if (cx < 0) cx = 0;
            if (cy <0) cy = 0;
            if (cw > iw) cw = iw;
            if (ch > ih) ch = ih;

            ctx.drawImage(img, cx, cy,cw,ch,x,y,w,h)
        }

        _image.onload = ()=>{
            drawImageProp(ctx,_image, 0,0,width,height,offsetX,offsetY)
        }

        if(option.init == 'true'){
            canvas.addEventListener('click', function(e){
                if (option.beforeCallback && $.isFunction(option.beforeCallback) && e.target.getAttribute('init') == 'true'){
                    console.log('before callback')
                    //beforeCallbackChk = true;
                    option.beforeCallback();
                }
            });
            return false;
        }
        
        ctx.save();
        ctx.beginPath();
        ctx.setTransform(0,0,0,0,0,0);
        ctx.clearRect(0,0,width,height);
        ctx.rect(0,0,width,height);
        ctx.fillStyle = `rgba(255,255,255,0)`;
        ctx.fillRect(0,0,width,height);
        ctx.fill();
        ctx.closePath();
        ctx.restore();

        clearInterval(lottoTimer);
        canvas.parentElement.classList.remove('touch');
        canvas.parentElement.classList.remove('end');

        function drawVal(){
            (drawingValue >= maxValue) ? drawingValue = maxValue : drawingValue = Math.floor(inSideArr.length / maxSize * 100);
            canvas?.setAttribute('drawing-value', drawingValue);
        }
        drawVal();

        function _isInside(x1, y1){
            drawVal();     
            // 기존 inSideArr.length >= maxSize
            if (drawingValue >= maxValue){
                stopDrawing = true;
                clearInterval(lottoTimer);
                lottoTimer = setInterval(()=>{
                    if (drawNum<=0) {
                        clearInterval(lottoTimer);
                        ctx.save();
                        ctx.beginPath();
                        ctx.clearRect(0,0,width,height);
                        ctx.rect(0,0,width,height)
                        ctx.fillStyle = `rgba(0,0,0,0)`
                        ctx.fill();
                        ctx.closePath();
                        ctx.restore();

                        if (option.callback && $.isFunction(option.callback) && callbackChk == false){
                            console.log('lottery after callback')
                            callbackChk = true
                            option.callback();
                        }
                        canvas.parentElement.classList.remove('touch');
                        canvas.parentElement.classList.add('end');
                        console.log('복권긁기 완료');
                        lottoTimer = null;
                    }

                    dataArr.forEach(item =>{
                        ctx.save();
                        ctx.beginPath();
                        ctx.globalCompositeOperation = 'destination-out';
                        ctx.arc(item.x, item.y, size, (Math.PI/180)*0, (Math.PI/180)*360, false)
                        ctx.fill();
                        ctx.closePath();
                        ctx.restore();
                    })
                    drawNum -= 0.2;
                }, 30)
            }
            
            if (stopDrawing) return;

            let check = inSideArr.filter(arc => {
                let x = arc.x - x1;
                let y = arc.y - y1;
                let my_len = Math.sqrt(Math.abs(x*x) + Math.abs(y*y));
                return my_len < size
            })

            let json = {x : x1, y: y1, target: false};
            if (!check || check.length == 0) {
                json.target = true;
                inSideArr.push(json)
            }

            dataArr.push(json)

            return drawingValue;
        }

        function _drawing(_x, _y){
            ctx.save();
            ctx.beginPath();
            ctx.globalCompositeOperation = 'destination-out';
            ctx.arc(_x, _y, size, (Math.PI/180)*0, (Math.PI/180)*360, false)
            ctx.fill();
            ctx.closePath();
            ctx.restore();
        }

        if(option.beforeCallback && $.isFunction(option.beforeCallback) && option.init != 'true' && !option.init){
            canvas.setAttribute('before-init','true');
            canvas.addEventListener('click', function(e){
                console.log('before callback')
                option.beforeCallback();
                const timer = new Promise((resolve) => setTimeout(resolve, 100));
                timer.then(()=>{
                    handleaddEvents();
                });
            })
        }else{
            handleaddEvents();
        }
        
        function handleaddEvents() {
            let _eventNameS;
            let _eventNameM;
            let _eventNameE;
            var filter = 'win16|win32|win64|mac|macintel';
            if(navigator.platform){
                if(filter.indexOf(navigator.platform.toLowerCase()) < 0){
                    _eventNameS = 'touchstart'
                    _eventNameM = 'touchmove'
                    _eventNameE = 'touchend'
                } else if(screen.width < 699) {
                    _eventNameS = 'touchstart'
                    _eventNameM = 'touchmove'
                    _eventNameE = 'touchend'
                }else{
                    _eventNameS = 'click'
                    _eventNameM = 'mousemove'
                    _eventNameE = 'mousedown'
                }
            }
            let scrollTop, moveEventSetTime
            //const canvasOffsetTop = $(canvas.parentElement).offset().top;

            $(canvas).off(_eventNameS).on(_eventNameS,(e)=>{
                if(option.startCallback && $.isFunction(option.startCallback) && startCallbackChk == false){
                    option.startCallback();
                    startCallbackChk = true;
                }
                scrollTop = scrollTarget.scrollTop();
                // moveEventSetTime = setTimeout(()=>{
                //     if (Math.abs(scrollTop - $(canvas).closest('.page-inner-scroll').scrollTop()) < 30) {
                //         console.log('이벤트 시작')
                //         moveEvent();
                //     }
                // },200)
                scrollTarget.css('overflow-y', 'hidden');
                canvas.parentElement.classList.add('touch');
                // moveEvent();
            });

            $(canvas).off(_eventNameM).on(_eventNameM,(e)=>{
                stopDrawing = false;
                if(!ctx || stopDrawing) return;
                if(option.moveCallback && $.isFunction(option.moveCallback)) option.moveCallback();
                if (scrollTarget.length > 0 && scrollTarget.css('overflow-y') != 'hidden') {
                    scrollTarget.css('overflow-y', 'hidden')
                }
                let x1 =  (_eventNameM == 'touchmove' ? e.touches[0].clientX : e.clientX) - $(canvas.parentElement).offset().left
                let y1 = (_eventNameM == 'touchmove' ? e.touches[0].clientY : e.clientY) - $(canvas.parentElement).offset().top
                _isInside(x1,y1);
                _drawing(x1,y1);
            });

            $(canvas).off(_eventNameE).on(_eventNameE,(e)=>{
                clearTimeout(moveEventSetTime);
                if (scrollTarget.css('overflow-y') == 'hidden') {
                    setTimeout(()=>{
                        // inter = null;
                        stopDrawing = false;
                        scrollTarget.css('overflow-y', 'auto');
                        // console.log(ctx)
                    })
                }
            });
        }
    }

    render();

    return {
        reDraw : (arg) =>{
            clearInterval(lottoTimer);
            if (!lottoTimer) {
                ctx.save();
                ctx.beginPath();
                ctx.clearRect(0,0,width,height);
                ctx.rect(0,0,width,height);
                ctx.fillStyle = `rgba(0,0,0,0)`;
                ctx.fill();
                ctx.closePath();
                ctx.restore();
                stopDrawing = false;
                lottoTimer = null;
                inSideArr = inSideArr.filter((arg) => false);
                dataArr = dataArr.filter((arg)=> false);
            }
            if (arg && arg instanceof Function) {
                arg(stopDrawing);
            }
        },
        callback : (callbackFn)=>{
            if (callbackFn && $.isFunction(callbackFn)) {
                callbackFn(this);
            }
        },
        reset(){
            render();
        }
    }
}
/**
 * @summary 이미지 로딩 체크 이벤트
 * @param {element} imgSelector  이미지 선택자
 */
export function imgLoadingChk(imgSelector){
	return new Promise(function(resolve, reject){
		let total = imgSelector.length;
		return function f(image, new_arr){
			var imgArr = Array.prototype.slice.call(image);

			imgArr.forEach(function(img, index){
				//console.log('이미지 ' + index + ' - 반복문 시작');
				if(img.complete){
					//console.log('이미지 로드가 되었습니다.');
					new_arr.push({
						loaded: img.complete,
						width: img.clientWidth,
						height: img.clientHeight
					})
				}else{
					//console.log('이미지 로드가 실패했습니다.');
					$(img).on('load', function(){
						f([img], new_arr);
					}).on('error', function(){
						//console.log('이미지 로드 에러!');
					});
				}
				if(total === new_arr.length){
					//console.log('이미지 로딩완료');
					resolve(new_arr);
				}
			});
		}(imgSelector, []);
	});
}

/**
 * @summary [FETASK-1647] 퍼즐 드래그 동작 고도화 관련 작업 중 
 * @summary [data-puz-drag] 속성값이 있으면 드래그이벤트가 진행되어야 하는데 현재 click 이벤트로 진행
 */
export function puzzleEventDrag() {
    if (!$('[data-puz-drag]').length > 0) {
        return false
    }
    let $boxArr = []
    let _move = false;
    document.querySelectorAll('[data-puz-drag] .box-wrap .box').forEach(function(el,idx){
        $boxArr.push($(el))
        if($(el).find('span').attr('drag-top') != undefined){
            $(el).find('span').css({
                top :`${$(el).find('span').attr('drag-top')}px`,
                left : `${$(el).find('span').attr('drag-left')}px`,
                //transform : `rotate(${$(el).find('span').attr('drag-rotate')}deg)`,
            })
        }
    })

    $('[data-puz-drag] .box-wrap span').on('click', function(e){
        if ($(this).attr('drag-top') != undefined ) {
            _move = true;
        }
    })
    function getCurrentRotation(el){
        var st = window.getComputedStyle(el, null);
        var tm = st.getPropertyValue("-webkit-transform") ||
                 st.getPropertyValue("-moz-transform") ||
                 st.getPropertyValue("-ms-transform") ||
                 st.getPropertyValue("-o-transform") ||
                 st.getPropertyValue("transform") ||
                "none";
        if (tm != "none") {
          var values = tm.split('(')[1].split(')')[0].split(',');

          var angle = Math.round(Math.atan2(values[1], values[0]) * (180/Math.PI));
          return (angle < 0 ? angle + 360 : angle);
        }
        return 0
    }
    $('[puz-drag-item]').on('click', function(e){
        e.preventDefault();
        $(this).css({
            top : $(this).position().top + 'px',
            left : $(this).position().left + 'px',
            transform : 'rotate(0deg)'
        })
    })
}

/**
 * @summary [FETASK-1647] 퍼즐 이벤트 
 * @param {object} opt  opt={callback:function(){}}
 * @example
 * frontUI.puzzleEvent({callback:function(){}})
 */
export function puzzleEvent(opt={}){ // FETASK-1647 
    let lastIndex = 3;
    if (!$('[data-puz-event]').length > 0 || $('[data-puz-event]').attr('puzzle-step') == lastIndex) {
        return false
    }
    let _valueArr = [-1,1];
    let posArr = [40, 30, 5, 2];
    let rotateArr = [100, 50, 25,8];
    
    const $wrap = $('[data-puz-event]');
    if ($wrap.attr('puzzle-step') == undefined) {
        $wrap.attr('puzzle-step', 0)
    } else {
        $wrap.attr('puzzle-step', Number($wrap.attr('puzzle-step'))+1)
    }
    let _step = Number(checkStep())
    
    $wrap.find('.box span').each(function(idx,el){
        $(el).css({
            top: postionSet() * signSet(idx,'top') + 'px',
            left: postionSet() * signSet(idx,'left') + 'px',
            'transform' : rotateSet(el)
        })
    })

    if (_step == lastIndex) { // 마지막 콜백 실행
        setTimeout(() => {
            //frontUI.fadeAction(1); // 두번째 페이지로 이동
            if (opt.callback && $.isFunction(opt.callback)) {
                opt.callback();
            }
        },Number($wrap.find('span').css('transition-duration').replace('s',''))*1000 + 100);
    }
    function signSet(idx,pos){
        let _value
        switch (idx) {
            case 0:
                _value = pos == 'top' ? -1 : -1
                break;
            case 1:
                _value = pos == 'top' ? -1 : 1
                break;
            case 2:
                _value = pos == 'top' ? 1 : -1
                break;
            case 3:
                _value = pos == 'top' ? 1 : 1
                break;
            default:
                break;
        }
        return _value
    }

    // tooltip event
    const $tooltip = $wrap.find('.ui-tooltip');
    switch (_step) {
        case 0:
            $tooltip.find('.txt').text('휴대폰을 흔들거나 두번 탭하여 조각을 맞춰주세요')
            break;
        case 1:
            $tooltip.find('.txt').text('조금 더 흔들어주세요')
            break;
        case 2:
            $tooltip.find('.txt').text('거의 다 맞췄어요')
            break;
        case 3:
            $tooltip.stop().animate({
                top: '-25px',
                opacity : 0
            }, function(){
                $tooltip.css('display', 'none')
            })
            break;
        default:
            break;
    }
    //$tooltip.find('.txt').focus()
    function rotateSet(el){
        let _rotateValue
        if (_step == lastIndex ) {
            _rotateValue = `rotate(0deg)`
        } else {
            if ($(el).attr('rotate-pos') == undefined) {
                $(el).attr('rotate-pos', _valueArr[Math.floor(Math.random() * _valueArr.length)])
            }
            _rotateValue = `rotate(${Math.floor(Math.random() * (rotateArr[_step] - rotateArr[_step+1]) + rotateArr[_step+1]) * $(el).attr('rotate-pos')}deg)`
            // _rotateValue = `rotate(${Math.floor(Math.random() * (rotateArr[_step] - rotateArr[_step+1]) + rotateArr[_step+1]) * _valueArr[Math.floor(Math.random() * _valueArr.length)]}deg)`
        }
        return _rotateValue
    }
    function postionSet(){
        let _posValue
        if (_step == lastIndex ) {
            _posValue = 0
        } else {
            _posValue = Math.floor(Math.random() * (posArr[_step] - posArr[_step+1]) + posArr[_step+1])
        }
        return _posValue
    }
    function checkStep(){
        return $wrap.attr('puzzle-step')
    }
}
/**
 * @summary [FETASK-1499] Dimmed 영역 스크롤 방지
 * @param {boolean} flag  defalut : true
 */
export function preventScroll(flag = true){
    if($('html').hasClass('ios')) return false;

    const mainTabContents = $('.main-tab-content01, .main-tab-content02, .main-tab-content03, .main-tab-content04');
    if(!mainTabContents.length) return false;

    const tabContent = [...mainTabContents].filter(content => $(content).is(':visible'));
    if(tabContent.length){
        flag ? tabContent[0].classList.add('over-y-none') : tabContent[0].classList.remove('over-y-none');
    }             
}
/**
 * @summary [FETASK-1540] 약관상세 전체팝업내  버튼 스크롤 시 보이는 효과
 * @summary [data-hideopen] 속성의 위치가 스크롤이벤트로 인해 보이고 안보이고 설정
 * @param {element} popup  ui-popup 선택자
 * @example
 * frontUI.popupBotBtnHideOpen('#kbank-popup-PBKMAN1000003400S_P01')
 */
export function popupBotBtnHideOpen(popup){
    let $hideBtn, eventAct = false;
    if ($(popup).find('[data-hideopen]').length > 0) {
        $hideBtn = $(popup).find('[data-hideopen]');
        if ($(popup).find('.popup-group').height() > $(popup).height()) {
            setDisabled(true)
        }
        $(popup).on('scroll', function(){
            if ($(this).find('.popup-group').height() - $(this).height() <=  $(this).scrollTop() + 5) {
                setDisabled(false)
            } else {
                setDisabled(true);
            }
        })
    }

    // CHPFMTASK-2364 버튼 1개 disabled 에서 2개로 변경[최관영]
    function setDisabled(status){
        const hideBtns = $hideBtn.find('button');
        hideBtns.each((_, el) => {
            el.disabled = status;
        })
        status ? $hideBtn.find('button').addClass('disabled') : $hideBtn.find('button').removeClass('disabled');
   }

    function btnEvent (act, frist = false) {
        if (act == 'hide') {
            if (frist == true) {
                $hideBtn.css('display', 'none')
            } else {
                $hideBtn.stop().animate({
                    opacity : 0
                }, function(){
                    $hideBtn.css('display', 'none')
                })
            }
        } else {
            $hideBtn.css({
                'display': 'block',
            }).stop().animate({
                opacity : 1
            })
        }
    }
}

// 
/**
 * @summary [FETASK-1538] 정보제공용 팝업내 슬라이드 팝업 
 * @summary [popup-depth2-button] 속성값의 버튼으로 popup의 depth 이동
 */
export function popupDepth2(){ 
    let $popupDepth1, $popupDepth2, $depth2Button, $popup;
    $(document).on('click' , '[popup-depth2-button]', function(){
        $depth2Button = $(this);
        $popup = $depth2Button.closest('.ui-popup')
        $popupDepth1 = $(this).closest('.popup-group');
        $popupDepth2 = $(this).closest('.popup-section').find('.popup-depth2');
        if ($popupDepth2.outerHeight() < $popupDepth1.outerHeight()) {
            $popupDepth2.css('height', $popupDepth1.outerHeight())
        }
        checkPopupHeight('depth2');
        $popupDepth2.addClass('active')
        setTimeout(function(){
            $popupDepth2.find('.popup-header').addClass('on')
            $popupDepth2.find('.popup-content').addClass('on')
            $popupDepth2.find('.popup-footer').addClass('on')
        })
        
        $popupDepth2.find('.btn-back').focus();
        $popupDepth2.find('.btn-back').on('click', function(){
            checkPopupHeight('depth1');
            $popupDepth2.removeClass('active');
            setTimeout(function(){
                $popupDepth2.find('.popup-header').removeClass('on')
                $popupDepth2.find('.popup-content').removeClass('on')
                $popupDepth2.find('.popup-footer').removeClass('on')
            },600)
            $depth2Button.focus();
        })
    })

    function checkPopupHeight(depth) { // FETASK-1479  231010 : 작업중
        let _maxHeight = 70;
        if ($popup.find('.hv-60').length > 0) {
            _maxHeight = 60;
        }
        $popup.removeClass('pop-top-shadow');
        $popup.removeClass('pop-bot-shadow');
        if (depth == 'depth1') {
            $popup.data('ui').popupScrollEvent()
            $popup.addClass('depth1')
            $popup.removeClass('depth2')
            if (Math.floor($popupDepth1.outerHeight()) >= Math.floor(window.innerHeight * 0.01 * _maxHeight)) {
                setTimeout(function(){$popup.addClass('pop-bot-shadow')},800)
            }
        } else {
            $popup.data('ui').popupScrollEvent('depth2')
            $popup.addClass('depth2')
            $popup.removeClass('depth1')
            if (Math.floor($popupDepth2.outerHeight()) >= Math.floor(window.innerHeight * 0.01 * _maxHeight)) {
                setTimeout(function(){$popup.addClass('pop-bot-shadow')},800)
            }
        }
    }
}

/**
 * @summary 공통적으로 사용 중인 넘버롤링 [data-interest-num="Number"] 속성의 값변경시  옵저버동작, viewport 보이면 옵저버 동작
 * @param {function} callback  넘버롤링 동작 끝나고 실행 콜백 
 * @example
 * frontUI.onRollingNumber(function(){})
 */
export function onRollingNumber(callback){
    let rollingDiv, counterNumArr, returnNum, observerNum;
    const hasCounterNum = () => {
        return document.querySelectorAll('[data-interest-num]');
    }

    const hasRollingNum = (counterNum) => {
        const parentElem = counterNum.parentElement;
        return parentElem.querySelector('.number-rolling');
    }

    const createRollingDiv = (counterNum) => {
        rollingDiv = document.createElement('div');
        rollingDiv.className = 'number-rolling';
        rollingDiv.ariaHidden = 'true';
        counterNum.after(rollingDiv);
       
    }

    const animateRolling = (target) => {
        animateRollingNumber(target);
        observerNum && observerNum.observe(target, {attributes: true});
    }

    const resetRolling = (target) => {
        observerNum && observerNum.disconnect();
        // const numberRollingElem = target.parentElement.querySelector('.number-rolling');
        // numberRollingElem && numberRollingElem.classList.remove('active');
    }

    const animateRollingNumber = (counterNum) => {
        if ($(counterNum).attr('data-interest-num') == undefined) {
            counterNum = $(counterNum).find('[data-interest-num]')[0]
        }
        const currentNum = $(counterNum).attr('data-interest-num');
        const counterSum = currentNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const prevNum = !!counterNum.textContent && counterNum.textContent.replace(/,/g,'')

        counterNumArr = counterSum.split('');

        // data-interest-num 동적 변경시 기존 DOM 삭제
        
        // if ($(counterNum).closest('.ui-amount').length > 0 ) {
        //     console.log(111)
        //     //hasRollingNum(counterNum) && hasRollingNum(counterNum).remove();
        // } else {
        //     if(prevNum && currentNum != prevNum){
        //         hasRollingNum(counterNum) && hasRollingNum(counterNum).remove();
        //     }
        // }
        if(prevNum && currentNum != prevNum){
            hasRollingNum(counterNum) && hasRollingNum(counterNum).remove();
        }
        if (counterNum.hasAttribute('data-num-reset')){
            if ($(counterNum).closest('.txt-count-wrap').attr('num-reset') == 'true'){
                return false;
            }
        }
        if ($(counterNum).attr('data-num-reset') != undefined) {
            hasRollingNum(counterNum) && hasRollingNum(counterNum).remove();
        }
        if(hasRollingNum(counterNum) ){
            return false;
        }
        
        if (counterSum == null || counterSum == '' || counterSum == undefined) {
            return false;
        }
        // DOM(number-rolling) 동적생성
        if(!$(counterNum).closest('.count-item').length > 0) {
            counterNum.textContent = `${counterSum}`;
        }
        
        if ($(counterNum).attr('interest-num-type') == 'question') {
            $(counterNum).closest('.txt-count-wrap').attr('aria-hidden', true);
            if (!$(counterNum).closest('.finding-oil').length > 0 ) {
                $(counterNum).closest('.txt-count-wrap').after('<div class="hide-txt" question-text>신용점수는 가입 후 확인 가능</div>')
            }
            
        } else {
            $(counterNum).closest('.txt-count-wrap').attr('aria-hidden', false);
            $(counterNum).closest('.finding-my-credit').length >0 ? $(counterNum).closest('.finding-my-credit').find('[question-text]').remove() : '';
        }
        if (counterSum == 0) { // FETASK-1555 : 240110 금액이 0 인경우에  동작 x
            createRollingDiv(counterNum);
            $(rollingDiv).append(`<div class="normal-num0">0</div>`); // CHPFMTASK-674 : 240213 금액 0 일경우 공백재거
            return false;
        }
        
        createRollingDiv(counterNum);
        if (counterNum.hasAttribute('interset-num-small')) { // 숫자 적은 타입 (한바퀴 돌고 1,  01234567891 )
            $(rollingDiv).addClass('type2')
        }
        if (counterNum.hasAttribute('interset-num-slow')) { // 느린 타입
            $(rollingDiv).addClass('slow')
        }
        if (counterNum.hasAttribute('interset-num-short')) { // 한바퀴 안도는 타입 (1,  01 )
            $(rollingDiv).addClass('short')
        }
        if (counterNum.hasAttribute('data-num-start')) { // 숫자 동일하게 애니메이션 시작
            $(rollingDiv).addClass(counterNum.getAttribute('data-num-start'))
        }
        if (counterNum.hasAttribute('interest-num-type')) { // 내 신용점수  ???
            $(rollingDiv).addClass(counterNum.getAttribute('interest-num-type'))
        } 
        returnNum = counterNumArr.map((number, i) => {
            const value = number >= 0 && `n${number}`;
            const numberDiv = isNaN(number) ? `<div>${number}</div>` : value ? `<div class="num ${value}">&nbsp;</div>` : `<div class="num">&nbsp;</div>`;        
            $(rollingDiv).append(numberDiv);
            return numberDiv;
        });
    
        // 동적생성 완료후 롤링모션(active) 및 콜백호출
        if(returnNum.length == counterNumArr.length){            
            if(!rollingDiv) rollingDiv = hasRollingNum(counterNum);

            $(rollingDiv).find('.num').each(function(i,e){
                $(e).addClass(`num-${i+1}`)
            })
            if ($(counterNum).attr('data-type') == 'oil') {
                $(rollingDiv).addClass('oil n3')
                
                $(rollingDiv).find('.num-1').addClass('active');
                $(rollingDiv).find('.num-2').addClass('active'); 
                $(rollingDiv).find('.num-3').addClass('active');
                if ($(rollingDiv).find('.num').length == 4) {
                    $(rollingDiv).find('.num-4').addClass('active');
                    $(rollingDiv).removeClass('n3')
                    $(rollingDiv).addClass('oil n4')
                }
                
                if ($(counterNum).attr('interest-num-type') != 'question') {
                    setTimeout(()=>{
                        let numLast = '.num-3'
                        let numLastBefore = '.num-2'
                        let numLastBefore2 = '.num-1'
                        let numFirst =''
                        if ($(rollingDiv).find('.num').length == 4) {
                            numLast = '.num-4';
                            numLastBefore = '.num-3';
                            numLastBefore2 = '.num-2';
                            numFirst = '.num-1';
                        }
                        oilEvent(numLast);
                        if ($(rollingDiv).find(numLast).hasClass('n0')) {
                            setTimeout(()=>{
                                oilEvent(numLastBefore);
                                if ($(rollingDiv).find(numLastBefore).hasClass('n0')) {
                                    setTimeout(()=>{
                                        oilEvent(numLastBefore2);
                                        if ($(rollingDiv).find(numFirst).length>0){
                                            if ($(rollingDiv).find(numLastBefore2).hasClass('n0')) {
                                                setTimeout(()=>{
                                                    oilEvent(numFirst);
                                                },120)
                                            }
                                        }
                                    },120)
                                }
                            }, 10)
                        }
                        if ($(rollingDiv).find(numLast).hasClass('n1')) {
                            setTimeout(()=>{
                                oilEvent(numLastBefore);
                                if ($(rollingDiv).find(numLastBefore).hasClass('n0')) {
                                    setTimeout(()=>{
                                        oilEvent(numLastBefore2);
                                        if ($(rollingDiv).find(numFirst).length>0){
                                            if ($(rollingDiv).find(numLastBefore2).hasClass('n0')) {
                                                setTimeout(()=>{
                                                    oilEvent(numFirst);
                                                },120)
                                            }
                                        }
                                    },120)
                                }
                            }, 200)
                        }
                    },1300)
                }
                
                
            } else {
                if (counterNum.getAttribute('data-no-observer') == undefined) {
                    hasRollingNum(counterNum).classList.add('active');
                } else {
                    setTimeout(() => {
                        hasRollingNum(counterNum).classList.add('on');    
                    }, 1);
                    
                }
                
            }
            
            function oilEvent(selector){
                $(rollingDiv).find(selector).addClass('active2')
            }
            const lastNumDiv = hasRollingNum(counterNum).querySelectorAll('.num');
            let  numberBefore
            if ($(counterNum).attr('data-type') == 'oil') {
                numberBefore = window.getComputedStyle(lastNumDiv[lastNumDiv.length-2], '::before');
            } else {
                numberBefore = window.getComputedStyle(lastNumDiv[lastNumDiv.length-1], '::before');
            }
            setTimeout(()=>{
                const animatedDuration = Number(numberBefore.animationDelay.split('s')[0])  + Number(numberBefore.animationDuration.split('s')[0]);
                $(counterNum).attr('ani-duration',animatedDuration)
                setTimeout(() => { 
                    hasRollingNum(counterNum).classList.add('completed');
                    if (callback && $.isFunction(callback)) {
                        callback();
                    }
                }, animatedDuration*1000);
            },10)
            
        }

        if (counterNum.hasAttribute('data-num-reset')){
            if ($(counterNum).closest('.txt-count-wrap').attr('num-reset') == 'false' || $(counterNum).closest('.txt-count-wrap').attr('num-reset') == undefined){
                $(counterNum).closest('.txt-count-wrap').attr('num-reset', true)
                return false;
            }
        }
    }

    if(!hasCounterNum().length){
        return false;
    }
    
    // 기존소스 백업
    // document.querySelectorAll('[data-interest-num]')?.forEach((counterNum) => {
    //     // animateRollingNumber(counterNum);

    //     // 가시성 관찰(viewport 진입시 한번만 실행되도록 수정)
    //     callByObserver({target: counterNum, showFn: animateRolling, hideFn: resetRolling});

    //     // DOM 변경 관찰 
    //     observerNum = new MutationObserver((mutations) => {
    //         mutations.forEach((mutation) => {
    //             animateRollingNumber(mutation.target);
    //         });
    //     });
    //     // target 속성이 변경될시 DOM 변경 계속 관찰 추가
    //     // observerNum.observe(counterNum,{attributes: true});
    // });

    // 240313 MutationObserver 계속감지하게 수정
    // const interestNum =  document.querySelectorAll('[data-interest-num]');
    // interestNum?.length && Array.from(interestNum).forEach((counterNum) => {
    //     // 가시성 관찰(viewport 진입시 한번만 실행되도록 수정) 
    //     // callByObserver({target: counterNum, showFn: animateRolling, hideFn: resetRolling});
    //     callByObserver({target: counterNum, showFn: animateRolling});
    //     // DOM 변경 관찰
    //     observerNum = new MutationObserver((mutations) => {
    //         mutations.forEach((mutation) => {
    //             animateRollingNumber(mutation.target);
    //         });
    //     });
    // });
    const interestNum =  document.querySelectorAll('[data-interest-num]');  // 홈개편 롤링 함수실행으로 변경 테스트  240711
    interestNum?.length && Array.from(interestNum).forEach((counterNum) => {
        // 가시성 관찰(viewport 진입시 한번만 실행되도록 수정) 
        // callByObserver({target: counterNum, showFn: animateRolling, hideFn: resetRolling});
        if (counterNum.getAttribute('data-no-observer') == undefined) {
            callByObserver({target: counterNum, showFn: animateRolling});
            // DOM 변경 관찰
            observerNum = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    animateRollingNumber(mutation.target);
                });
            });
        } else {
            //callByObserver({target: counterNum, showFn: animateRolling});
            if (!$.isFunction(callback) && callback) {  //  callback 파라미터를 기존사용중이여서    펑션이 아닐경우에 사용  선택자로 받기위함
                animateRollingNumber(callback);
            }
        }
    });
}

/**
 * @summary 넘버롤링 restart : 현재 홈 혜택탭에서만 사용
 */
export function onRollingNumberStart(counter) {
    const hasRollingNum = (_counterNum) => {
        const parentElem = _counterNum.parentElement;
        return parentElem.querySelector('.number-rolling');
    }
    if (hasRollingNum(counter[0]) != null) {
        const lastNumDiv = hasRollingNum(counter[0]).querySelectorAll('.num');
        const numberBefore = window.getComputedStyle(lastNumDiv[lastNumDiv.length-2], '::before');
        setTimeout(()=>{
            let animatedDuration = Number(numberBefore.animationDelay.split('s')[0])  + Number(numberBefore.animationDuration.split('s')[0]);
            if ($(counter).attr('ani-duration') != undefined ) {
                animatedDuration = Number($(counter).attr('ani-duration')); 
            }
            $(counter).next().addClass('active');
            setTimeout(()=>{
                $(counter).next().addClass('completed');
            },animatedDuration*1000)
        },10)
    }
}

/**
 * @summary 넘버롤링 reset 이벤트 : 현재 홈 혜택탭에서만 사용
 */
export function onRollingNumberReset() {
    const interestNumReset =  document.querySelectorAll('[data-interest-num][data-num-reset]'); 

    interestNumReset?.length && Array.from(interestNumReset).forEach((counterNum) => {
        $(counterNum).next().removeClass('active completed')
        $(counterNum).next().find('.num').each((i,e)=>{
            $(e).removeClass('active active2')
        })
    });
}

/**
 * @summary [CHPFMTASK-932] .btn-flip  클릭시 .card-type-flip  active 클래스 토글 이벤트
 */
export function cardReverse() { //CHPFMTASK-932
    if (!$('.ui-swiper.card-type-flip').length > 0) {
        return false;
    }
    $(document).off('click.btnFlip').on('click.btnFlip', '.btn-flip', function(){
        $('.card-type-flip').toggleClass('active')
    })
    // const config = {
    //     attributes: true,
    // };
    // const callback = (mutaionList,observer) =>{
    //     if ($(mutaionList[0].target).closest('.card-type-flip').hasClass('active')){
    //         $(mutaionList[0].target).closest('.card-type-flip').removeClass('active')
    //     }
    // }
    // const observer = new MutationObserver(callback);
    // observer.observe(document.querySelector('.card-type-flip .swiper-wrapper'), config);

    // CHPFMTASK-2387 MutationObserver 복수 타겟으로 변경
    document.querySelectorAll('.card-type-flip .swiper-wrapper')?.forEach(item =>{
        flipAction(item);
    })

    function flipAction($el){
        if(!$el) return;

        const config = {
            attributes: true,
        };

        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];
            if ($(target).closest('.card-type-flip').hasClass('active')){
                $(target).closest('.card-type-flip').removeClass('active')
            }
        });

        observer.observe($el, config);
    }
}

/**
 * @summary IntersectionObserver API을 이용한 가시성 관찰
 * @param {object} params   {target:'', showFn:'', fideFn: ''}
 * @example
 * callByObserver({target: element, showFn: Fn, hideFn: Fn});
 */
export function callByObserver(params){
    // 기존 소스
    // let fixedElem = $('button.primary1').closest('.fixed-bottom');
    // let paddingTop = fixedElem.length && parseInt(window.getComputedStyle(fixedElem[0]).paddingTop);
    // var options = {
    // ...{
    //     root: params.target.closest('.ui-popup') ? params.target.closest('.popup-content') : null,
    //     rootMargin: fixedElem.length ? `0px 0px -${Math.abs(fixedElem[0].clientHeight-paddingTop)}px 0px` : '0px 0px 0px 0px',
    //     threshold: 1.0
    // }, ...options };

    // S -- 240312 progressGab 추가 -- //  
    const progressGabobj = $('[data-progress-gab]');
    let fixedElem = $('button.primary1').closest('.fixed-bottom');
    let paddingTop = fixedElem.length && parseInt(window.getComputedStyle(fixedElem[0]).paddingTop);
    var options = {
    ...{
        root: params.target.closest('.ui-popup') ? params.target.closest('.popup-content') : null,
        rootMargin: fixedElem.length ? `0px 0px -${Math.abs(fixedElem[0].clientHeight-paddingTop)}px 0px` : '0px 0px 0px 0px',
        threshold: (progressGabobj.length > 0) ? progressGabobj[0]?.dataset?.progressGab : 1.0
    }, ...options };
    // E -- 240312 progressGab 추가 -- //
    
    let callback = (entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                // 요소가 뷰포트 또는 root에 visible될 경우 function
                if(params.showFn && typeof params.showFn == 'function'){
                    params.showFn(entry.target);
                }
            }else{
                // 요소가 뷰포트 또는 root에서 hidden될 경우
                if(params.hideFn && typeof params.hideFn== 'function'){
                    params.hideFn(entry.target);
                }
            }
        });
    };
    let io = new IntersectionObserver(callback, options);
    io.observe(params.target);
}

/**
 * @summary [data-scrAnchor], [scrAnchor-anchor-wrap], [scrAnchor-height], [scrAnchor-scroll], [scrAnchor-target] 속성값으로 스크롤 이벤트 
 * @param {element} scrollTarget  스크롤 주체  ex) '.page-inner-scroll'// 필요시 사용 
 */
export function scrClickMove(scrollTarget){
    if (!$('[data-scrAnchor]').length > 0){
        return false
    }
    const $wrap = $('[data-scrAnchor]');
    const $anchorWrap = $wrap.find('[scrAnchor-anchor-wrap]');
    $anchorWrap.parent().css('height', $anchorWrap.find('a').outerHeight(true) + 'px')
    const scrollTotalheight = $wrap.find('[scrAnchor-height]').outerHeight(true);
    const $scroll = $wrap.find('[scrAnchor-scroll]');
    
    const $anchor = $anchorWrap.find('a');
    const $targets = $wrap.find('[scrAnchor-target]');
    //setting
    let targetPosition = [];
    $targets.each((idx,element)=>{
        $(element).attr('target-index',idx)
        targetPosition[idx] = $(element).offset().top
        $(element).attr('offsettop',$(element).offset().top)
    })
    $anchor.each((idx,element)=>{
        $(element).attr('anchor-index',idx)
    })
    $('[anchor-index="0"]').addClass('on')
    const anchorTop = $anchorWrap.offset().top;
    const anchorH = $anchorWrap.outerHeight(true)
    const headerH = $wrap.find('.component-header').length > 0 ? $wrap.find('.component-header').outerHeight(true) : 0;
    let _beforePosition = $scroll.scrollTop();
    if (scrollTarget != undefined){
        if (!$(scrollTarget).hasClass('first')) {
            $(scrollTarget).addClass('first')
            $scroll.scrollTop($(scrollTarget).offset().top - anchorH - headerH);
        }
    }
    $scroll.on('scroll', function(){
        const  scrt = $(this).scrollTop()
        if (scrt+headerH >= anchorTop ) {
            $anchorWrap.addClass('fixed')
            $anchorWrap.css('top', headerH+'px')
        } else {
            $anchorWrap.removeClass('fixed')
            $anchorWrap.css('top', 0)
        }
        if (_beforePosition <= $(this).scrollTop()) {
            if (Math.ceil(scrt + headerH + anchorH) >= Math.ceil($(`[target-index]`).not('.active').attr('offsettop'))-2){
                downEvent()
            }
            if (Math.ceil(scrt + $wrap.outerHeight(true)) == Math.ceil(scrollTotalheight)) {
                downEvent()
            }
        }else {
            if (Math.ceil(scrt + $wrap.outerHeight(true)) <= Math.ceil($(`[target-index].active`).last().attr('offsettop'))-2) {
                upEvent()
            }
            if (Math.ceil(scrt + headerH + anchorH) <= Math.ceil(targetPosition[0])){
                upEvent('first')
            }
        }
        _beforePosition = $(this).scrollTop();
    })
    
    function upEvent(_type) {
        $(`[target-index].active`).last().removeClass('active');
        $anchorWrap.find('a').siblings().removeClass('on')
        $anchorWrap.find(`a[anchor-index="${$(`[target-index].active`).last().attr('target-index')}"]`).addClass('on')
        if (_type == 'first') {
            $('[anchor-index="0"]').addClass('on')
        }
        loadClassSet()
    }
    function downEvent() {
        $(`[target-index]`).not('.active').first().addClass('active');
        $anchorWrap.find('a').siblings().removeClass('on');
        $anchorWrap.find(`a[anchor-index="${$(`[target-index].active`).last().attr('target-index')}"]`).addClass('on')
        loadClassSet()
    }
    $anchor.off('click.scrmove').on('click.scrmove', function(e){
        e.preventDefault()
        const _idx = $(this).attr('anchor-index')
        $scroll.stop().animate({scrollTop: targetPosition[_idx]-headerH - anchorH});
    })
    function loadClassSet() {
        if (scrollTarget != undefined){
            if (!$(scrollTarget).hasClass('set')) {
                $(scrollTarget).addClass('set')
                $anchorWrap.find('a').siblings().removeClass('on');
                $(`[anchor-index="${$(scrollTarget).attr('target-index')}"]`).addClass('on')
            }
        }
    }
}

/**
 * @summary [CHPFMTASK-1464] 한번에 이자받기 이벤트 
 * @summary PBKMAN1000003400S.html  하단 스크립트 var coinAniPop = frontUI.earnInterest(); 부분 작업방법 
 * @param {object} options  options = {id,class,duration,callback,focus}
 * @example
 * var test = frontUI.earnInterest();
 * test.start(callbackFn);
 * test.close(callbackFn , tiem);
 */
export function  earnInterest(options={}) {  // CHPFMTASK-1464  한번에 이자받기  
    const {afterElement} = {
        afterElement: '.interest-group-after',  // 현재는 해당페이지에서만 사용중이고 .interest-group-after 고정 
        ...options
    };

    var obj  = {
        start : function(callback) {
            $('.interest-group-after').css({
                'display':'flex',
                'opacity':0
            });
            $('.interest-group-after').stop().animate({
                opacity :1,
            },250, function(){
                callback && $.isFunction(callback) && callback();
            })
        },
        close : function (callback, time = 400) {
            const _time = 400
            $('.interest-group-after').stop().animate({
                opacity:0,
            },_time ,function(){ 
                $('.interest-group-after').css({
                    'display':'none',
                });
            })
            setTimeout(()=>{
                console.log('const time:', _time)
                callback && $.isFunction(callback) && callback();
            }, Number(_time)+10)
        }
    }
    return obj
}
/**
 * @summary [data-elps-wrap], [elps-box-except], [elps-box], [elps-txt]   속성 추가 관련하여 텍스트  끝 ... 처리 이벤트
*/
// [CHPFMTASK-861] 전체계좌조회 개선
export function textEllipsis() {
    if (!$('[data-elps-wrap]').length > 0) {
        return false;
    }
    var addRem = 0
    $('[data-elps-wrap]').each(function(idx,el){
        var boxExcept = 0;
        $(el).find('[elps-box-except]').each(function(i,e){
            boxExcept += $(e).width()
        })
        if ($(el).closest('.home-default').length > 0 ) {
            addRem = 1;
        }
        // console.log(addRem)
        if ($(el).find('[elps-box]').length > 0 ) {
            $(el).find('[elps-box]').css('max-width', `calc(100% - ${boxExcept > 0 ? (boxExcept+10)/10 + addRem : 0 }rem)`)
        }
        if ($(el).find('[elps-txt]').length > 0 ) {
            $(el).find('[elps-txt]').css('max-width', `calc(100% - ${$(el).find('[elps-txt-except]').width() > 0 ? ($(el).find('[elps-txt-except]').width()+10)/10 : 1 }rem)`)
        }
        
    })
}
/**
 * @summary [CHPFMTASK-870] 애니메이션 이벤트
 * @param {object} opt  opt = {id,class,duration,callback,focus}
 * @example
 * frontUI.gsapEvent({
 *   id:"test",    // [data-gsap="test"]
 *   class :'test',  // addClass 네임
 *   duration:'1000',  // setTimteout 시간 
 *   callback:function(){},  // 콜백함수 
 *   focus:'.test or #test'  // 돌아갈 포커스 선택자 '.test' or '#test'
 * })
 */
export function gsapEvent(opt) {
   if (!$('[data-gsap]').length > 0) {
        return false;
   }
   $(`[data-gsap="${opt.id}"]`).addClass(opt.class)
   setTimeout(() => {
    opt.callback()
    if ($(opt.focus).length > 0) {
        $(opt.focus).focus()
    }
   }, opt.duration);
}

/**
 * @summary [FETASK-1286] 머니톡 
 * @summary 구소스 머니톡 js script 열결하는 이벤트
 */
export function moneyTalkMain() {
	if( $('.moneytalk.theme').length) {
		$.getScript('/resource/js/mmk/libs/moneyTalkMain.js', function(){
			moneyTalk.init();
		});
	}
}
// 은행 증권사 select
/**
 * @summary select 팝업이 ui-custom이 아닌   셀렉트 -> 하드코딩반팝업 케이스 \
 * popup_bottom_sample36.html  사용법 정리  
 */
export function selectPopup() {
    var obj = {
        selectBank : function (opt) {
            const $button =  typeof opt.optBtn == 'string' ? $(`#${opt.optBtn}`).length ? $(`#${opt.optBtn}`): $(`.${opt.optBtn}`) : $(opt.optBtn);
            const selectNum = $button.closest('.ui-popup').attr('select-bank');
            const _value = $button.attr('data-val');
            const _text = $button.find('.tit-option').text();
            const _select = $(`#${selectNum}`);
            const _optionSelected = _select.find(`option[value="${_value}"]`);
            var iconClass;
            $button.find('i')[0].classList.value.split(' ').filter((val) => {
                if (val.includes('logo-')) {
                    iconClass = val;
                }
            });
            _select.find('option').each(function(idx,option){
                $(option).removeAttr('selected');
                $(option).prop('selected',false);
                $(option).attr('check-text',true);
            })
            _optionSelected.attr('selected','selected');
            _optionSelected.prop('selected',true)
            _select.find('[data-select-icon]')[0]?.setAttribute('class', `${iconClass} w20`);
            _select.find('[data-select-text]')?.text(_text)
            _select.addClass('done')
            $(opt.optBtn).closest('.ui-popup').data('ui').close().callback(()=>{
                frontUI.Popup.closeSelectors = `#${selectNum} .btn-selectbox`;
                opt.callback && $.isFunction(opt.callback) && opt.callback();
            })
        },
        popupOpen : function(opt) {
            const $select = $(`#${opt.selectWrap}`);
            $(`#${opt.popup}`).attr('select-bank', $select.attr('id'));
            $(`#${opt.popup}`).attr('data-type', 'select-bank');
            // s : CHPFMTASK-1714 삭제
            // if ($select.find('option[selected]').attr('data-tab') != undefined) { 
            //     $(`#${opt.popup}`).find('.select-tab').data('ui').open($select.find('option[selected]').attr('data-tab'))
            // } else {
            //     $(`#${opt.popup}`).find('.select-tab').data('ui').open(0)
            // }
            // e : CHPFMTASK-1714 삭제
            $(`#${opt.popup}`).find('.select-tab').data('ui').open(0);
            var popupCont = $(`#${opt.popup}`).find('.popup-content');
            if (popupCont.attr('tabScrTop0') != undefined) {
                for (var i = 0; i < popupCont[0].attributes.length; i++) {
                    if (popupCont.attr(`tabScrTop${i}`) != undefined) {
                        console.log('여기', popupCont.attr(`tabScrTop${i}`))
                        popupCont.removeAttr(`tabScrTop${i}`)
                    }
                }
            }
            if ($select.find('option[selected]').attr('value') != '') {
                const _value = $select.find('option[selected]').attr('value');
                $(`#${opt.popup}`).find('button').each(function(i,e){
                    $(e).removeClass('selected')
                    //$(e).attr('aria-checked','false')  // CHPFMTASK-1714 삭제
                    if ($(e).attr('data-val') == _value) {
                        $(e).addClass('selected');
                        //$(e).attr('aria-checked', 'true'); // CHPFMTASK-1714 삭제
                    }
                })
            } else {
                $(`#${opt.popup}`).find('button').each(function(i,e){
                    $(e).removeClass('selected')
                })
            }
        },
        update: function(selector){
            $(selector).each(function(idx, el){
                if (Number($(el).find('select option[selected]').attr('value')) > 0) {
                    var selected = $(el).find('select option[selected]');
                    $(el).addClass('done')
                    $(el).find('[data-select-text]').text(selected.text());
                    $(el).find('[data-select-icon]')[0].setAttribute('class', `${selected.attr('data-img')} w20`);
                    if ($(el).closest('.ui-formBox').length > 0) {
                        $(el).closest('.ui-formBox').addClass('done');
                    }
                } else {
                    $(el).find('[data-select-text]').text($(el).find('select').attr('title'));
                }
            })
        },
        reset : function (selector) {
            if (!$(selector).length > 0) {
                return false;
            }
            $(selector).each(function(idx, select){
                if ($(select).closest('.ui-formBox').length > 0) {
                    $(select).closest('.ui-formBox').removeClass('done');
                    $(select).closest('.ui-formBox').data('ui').attachEvents();
                }
                $(select).find('[data-select-text]').text($(select).find('select').attr('title'));
                $(select).removeClass('done')
                
                $(select).find('option').each(function(idx, option) {
                    $(option).removeAttr('selected')
                })
            })
        }
    }
    if ($('[data-select-popup]').length > 0){
        obj.update('[data-select-popup]');
    }
    return obj;
}

/**
 * @summary CHPFMTASK-1574   툴팁 -> 반팝업 케이스 추가 \
 * [data-tooltip-popup] 속성값 있는 경우 클릭이벤트를 js에서 실행 그외 개발에서 open하고싶은 경우엔 함수로 실행 
 * @example
 * frontUI.popupTooltip.open({
 *       button : $(this),   // element 
 *       title: _title,      // 툴팁 반팝업 타이틀 
 *       lists: _lists,      // 툴팁 반팝업 안에 들어갈 list  innerHTMlL 형식
 *       btnConfirm: {
 *           text: '확인',    // 툴팁 반팝업 안에 버튼 text
 *           fn: function(){console.log(2);}   // 콜백
 *       }
 *   })
 */
export function tooltipPopup() {
    if (!$('[data-tooltip-popup]').length > 0){
        return false;
    }
    $('[data-tooltip-popup] .btn-tooltip').off('click.tooltipPopup').on('click.tooltipPopup',function(){
        let _tooltipWrap = $(this).closest('[data-tooltip-popup]');
        let _title;
        if (_tooltipWrap.attr('data-group-title') == undefined) {
            _title = $(this).attr('title')
        } else {
            _title = _tooltipWrap.attr('data-group-title');
        }

        let _lists 
        if (_tooltipWrap.attr('data-group-num') == undefined) {
            _lists = _tooltipWrap.find('[tooltip-popup-desc]')[0].innerHTML;
        } else {
            _lists = $(`[tooltip-popup-desc="${_tooltipWrap.attr('data-group-num')}"]`)[0].innerHTML
        }

        frontUI.popupTooltip.open({
            button : $(this),
            title: _title,
            lists: _lists,
            btnConfirm: {
                text: '확인',
                fn: function(){console.log(2);}
            }
        })
    })
}

/*! s: FETASK-a11y page isA11yHeaderEmptyTextCheck v.1.0.0 */
export function isA11yHeaderEmptyTextCheck(){
    /**
     * Header쪽 공통 a11y작업
     */
    try {
        const headerWrap = document?.querySelectorAll('.component-header .tit-header > span');
        const likeGroupInp = document?.querySelectorAll('.like-group .tap-like input');
        const likeGroupTextEles = document.querySelectorAll('.like-group .tap-like + .ui-tooltip .tooltip-content .txt');

        const btnAlarmEles = document?.querySelectorAll('.component-header .btn-alarm i');
        const alarmObj = {
            'ico-alarm': '알림',
            'new-alarm': '새소식',
        }

        const btnSettingEles = document?.querySelectorAll('.component-header .btn-set');

        const btnClapEles = document?.querySelectorAll('.component-header .btn-clap');

        // s:title h1태그 span안에 text없을시 스크린리더 안 읽히게 수정
        /*
        if(headerWrap){
            headerWrap.forEach((list) => {
                const listText = (list.innerText || '')?.trim()?.length;
                const parentWrap = list.classList.contains('logo-zeropay');

                if(!listText && !parentWrap){
                    list.parentNode.setAttribute('aria-hidden', 'true');
                }
            });
        }
        */
        // e:title h1태그 span안에 text없을시 스크린리더 안 읽히게 수정

        // s:관심 혜택 설정 접근성 수정
        /*
        if(likeGroupInp){
            likeGroupInp?.forEach((list) => {
                //초기 해당 input checked 여부에 따라 해제/설정 적용
                list?.setAttribute('title','관심 혜택 설정');
            });
        }

        if(likeGroupTextEles){
            const newText = `
                ♡버튼
                <span style="position:absolute;top:-99999px;left:-99999px;">
                    (관심 혜택 설정 체크박스)
                </span>
                을 누르면 나만의 관심 혜택으로 설정할 수 있어요
            `;

            likeGroupTextEles.forEach((list) => {
                list.innerHTML = newText;
            });
        }
        */
        // e:관심 혜택 설정 접근성 수정

        // s: 알림 / 새소식 설정 접근성
        /*
        if(btnAlarmEles){
            let newTitleText = '';

            btnAlarmEles?.forEach((list) => {
                newTitleText += `${alarmObj[list.className] + ' '}` || '';

                list.parentElement.setAttribute('title', newTitleText.trim(''))
            });
        }
        */
        // e: 알림 / 새소식 설정 접근성

        // s: 설정 접근성
        /*
        if(btnSettingEles){
            btnSettingEles.forEach((list) => {
                list.setAttribute('title', '설정');
            });
        }
        */
        // e: 설정 접근성

        // s: 한정쿠폰 접근성
        /*
        if(btnClapEles){
            btnClapEles.forEach((list) => {
                list.setAttribute('title', '한정쿠폰')
            });
        }
        */
        // e: 한정쿠폰 접근성
    } catch (error) {
        throw new Error(error);
    }
}
/*! e: FETASK-a11y page isA11yHeaderEmptyTextCheck v.1.0.0 */

/*! s: FETASK-a11y page isA11yAgreement v.1.0.0 */
export function isA11yAgreement(){
    /**약관동의 */
    try {
        const agreeMentEles = document?.querySelectorAll('.component-agreement .agreement-group2[data-role="agree-wrap"] .input-checkbox-group input');

        if(agreeMentEles){
            agreeMentEles?.forEach((list) => {
                list.setAttribute('title', '선택 시 레이어가 활성화됩니다.');
            })
        }
    } catch (error) {
        throw new Error(error);
    }
}
/*! e: FETASK-a11y page isA11yAgreement v.1.0.0 */

/*! s: FETASK-a11y page isA11yUtilText v.1.0.0 */
export function isA11yUtilText(){
    /**
     * input.js에 로직 넣을시 랜더가 input 개수만큼되서 브라우저 성능상 안좋아서 한번만 실행되게 해당위치에 적용
     */
    const utilTextCount = document?.querySelectorAll('.form-util .helper-msg span.sum, .form-util .helper-msg > em');
    let countId = 'newBoxTextCount';

    if(utilTextCount){
        utilTextCount.forEach((list,idx) => {
            const sumBox = list?.parentElement;
            const sumInputBox = list?.parentElement?.parentElement?.previousElementSibling?.children[0];

            if(sumBox){
                sumBox.setAttribute('id',`${countId}_${idx}`);
                sumBox.setAttribute('aria-live','polite');
                sumBox.setAttribute('aria-hidden','true');
                sumBox.setAttribute('tabindex','-1');
            }

            if(sumInputBox){
                sumInputBox.setAttribute('aria-describedby',`${countId}_${idx}`);
            }
        });
    }
}
/*! e: FETASK-a11y page isA11yUtilText v.1.0.0 */

/*! s: FETASK-a11y page isA11yRecList v.1.0.0 */
export function isA11yRecList(){
    const rectListBox = document?.querySelectorAll('.rec-list-item');

    rectListBox?.length && rectListBox?.forEach((list) => {
        const rectItem = list?.querySelector('.rec-item-txt');

        rectItem.setAttribute('role', 'button');

    })
}
/*! e: FETASK-a11y page isA11yRecList v.1.0.0 */

/*! s: FETASK-a11y page isA11yDetectConfirmBtn v.1.0.0 */
export function isA11yDetectConfirmBtn(){
    /**
     * DOM에 class감지를 통해 aria-disabled 속성 true/false 변경
     */
    const btnEles = document.querySelectorAll('.btn-group');

    btnEles?.forEach((list) => {
        const btnItem = list?.querySelector('button');

        if(!btnItem) return;

        const isDisable = btnItem?.classList.contains('disabled');

        if(isDisable){
            btnItem?.setAttribute('role','button');
            btnItem?.setAttribute('aria-disabled', isDisable);
        }

        return detectList(btnItem);
    });

    function detectList($el){
        const config = {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        };

        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];

            const isDisable = target.classList.contains('disabled');

            target?.setAttribute('aria-disabled', isDisable);
        });

        observer.observe($el, config);
    }
}
/*! e: FETASK-a11y page isA11yDetectConfirmBtn v.1.0.0 */

/*! s: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
export function addPopupCloseBtn(){
    const popupEles = Popup.isPopupEles;    
    
    $(popupEles).each((_,item) => {
        const isCheckFullPopup = item.classList.contains('ui-full');
        const isCheckFullPopupInCloseBtn = item.querySelector('.btn-popup-close');

        if(isCheckFullPopup && isCheckFullPopupInCloseBtn) return; //풀팝업이면서 닫기버튼 있을시 실행 안되게

        const closeBtn = isA11yCreatButton();

        $(closeBtn).on('click', (e) => {
           $(item).trigger('click');
        });

        if($(item).find('.interest-group-top')[0]){
            $(item).find('.popup-header').append(closeBtn);
        }else{
            $(item).find('.popup-content').before(closeBtn);
        }
    });
}
/*! e: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */

/*! s: FETASK-a11y page benefit-list-group v.1.0.0 */
export function isA11yBenefitList(){
    const benefitLists = document?.querySelectorAll('.benefit-list-group .list-item .tap-link');
    const benefitLabel = document?.querySelectorAll('.benefit-list-group .img-figure label');
    const benefitInput = document?.querySelectorAll('.benefit-list-group .tap-like input');

    benefitInput?.forEach((list,idx) => {
        !!benefitLists[idx].innerText.replace(/\n|\r|\s*/g, '')?.length && list?.setAttribute('title', `${benefitLists[idx].innerText.replace(/\n|\r|\s*/g, '')}`)
    });

    benefitLabel?.forEach((list) => {
        list?.setAttribute('aria-hidden','true');
    });

    benefitLists?.forEach((list) => {
        list?.setAttribute('role','button');
    });
}
/*! e: FETASK-a11y page benefit-list-group v.1.0.0 */

/*! s: FETASK-a11y page progress-step-group v.1.0.0 */
export function isA11yProgressStep(){
    const progressBox = document.querySelectorAll('.progress-step-group li.progress-item');

    progressBox?.forEach((list,idx) => {
        const circleEle = list.querySelector('.progress-circle') || list.querySelector('.progress-square');
        const isCheckCurrent = list.classList.contains('current');
        const titleEle = list.querySelector('.progress-tit');

        const currentIdx = getElementIdx(list); //현재 index값 가져오기

        circleEle?.setAttribute('role', 'img');
        circleEle?.setAttribute('aria-label', `${currentIdx + 1} ${titleEle?.textContent}`);
        isCheckCurrent && circleEle.setAttribute('aria-current','step');

        titleEle?.setAttribute('aria-hidden','true');
    });
}
/*! e: FETASK-a11y page progress-step-group v.1.0.0 */

/*! s: FETASK-a11y page isA11yDateSpinnerInput v.1.0.0 */
export function isA11yDateSpinnerInput(){
    const spinnerInputs = document?.querySelectorAll('.input-txt-group[data-type="dateSpinner"], .input-close-group[data-type="dateSpinner"], .input-line-group[data-type="dateSpinner"], .input-triangle-group[data-type="dateSpinner"], .input-arrow-group[data-type="dateSpinner"], .btn-group[data-type="dateSpinner"], .selectbox-bl-radius-group[data-type="dateSpinner"]');

    spinnerInputs?.length && spinnerInputs?.forEach((list) => {
        const reg = /[`~!@#$%^&*()_+=?;:'",.<>\{\}\[\]\\\/ ]/gim;
        const label = list?.querySelector('label');
        const labelText = label ? label?.textContent.replace(reg,'') : undefined;
        const inputEle = list?.querySelector('input');

        inputEle && inputEle?.setAttribute('aria-hidden','true');

        const isCheckBtn = $(list)?.find('.btn-selectbox');

        (inputEle && inputEle?.value && !!inputEle?.value?.length) && list.setAttribute('aria-label', inputEle?.value);

        if(!list?.ariaLabel?.length){
            list.removeAttribute('aria-label');
        }

        list.setAttribute('aria-hidden', 'false');
        list.setAttribute('role', 'button');

        if(!list?.title?.length){
            //해당 div에 title속성 안들어가 있을시 label textContent값 넣기
            if(!isCheckBtn?.length){
                list.setAttribute('title', isA11ySameTextFilter(`${labelText ?? ''} 선택`));
            }else{
                list.setAttribute('title', isA11ySameTextFilter(`${isCheckBtn?.attr('title')}`));
            }
            
        }else{
            $(list).data('a11yTitle', list.title);
        }
    });
}
/*! e: FETASK-a11y page isA11yDateSpinnerInput v.1.0.0 */

/*! s: FETASK-a11y page isA11yLinkParamsChange v.1.0.0 */
export function isA11yLinkParamsChange(){
    /*
    const a11yLinks = document.querySelectorAll('a[target="_self"], a[target="_blank"]');

    a11yLinks.forEach((list) => {
        list.href = `${list.pathname}?a11y`;
    });
    */
}
/*! e: FETASK-a11y page isA11yLinkParamsChange v.1.0.0 */

/*! s: FETASK-a11y page isA11yImgLink v.1.0.0 */
export function isA11yImgLink(){
    const imgEles = document?.querySelectorAll('img');

    imgEles?.length && imgEles?.forEach((item) => {
        if(!item?.attributes['alt']){
            item.alt = "";
        }
    });
}
/*! e: FETASK-a11y page isA11yImgLink v.1.0.0 */

/*! s: FETASK-a11y page isA11yFormPasswordAcess v.1.0.0 */
export function isA11yFormPasswordAcess(){
    const passwordWrap = document.querySelectorAll('.form-password-input');
    
    passwordWrap?.forEach((list) => {
        const items = list.children;
        list.setAttribute('role','button');
        //list.setAttribute('title','비밀번호 입력 보안키패드 열기');
        initAcess(list, items, 'on'); //처음 접근성 로직 실행
        detectList(list); //클래스 변경 감지
    });

    function initAcess($target, $items, check='on'){
        const activeItem = $target.querySelectorAll(`.${check}`);
        $target.setAttribute('aria-live','polite');

        const setText = !activeItem.length ? `총 ${$items.length}자리 입력` : `총 ${$items.length}자리 입력. ${activeItem.length}자리 입력됨`
        
        Array.from($items)?.forEach((_) => {
            $target.setAttribute('aria-label', setText);
        });
    }

    function detectList($el){
        const config = {
            subtree: true,
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        };

        const childList = $el.children //감시하는 자식nodes

        const observer = new MutationObserver(() => {
            initAcess($el, childList, 'on');
        });

        observer.observe($el, config);
    }
}
/*! e: FETASK-a11y page isA11yFormPasswordAcess v.1.0.0 */

/*! s: FETASK-a11y page moveItemFocusMove v.1.0.0 */
export function moveItemFocusMove($el){
    $(document).ready(async () => {
        //해당 로직보다 뒤로 실행시키기위해 비동기로 실행
        if(!$el.find('.move-item')) return;
            
        const delay1 = new Promise((resolve) => setTimeout(resolve, 20));

        await delay1;

        await($el.find('.move-item')?.each(function(_, item){
            $(item).css({
                'width': `calc(100% / ${$(this).parent()?.find('.toggle-item')?.length})`,
                'opacity':1,
                'transition': 'initial',
                'transform': `translate(calc(100% * ${$(this).parent()?.find('.toggle-item.active').index()-1}), 0)`,
            });
        }));

        //해당 로직보다 뒤로 실행시키기위해 비동기로 실행
        const delay2 = new Promise((resolve) => setTimeout(resolve, 10));

        await delay2;

        await $el.find('.move-item').css({
            'transition': 'all .3s ease-in-out',
        });
    })
}
/*! e: FETASK-a11y page moveItemFocusMove v.1.0.0 */

/*! s: FETASK-a11y page isA11yTrnForm v.1.0.0 */
export function isA11yTrnForm(){
    // .trn-msg-group 형태 input 접근성 대응
    const trnMsgWrap = document.querySelectorAll('.trn-msg-group .trn-msg-area');

    trnMsgWrap?.forEach((list) => {
        const trnMsgEles = list?.querySelectorAll('.trn-msg-item');
        const inputEles = list?.querySelectorAll('input');
        const labelEles = list?.querySelectorAll('label');

        $(labelEles).attr('aria-hidden','true');

        trnMsgEles?.forEach((item, idx) => {
            const inputEle = item.querySelector('input');
            const isChecked = inputEle?.checked;
            const labelEle = item.querySelector('label');
            const labelText = labelEle?.querySelector('.txt-trn')?.textContent;

            inputEle.setAttribute('aria-label', labelText);
    
            if(isChecked){
                inputEle.setAttribute('checked','true');
            }else{
                inputEle.removeAttribute('checked');
            }

            item.addEventListener('click', (e) => {
                $(inputEle).trigger('click');
                
                $(inputEles).removeAttr('checked');

                inputEle.setAttribute('checked','true');
            });
    
            inputEle.addEventListener('change', (e) => {
                $(inputEles)?.removeAttr('checked');

                inputEle?.setAttribute('checked','true');
            });
        });
    });
}
/*! e: FETASK-a11y page isA11yTrnForm v.1.0.0 */

/*! s: FETASK-a11y page a11yUnconfirmed v.1.0.0 */
export function a11yUnconfirmed(){
    let unconfirmedEles = [
        ...document?.querySelectorAll('.card-timeline-group'),
        ...document?.querySelectorAll('.btn-quick-link')
    ].filter((item) => !!item && item);

    unconfirmedEles?.length && Array.from(unconfirmedEles).forEach((list) => {
        const icoEle = list?.querySelector('.ico-quick');
        const spanEle = list?.querySelector('.icon');

        const isCheckNew = $(list).hasClass('unconfirmed');

        if(icoEle){
            icoEle?.removeAttribute('role','img');
            icoEle?.setAttribute('aria-hidden','true');
            icoEle.setAttribute('tabindex','-1');

            if(isCheckNew){
                icoEle?.setAttribute('role','img');
                icoEle?.setAttribute('aria-hidden','false');
                icoEle?.setAttribute('aria-label','새알림');
                icoEle.setAttribute('tabindex','0');
            }
        }

        spanEle?.setAttribute('aria-hidden','true');
    });
}
/*! e: FETASK-a11y page a11yUnconfirmed v.1.0.0 */

/*! s: FETASK-a11y page a11yNewHome v.1.0.0 */
export function a11yNewHome(){
   
    // const newHomeMenu = document.querySelectorAll('.new-home.home-tab-menu .btn-group a'); //A11YTASK-26 : : 접근성대응(2025-03-07)
    const newHomeMenu = document.querySelectorAll('.component-btn.home-tab-menu .btn-group a'); //A11YTASK-26 : : 접근성대응(2025-03-07)
    const totalNum = newHomeMenu?.length;

    newHomeMenu?.length && Array.from(newHomeMenu).forEach((list,idx) => {
        const isCheckOn = list.classList.contains('on');
        console.log('isCheckOn', isCheckOn)
        if(isCheckOn){
            list.setAttribute('aria-selected','true');
        }else{
            list.setAttribute('aria-selected','false');
        }

        list.addEventListener('click', (e) => {
            e.preventDefault();

            $(newHomeMenu)?.attr('aria-selected','false');

            e.currentTarget?.setAttribute('aria-selected','true');
        });
    });
}
/*! e: FETASK-a11y page a11yNewHome v.1.0.0 */

/*! s: FETASK-a11y page isA11yAgreementInputTitle v.1.0.0 */
export function isA11yAgreementInputTitle(){
    const agreeInputDivEles = document?.querySelectorAll('.component-agreement .input-checkbox-group, .agreement-content .input-checkbox-group');
    const noneTitlePoup = document?.querySelectorAll('.agreement-inbox-gray .input-checkbox-group, .component-agreement.loan-type .input-checkbox-group');

    agreeInputDivEles?.length && agreeInputDivEles?.forEach((list) => {
        const inputEle = $(list).find('input');

        if(inputEle.attr('data-none-title') != 'true'){
            inputEle?.attr({'title':'선택 시 레이어가 활성화됩니다'});
        }
    });

    noneTitlePoup?.length && noneTitlePoup?.forEach((list) => {
        const inputEle = $(list).find('input');
        
        inputEle?.removeAttr('title');
    });
}
/*! e: FETASK-a11y page isA11yAgreementInputTitle v.1.0.0 */

/*! s: FETASK-a11y page isA11yInitButtonRole v.1.0.0 */
export function isA11yInitButtonRole(){
    //모든 a태그 role=button없을때 button넣기
    $(document)?.ready(function(){
        $('body')?.removeAttr('style');

        const backBtnEles = $('a[href]').not('[role="tab"]');
    
        backBtnEles?.length && backBtnEles?.each((idx, item) => {
            if(item.getAttribute('role') != null && item.getAttribute('role') != '') return;
            item.setAttribute('role','button');
        });
    });
}
/*! e: FETASK-a11y page isA11yInitButtonRole v.1.0.0 */

export function isA11yTrnListGroup(){
    const trnListGroupWrap = document?.querySelectorAll('.trn-list-group');

    trnListGroupWrap?.length && Array.from(trnListGroupWrap).forEach((item) => {
        const ulEle = item?.querySelector('.trn-list');
        const listEle = item?.querySelectorAll('.trn-list-item');

        ulEle && ulEle.setAttribute('role','radiogroup');
        
        listEle?.length && Array.from(listEle).forEach((list) => {
            const optionEle = list?.querySelector('.btn-trn-option');
            
            list?.removeAttribute('role');

            const isChecked = optionEle?.classList.contains('selected');

            optionEle?.setAttribute('aria-checked', isChecked);

            detectSelectItem(optionEle);
        })
    });

    function detectSelectItem($el){
        if(!$el) return;

        const config = {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        };

        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];

            const isChecked = target?.classList.contains('selected');

            target?.setAttribute('aria-checked', isChecked);
        });

        observer.observe($el, config);
    }
}

export function isA11yTitleHeadHide(){
    const hideTxt = document?.querySelectorAll('.popup-header .tit-head, .popup-header .tit-header, .header-content .tit-head, .header-content .tit-header');

    hideTxt?.length && Array.from(hideTxt)?.forEach((item) => {
        const hideSapn = item?.querySelector('span.hide-txt');

        if(hideSapn){
            item?.setAttribute('aria-hidden','true');
        }
    });
}
/*! s: FETASK-a11y page ScrollAnimation v.1.0.0 */
export function isA11yScrollAnimation(element){  // scrollAnimation a11y
    // 관리자 페이지 svg 접근성 대응 data-role="animation-item"
    const svgEles = element?.querySelectorAll('svg');

    svgEles && isA11ySetAttr(svgEles, 'aria-hidden' , 'true');
    svgEles && isA11ySetAttr(svgEles, 'tabindex' , '-1');

    $(svgEles)?.find('*').attr({'aria-hidden':'true', 'tabindex':'-1'});
}
export function isA11yTableCaption(){
    //ios caption버그 방지
    const tableCaptions = document?.querySelectorAll('table caption');

    tableCaptions?.length && Array.from(tableCaptions)?.forEach((item) => {
        item?.setAttribute('role','presentation none');
    });
}

export function isA11yAccordionCard(){
    //챌린지 박스 접기 펼침 접근성 추가
    const accordionBtns = $('.card-accor-btn .ui-accordion-btn, .ui-accordion-list .ui-accordion-btn');

    accordionBtns?.each((idx, item) => {
        const closeWrap = $(item).closest('.ui-accordion-list');
    
        $(item).attr('aria-expanded', closeWrap.hasClass('open'));
    });

    accordionBtns?.on('click',(e) => {
        const currentTarget = $(e.currentTarget);

        const curListWrap = currentTarget.closest('.ui-accordion-list');

        if(!curListWrap?.length) return;

        curListWrap.on('transitionend',() => {
            const isCheckedOpen = curListWrap.hasClass('open');

            if(isCheckedOpen){
                currentTarget.attr('aria-expanded', 'true');
            }else{
                currentTarget.attr('aria-expanded', 'false');
            }            
            

            if(isCheckedOpen){
                curListWrap.find('.card-group-sub').attr({'tabindex':'0','aria-hidden':'false'}).focus();
            }
        });
    });
}
//대출 상세내의 상세페이지 템플릿 접근성 dom순서변경 대응
export function changePrdDetailWrap(){
    $(document)?.ready(function(){
        const targetInsertEle = document?.querySelector('.prd-detail-wrap.btn');
        const changeEle = document?.querySelector('.prd-detail-wrap.icon-list');
        
        if(targetInsertEle && changeEle){
            targetInsertEle?.before(changeEle);
        }
    });
}
// A11YTASK-224, A11YTASK-227 fc-more-link 클릭 팝오버 이벤트 막기 
export async function fcreplaceTag(){
    const delay = new Promise((resolve) => setTimeout(resolve, 100));
    await delay;

    $(document).off('click.fcevent').on('click.fcevent','.fc-prev-button, .fc-next-button, .fc-customBtn1-button, .fc-customBtn2-button, .fc-customBtn3-button',(e)=>{
        e.preventDefault();
        e.stopPropagation();
        // Aremove();
        moreUpdate();
    });

    moreUpdate();

    // function Aremove(){
    //     const headerCell = $('.activeSlide .fc-col-header-cell.fc-day .fc-scrollgrid-sync-inner');
    //     if(headerCell?.children.length > 1) headerCell?.find('a.fc-col-header-cell-cushion')?.remove();
    //     moreUpdate();
    // }

    function moreUpdate(){
        const dayBottom = $('.activeSlide .fc-daygrid-day-bottom');
        dayBottom.each(function(){
            const This = $(this), findSpan = This.find('span'), findMoreLink = This.find('a.fc-daygrid-more-link.fc-more-link');
            if(findMoreLink?.length > 0){
                findSpan.remove();
                This.append(`<span class='${findMoreLink.attr('class')}' title='더보기'>${findMoreLink.text()}</span>`);
                findMoreLink.remove();
            }else{
                findSpan.remove();
            }
        });
    }
}

// A11YTASK-527 모어 버튼클릭시 콜백 호출
export async function fcMoreCallback(callback){
    const delay = new Promise((resolve) => setTimeout(resolve, 100));
    await delay;

    $(document).off('click.fcevent').on('click.fcevent','.fc-prev-button, .fc-next-button, .fc-customBtn1-button, .fc-customBtn2-button, .fc-customBtn3-button',(e)=>{
        e.preventDefault();
        e.stopPropagation();
        moreClick();
    });

    function moreClick(){
        const delay = new Promise((resolve) => setTimeout(resolve, 200));
        delay.then(()=>{
            $('.fc-more-link').off('click.fcmore').on('click.fcmore',(e) => {
                if(callback && typeof(callback) === 'function') callback(e);
            });
        });
    }
    moreClick();
}

export function fcCalendar(){
    // 공모주 청약 캘린더 접근성
    $(document)?.ready(async () => {
        a11yInitCalendar();

        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        $('.fc-media-screen')
            .find('.fc-header-toolbar')
            .find('.fc-toolbar-title')
            .attr({'aria-live':'polite'});

        // A11YTASK-526 role="button" 추가
        // $('.fc-media-screen').find('.fc-prev-button').attr('role','button');
        // $('.fc-media-screen').find('.fc-next-button').attr('role','button');

        $('.fc-media-screen')
            // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
            // .find('.fc-header-toolbar')
            // .find('.fc-prev-button')
            // .attr('title','이전')
            // .removeAttr('aria-pressed') // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
            .on('click', function(){
                // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
                // $(this).removeAttr('aria-pressed');
                // $('.fc-media-screen') 
                //     .find('.fc-header-toolbar')
                //     .find('.fc-next-button')
                //     .removeAttr('aria-pressed');

                $('.fc-daygrid table caption').remove();
                $('.fc-daygrid table colgroup').remove();
                $('.fc-daygrid table').prepend(`<caption role="none presentation"></caption>`);
    
                $('.fc-daygrid .fc-day-today .fc-daygrid-day-number').attr('aria-current','date');
                $('.fc-daygrid .fc-scrollgrid ').removeAttr('role');
    
                $('.fc-daygrid [role="row"]').removeAttr('role');
                $('.fc-daygrid [role="rowgroup"]').removeAttr('role');
                $('.fc-daygrid table [role="presentation"]').removeAttr('role');
                $('.fc-daygrid-day').removeAttr('role');
                $('.fc-daygrid-day-number').attr('role','button');

                // isMoreCalendar();
            });

        $('.fc-media-screen')
            // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
            // .find('.fc-header-toolbar')
            // .find('.fc-next-button')
            // .attr('title','다음')
            // .removeAttr('aria-pressed') // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
            .on('click', function(){
                // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
                // $(this).removeAttr('aria-pressed');
                // $('.fc-media-screen')
                //     .find('.fc-header-toolbar')
                //     .find('.fc-prev-button')
                //     .removeAttr('aria-pressed');

                $('.fc-daygrid table caption').remove();
                $('.fc-daygrid table colgroup').remove();
                $('.fc-daygrid table').prepend(`<caption role="none presentation"></caption>`);
    
                $('.fc-daygrid .fc-day-today .fc-daygrid-day-number').attr('aria-current','date');
                $('.fc-daygrid .fc-scrollgrid ').removeAttr('role');
    
                $('.fc-daygrid [role="row"]').removeAttr('role');
                $('.fc-daygrid [role="rowgroup"]').removeAttr('role');
                $('.fc-daygrid table [role="presentation"]').removeAttr('role');
                $('.fc-daygrid-day').removeAttr('role');
                $('.fc-daygrid-day-number').attr('role','button');

                // isMoreCalendar();
            });;
    });
}

// --s animate easing custom (2025.03.13)
/**
 * easing custom 공통함수
 * 
 * @example
 * $.cubicBez([0.42, 0, 0.58, 1])
*/
export function cubicCustomBez(){
    $.extend({
        cubicBez:function(encodedFuncName, coOrdArray){
          if($.isArray(encodedFuncName)){
            coOrdArray = encodedFuncName;
            encodedFuncName = 'bez_' + coOrdArray.join('_').replace(/\./g, 'p');
          }
          
          if(typeof $.easing[encodedFuncName] !== 'function'){
            
            var polyBez = function(p1,p2){
              var A = [null, null], B = [null, null], C = [null, null],
              bezCoOrd = function(t, ax){
                C[ax] = 3 * p1[ax], B[ax] = 3 * (p2[ax] - p1[ax]) - C[ax], A[ax] = 1 - C[ax] - B[ax];
                return t * (C[ax] + t * (B[ax] + t * A[ax]));
              },
              xDeriv = function(t){
                return C[0] + t * (2 * B[0] + 3 * A[0] * t); 
              },
              xForT = function(t){
                var x = t, i = 0, z;
                while (++i < 14){
                  z = bezCoOrd(x, 0) - t;
                  if(Math.abs(z) < 1e-3) break;
                  x -= z / xDeriv(x);
                } 
                return x;
              };
              return function(t){
                return bezCoOrd(xForT(t), 1);
              }
            }
            $.easing[encodedFuncName] = function(x, t, b, c, d){
              return c * polyBez([coOrdArray[0], coOrdArray[1]], [coOrdArray[2], coOrdArray[3]]) (t/d) + b;
            }
          }
          return encodedFuncName;
        }
      });
}
// --E animate easing custom (2025.03.13)

export async function a11yInitCalendar(){
        //공모주 청약 캘린더 더보기 접근성 대응
        let count = 0;
        let interval = setInterval(() => {
            $('.fc-daygrid table caption').remove();
            $('.fc-daygrid table colgroup').remove();
            $('.fc-daygrid table').prepend(`<caption role="none presentation"></caption>`);

            $('.fc-daygrid .fc-day-today .fc-daygrid-day-number').attr('aria-current','date');
            $('.fc-daygrid .fc-scrollgrid ').removeAttr('role');

            $('.fc-daygrid [role="row"]').removeAttr('role');
            $('.fc-daygrid [role="rowgroup"]').removeAttr('role');
            $('.fc-daygrid table [role="presentation"]').removeAttr('role');
            $('.fc-daygrid-day').removeAttr('role');
            $('.fc-daygrid-day-number').attr('role','button');

            // A11YTASK-227 수정 적용
            // $('.fc-col-header-cell-cushion').removeAttr('role');
            
            // 250515 성경님 요청 잠시 주석처리
            // $('.fc-daygrid-day').each(function(){
            //     const This = $(this), eventHarness = This.find('.fc-daygrid-event-harness:not(.fc-daygrid-event-harness-abs)');
            //     if(eventHarness.length < 1) {
            //         This.find('.fc-daygrid-day-number').attr('aria-disabled','true');
            //     }
            // });

            // A11YTASK-224 관련 주석 처리
            // $('.fc-daygrid-more-link.fc-more-link').attr('title','더보기');
            // isMoreCalendar();

            if(count >= 10){
                clearInterval(interval);
            }
            count++;
        },100);
}

export function isMoreCalendar(){
    // A11YTASK-224 로직 안타게 주석처리
    //공모주 청약 캘린더 더보기 접근성 대응
    // let focusEle = null;
    // $('.fc-more-link').off().on('click',(e) => {
    //     $('.fc-more-popover')
    //         .attr({
    //             'aria-hidden':'false',
    //             'tabindex': '-1',
    //             'role':'dialog',
    //             'aria-modal':'true',
    //         })
    //         .focus();
        
    //     $('.fc-more-popover .fc-popover-close').removeAttr('title');
    //     $('.fc-more-popover .fc-popover-close').attr({ 'aria-label':'닫기','role':'button' });
        


    //     focusEle = new FocusTrap({
    //         containerDomNode: '.fc-more-popover', //해당 기준 빼고 포커스 다 막는로직 실행
    //         initialFocusDomNode: '.fc-popover', //팝업 열렸을때 보낼곳
    //         sourceDomNode: e.currentTarget, //팝업 닫을때 보낼곳
    //         useFocus:false //키보드 이벤트 적용여부
    //     });

    //     focusEle.activate();
    //     //풀캘린더 열릴때 dom생성으로 클릭시 해당 이벤트 바인딩
    //     $('.fc-popover-header .fc-popover-close').off().on('click', () => {
    //         focusEle.deactive();
    //     });

    //     $('.fc-more-popover .fc-daygrid-event')
    //         .attr('role','button')
    //         .off().on('click', () => {
    //             focusEle.deactive();
    //         });
    // });
}

export function isA11yinputRadio(){
    const radioGroupEles = document?.querySelectorAll('.input-radio-btn-group');

    radioGroupEles?.length && radioGroupEles?.forEach((list) => {
        const radioBtnEles = list?.querySelectorAll('.input-radio-btn');

        radioBtnEles?.forEach((item) => {
            const inputEle = item?.querySelector('input');
            const labelEle = item?.querySelector('label');
            const labelTxt = labelEle?.innerText;

            labelEle?.setAttribute('aria-hidden', 'true');
            inputEle?.setAttribute('aria-label', labelTxt);
        });
    })
}

/*! s: FETASK-a11y 청약 캘린더 수정 v.1.0.0 */
export function a11yCalendarAccess(){
    // 청약 캘린더 접근성 스크립트
    $('.fc-prev-button, .fc-next-button').on('click',() => {
        al11yDot();
        fcCalendar();
    });

    function al11yDot(){
        $('.fc-daygrid-event .fc-daygrid-event-dot').attr('aria-hidden','true');
    
        $('.fc-daygrid-event .fc-event-title').each((idx, item) => {
            if($(item).parent()[0]?.classList.contains('dot-1')){
                $(item).parent().attr({'title':'예측', 'role':'button'});
            }else if($(item).parent()[0]?.classList.contains('dot-2')){
                $(item).parent().attr({'title':'청약', 'role':'button'});
            }else if($(item).parent()[0]?.classList.contains('dot-3')){
                $(item).parent().attr({'title':'상장', 'role':'button'});
            }
        });
    }

    // 2025.06.12 A11YTASK-526 aria-pressed 이슈관련 주석처리
    // $('.fc-toolbar-chunk button').each((idx, item) => {
    //     item.setAttribute('aria-pressed', item.classList.contains('active'));

    //     $(item).on('click',() => {
    //         item.setAttribute('aria-pressed', item.classList.contains('active'));
    //         al11yDot();
    //     });
    // });

    al11yDot(); //load시 실행
}
/*! s: FETASK-a11y 캘린더 수정 v.1.0.0 */

/**
 *  @summary .tab-item.active 요소에 aria-selected 하기 위한 함수
 */
export function isA11yTabItemsSelected(){
    $(document).ready(function(){
        const tabItems = document?.querySelectorAll('.tab-item, .toggle-item');

        tabItems?.length && tabItems.forEach((item) => {
            $('.tab-item').find('a').attr('aria-selected', 'false');
            $('.tab-item.active').find('a').attr('aria-selected', 'true');
            $('.tab-item.on').find('a').attr('aria-selected', 'true');
            // CHPFMTASK-2227 접근성대응 (2025.04.14)
            $('.toggle-item').find('a').attr('aria-selected', 'false');
            $('.toggle-item.active').find('a').attr('aria-selected', 'true');
            $('.toggle-item.on').find('a').attr('aria-selected', 'true');

            selectedDetected(item);
        });
    
        function selectedDetected(el){
            const config = {
                subtree: true,
                attributes: true,
                attributeOldValue: true,
                attributeFilter:['class'],
            };
    
            const observer = new MutationObserver(async (mutations) => {
                const { target } = mutations[0];

                $('.tab-item').find('a').attr('aria-selected', 'false');
                $('.tab-item.active').find('a').attr('aria-selected', 'true');
                $('.tab-item.on').find('a').attr('aria-selected', 'true');
                // CHPFMTASK-2227 접근성대응 (2025.04.14)
                $('.toggle-item').find('a').attr('aria-selected', 'false');
                $('.toggle-item.active').find('a').attr('aria-selected', 'true');
                $('.toggle-item.on').find('a').attr('aria-selected', 'true');
            });
    
            observer.observe(el, config);
        }
    });
}


// A11YTASK-445 : 전체메뉴 최근 리스트 즐겨찾기 속성 적용 개발에서 변경하고 있어 적용은 안함 (2025.04.10)
// export function isA11yFavoriteIcoToggle(){
//     const favoriteBtns = $('.component-link-list .link-list-group .link-list').find('Button');

//     favoriteBtns?.each((idx, item) => {
//         if($(item).children().hasClass('ico-pin-on')){
//             $(item).attr('aria-label', '즐겨찾기 등록됨');
//             // $(item).addClass('reged');
//         } else {
//             $(item).attr('aria-label', '즐겨찾기 등록안됨');
//         }
//     });
    
//     favoriteBtns.on('click',(e) => {
//         const currentTarget = e.currentTarget;
//         const chEl = currentTarget.children[0]
//         const chClsName = currentTarget.children[0].className
        
//         // $(currentTarget).toggleClass('reged');
//         if(chClsName == 'ico-pin-on'){
//             console.log('chClsName',chClsName)
//             // $(chEl).removeClass('ico-pin-on');
//             // $(chEl).addClass('ico-pin-off');
//             $(currentTarget).attr('aria-label', '즐겨찾기 등록안됨');
//         } else {
//             console.log('chClsName',chClsName)
//             // $(chEl).removeClass('ico-pin-off');
//             // $(chEl).addClass('ico-pin-on');
//             $(currentTarget).attr('aria-label', '즐겨찾기 등록됨');
//         }
//     });
// }

// A11YTASK-445 : 전체메뉴 최근 리스트 아이콘변경 - 개발에서 변경하고 있어 적용은 안함 (2025.04.10)
// export function favoriteIcoToggle(){
//     const favoriteBtns = $('.component-link-list .link-list-group .link-list').find('Button');

//     favoriteBtns?.each((idx, item) => {
//         if($(item).children().hasClass('ico-pin-on')){
//             $(item).addClass('reged');
//         }
//     });
    
//     favoriteBtns.on('click',(e) => {
//         const currentTarget = e.currentTarget;
//         const chEl = currentTarget.children[0]
//         const chClsName = currentTarget.children[0].className
        
//         $(currentTarget).toggleClass('reged');

//         // 아이콘 변경
//         if(chClsName == 'ico-pin-on'){
//             $(chEl).removeClass('ico-pin-on');
//             $(chEl).addClass('ico-pin-off');
//         } else {
//             $(chEl).removeClass('ico-pin-off');
//             $(chEl).addClass('ico-pin-on');
//         }
//     });
// }
//######################################

function plusboxChart(opt = {}){  // CHPFMTASK-1033
    this.VIEW_ITEM_NUM = 6;

    this.SELECTOR = {
		year : '[data-plusboxchart-year]',		// FETASK-809 2023-04-13 추가
		wrapper : '[data-plusboxchart="wrapper"]',
        container : '[data-plusboxchart="container"]',
		items : '[data-plusboxchart="item"]',
	}
	
	this.EVENT = {
		SCROLL : 'scroll.plusboxchart',
		RESIZE : 'resize.plusboxchart orientationchange.plusboxchart',
	};
	this.$window = $(window);
	this.$document = $(document);

    if( !$(this.SELECTOR.wrapper).length ) {
        return;
    }
    var that = this;
    $(this.SELECTOR.wrapper).each( function() {
        that.init($(this));
    });
    return this;
};
plusboxChart.prototype.init = function($wrapper) {
var element = this.getElementData($wrapper);
var that = this;
if( !element.$wrapper.length || element.$wrapper.data('init') === true ) {
    return;
}

if( element.$container.data('view-num') ) {
    this.VIEW_ITEM_NUM = element.$container.data('view-num');
}

this.setItems(element.$wrapper);
this.setPosition(element.$wrapper);
this.setAnimation(element.$wrapper);

this.dataObserver = new MutationObserver(mutations => {
    mutations.forEach((mutation) => {
        that.setPosition(element.$wrapper);
    });
});

if(element.$year.length){
    //this.dataObserver.observe(element.$year[0], {attributes:true, subtree: true, childList: true});
}

element.$wrapper.off(this.EVENT.SCROLL).on(this.EVENT.SCROLL, function() {
    that.scrollAnimation(element.$wrapper);
});

this.$window.off(this.EVENT.RESIZE).on(this.EVENT.RESIZE, function() {
    setTimeout(function(){
        that.setItems(element.$wrapper);
        that.setPosition(element.$wrapper);
    }, 10)
});

element.$wrapper.data('init', true);
}

plusboxChart.prototype.getElementData = function ($wrapper){
var element = {};

element.$wrapper = $wrapper || $(this.SELECTOR.wrapper);
element.$container = element.$wrapper.find(this.SELECTOR.container);
element.$items = element.$container.find(this.SELECTOR.items);
element.$year = $(this.SELECTOR.year);

return element;
}
plusboxChart.prototype.reload = function ($wrapper){
var element = this.getElementData($wrapper);
var that = this;
element.$wrapper.each(function(i) {
    that.setItems(element.$wrapper.eq(i));
    that.setPosition(element.$wrapper.eq(i));
    that.setAnimation(element.$wrapper.eq(i));
});
}
plusboxChart.prototype.setItems = function($wrapper) {
    var element = this.getElementData($wrapper);
    var container = this.getContainerInfo(element.$wrapper);
    var valueData = this.getValueMath(element.$items);

    var valueMax = valueData.max;
    var valueMin = valueData.min;
    var valueAverage = valueData.average;

    var percentMax = 100;
    var percentMin = 0;
    var percent;
    var that = this;
    if( valueAverage == valueMin ) {
        valueMin = valueMax - valueMin;
    }
    // console.log(valueData.max, valueData.min, valueData.average)
    // console.log(valueMax, valueMin, valueAverage)

    element.$items.each(function(i) {
        var $this = $(this);
        var $itemBarWrap = $this.find('.bar-wrap');
        var $itemBar = $itemBarWrap.find('.bar');
        var $itemValue = $itemBarWrap.find('.txt span');
        var valueText = $itemValue.text();
        var value = valueText.replace(/,/g,"");
        percent = ((value / valueMax) * (percentMax - percentMin)) + percentMin;
        
        if( valueAverage == 0 ) {
            percent = percentMin;
        }

        if( !$.isNumeric(value) ) {
            percent = 0;
            $this.addClass('is-disabled');
        } else {
            $this.removeClass('is-disabled');
        }

        $itemBarWrap.css('height',percent + '%');
        $itemValue.attr('data-value', value);
        $itemValue.text(that.setComma(value));

        $(this).outerWidth(container.wrapper_width / that.VIEW_ITEM_NUM);
    });
    element.$container.width(container.container_width);
};

plusboxChart.prototype.getContainerInfo = function($warpper) {
    var element = this.getElementData($warpper);
    var container_width = 0;
    var data = {};
    var that = this;

    data.wrapper_width = element.$wrapper.width();
    data.wrapper_scrollX = element.$wrapper.scrollLeft();
    element.$items.each(function(i) {
        container_width += data.wrapper_width / that.VIEW_ITEM_NUM;
    });
    data.container_width = container_width;

    return data;
};
plusboxChart.prototype.getValueMath = function($items) {
    var data = {};
    var arry_item_value = [];
    var value_sum = 0;

    $items.each(function(i) {
        var $this = $(this);
        var value = $this.find('.bar-wrap .txt span').text().replace(/,/g,"");
        if( $.isNumeric(value) ) {
            arry_item_value.push( value )
        }
    });

    for( var i=0; i < arry_item_value.length; i++ ) {
        
        if( $.isNumeric(arry_item_value[i]) ) {
            value_sum += arry_item_value[i];
        }
    }
    
    data.max = Math.max.apply(null, arry_item_value);
    data.min = Math.min.apply(null, arry_item_value);
    data.average = value_sum / arry_item_value.length;
    //console.log('data', data)
    return data;
};
plusboxChart.prototype.setPosition = function($wrapper) {
    var element = this.getElementData($wrapper);
    var container = this.getContainerInfo(element.$wrapper);
    var isYear = new Date().getFullYear();
    var chartYear = element.$year[0];
    if(chartYear && chartYear?.dataset?.plusboxchartYear.length) {
        var nowYear = JSON.parse(chartYear?.dataset?.plusboxchartYear.replace(/[^0-9]/g,''));
    }
    var nowMonth = nowYear == isYear ? new Date().getMonth() + 1 : 0;

    var array_dataMonth = [];
    var active_item;
    var item;

    // data-month 가 없다면 item순서가 월순서
    element.$items.each(function(i) {
        var isMonth = false;

        if( $(this).data('month') ) {
            isMonth = true;
        }
        array_dataMonth.push(isMonth)
    });

    active_item = element.$items.eq(nowMonth - 1);	

    element.$year.length && this.activeMonth(element, nowYear, isYear);

    item = this.getItemsInfo(active_item);

    element.$wrapper.scrollLeft(0);

    element.$wrapper.scrollLeft(item.item_right - container.wrapper_width); // 우측기준
};
plusboxChart.prototype.activeMonth = function(element, nowYear, isYear){
    //console.log('element, nowYear, isYear', element, nowYear, isYear)
    var isMonth = new Date().getMonth();
    if( nowYear == isYear ){
        var active_item = element.$items.eq(isMonth);
        active_item && active_item.addClass('is-now-month');
    }else{
        var active_item = Array.from(element.$items).filter( el => $(el).hasClass('is-now-month'));
        active_item && $(active_item).removeClass('is-now-month');
    }	
}
plusboxChart.prototype.setAnimation = function($wrapper) {
    var element = this.getElementData($wrapper);
    var viewNum = this.VIEW_ITEM_NUM;
    var arry_items= [];

    element.$items.each(function(i) {
        var $this = $(this);
        if( i < viewNum ) {
            arry_items.push( $this );
        }
        $this.removeClass('is-show');
    });
    
    setTimeout(function() {
        for(var i = 0; i < arry_items.length; i++ ) {
            arry_items[i].addClass('is-show');
        }
    }, 10);

    element.$wrapper.removeClass('is-hide');
};
plusboxChart.prototype.setComma = function(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
plusboxChart.prototype.getItemsInfo = function($items) {
    var data = {};

    data.item_width = $items.outerWidth();
    data.item_left = $items.position().left;
    data.item_right = data.item_left + data.item_width;

    return data;
};
plusboxChart.prototype.scrollAnimation = function($wrapper) {
    var element = this.getElementData($wrapper);
    var container = this.getContainerInfo(element.$wrapper);
    var that = this;
    element.$items.each(function(i) {
        var $this = $(this);
        var item = that.getItemsInfo($this);

        var scrollX = parseInt(container.wrapper_scrollX);
        var startX = parseInt(item.item_left - container.wrapper_width);
        if( startX >= scrollX ) {
            $this.addClass('is-ready');
        } else {
            $this.addClass('is-show');
        }
    });
};
export const PlusboxChart = plusboxChart;


/**
 * @summary CHPFMTASK-870 한달적금 \
 * PBKINQ1100000401S.html 하단 script  영역 사용방법
 */
function savingsStory(opt = {}){  
    this.Data = opt.data
    this.SELECTOR = {
        wrapper : '[data-saving-wrap]',
        current : '[data-saving-fraction-current]',
        total : '[data-saving-fraction-total]',
        round : '[data-saving-round]',
        range : '[data-saving-range]',
        rate : '[data-saving-rate]',
        arrow : '[data-saving-arrow]',
        img : '[data-saving-img]',
        desc : '[data-saving-desc]',
        date : '[data-saving-date]',
        amount : '[data-saving-amount]',
        bgc: '[data-saving-bgc]'
        // btnPrev : '[data-saving-button-prev]',
        // btnNext : '[data-saving-button-next]',

	}
	this.$window = $(window);
	this.$document = $(document);

    //this.init();
    return this;
};
savingsStory.prototype.update = function(fraction) {
    $(this.SELECTOR.current).text(fraction.current);
    $(this.SELECTOR.total).text(`/ ${fraction.total}`);
    this.buttonActiveCheck(fraction);

    $(this.SELECTOR.range).find('input').attr({
        'value':fraction.current,
        'max': fraction.total,
        'min':0,
        'step': 1,
        'aria-valuetext': fraction.current
    });
    $(this.SELECTOR.range).find('input').val(fraction.current)
    $(this.SELECTOR.range).data('ui').setValue();
    this.activeEvent(fraction.current);
};

savingsStory.prototype.buttonActiveCheck = function (fraction) {
    if (fraction.current == 1) {
        $('[data-saving-button-prev]').find('> i').addClass('disabled')
    } else {
        $('[data-saving-button-prev]').find('> i').removeClass('disabled')
    }
    if (fraction.current == fraction.total) {
        $('[data-saving-button-next]').find('> i').addClass('disabled')
    } else {
        $('[data-saving-button-next]').find('> i').removeClass('disabled')
    }
}
savingsStory.prototype.activeEvent = function (index) {
    var activeIndex = index - 1;
    var _arrow = this.Data[activeIndex].arrow;
    if (this.Data[activeIndex].arrow == undefined) {
        _arrow = 'up'
    }
    $(this.SELECTOR.round).text(`${this.Data[activeIndex].round}회차`)
    $(this.SELECTOR.rate).text(`${this.Data[activeIndex].rate}%`)
    if (_arrow == 'up') {
        $(this.SELECTOR.arrow)?.attr({'class': 'ico-triangle-up-sample01', 'aria-label':'상승'});
    } else {
        $(this.SELECTOR.arrow)?.attr({'class': 'ico-triangle-down-sample01', 'aria-label':'하락'});
    }
    $(this.SELECTOR.img).attr('src', this.Data[activeIndex].img);
    document.querySelector(this.SELECTOR.desc).innerHTML = this.Data[activeIndex].desc;
    $(this.SELECTOR.date).text(`${this.Data[activeIndex].date.substr(0,4)}.${this.Data[activeIndex].date.substr(4,2)}.${this.Data[activeIndex].date.substr(6,2)}`);
    $(this.SELECTOR.amount).text(`${commaSet(this.Data[activeIndex].amount)}원`)

    function commaSet(num){
        let len, point, str;
        num = num + "";
        point = num.length % 3;
        len = num.length;

        str = num.substring(0, point);
        while (point < len){
            if (str != "") str += ",";
            str += num.substring(point, point+3);
            point += 3;
        }
        return str
    }
    $(this.SELECTOR.range).find('input').attr({
        'value':activeIndex+1,
        'aria-valuetext': activeIndex+1,
    });
    $(this.SELECTOR.range).find('input').val(activeIndex+1);
    $(this.SELECTOR.range).data('ui').setValue();

    $(this.SELECTOR.current).text(activeIndex+1);
    $(this.SELECTOR.bgc).css('background-color',this.Data[activeIndex].bgc);

    this.buttonActiveCheck({current:activeIndex+1, total:Number($('[data-saving-fraction-total]').text().replace('/',''))});
}
export const SavingsStory = savingsStory;

// kvTouchEvent 2025.02.11 (CHPFMTASK-1828)

/**
 * keyVisual 터치 했을경우 아래 컨텐츠 요소가 노출 되는 이벤트
 * @summary .page-inner-scroll 클래스가 위치한 요소에 data-type="kvFixed", data-type="kvRelative" 중 하나를 용도에 맞게 적용  \
 * 1.data-type="kvFixed" : keyVisual의 position:fixed 일경우 \
 * 2.data-type="kvRelative" : keyVisual의 position:relative 일경우 \
 * 3.애니메이션 속도(duration) :  400ms \
 * 4.애니메이션 효과(easing) : css root에 선언된 var(--kds-easing-steady) 적용 
 * 
 * 하기 속성을 해당 요소에 적용[필수값] \
 * 1.[touchEventContainer] : keyVisual과 Contents 요소의 부모가 되는 요소에 touchEventContainer 적용 \
 * 2.[touchEventKv] : keyVisual 요소에 touchEventKv 적용 \
 * 3.[touchEventContents] : keyVisual 바로 아래 Contents 요소에 touchEventContents 적용 \
 * 4.[touchEventContentsInner] : touchEventContents 자식요소중 첫번째 요소에 touchEventContentsInner 적용
 * 
 *
 * @example
 * frontUI.kvTouchEvent();
 */


export function kvTouchEvent(param) {
    let currentSection = 0;
    // let _duration = 0;
    const $pageInnerScroll = $('.page-inner-scroll');
    const $containerSection = $('[touchEventContainer]');
    const $kvSection = $('[touchEventkv]');
    const $contentsSection = $('[touchEventContents]');
    const $innerContents = $('[touchEventContentsInner]');
    const $a11yFocusTitle = $('[a11yFocusTitle]');  // 접근성모드 CHPFMTASK-2218 (2025.05.07)
    const $wHeight = $(window).height();
    const $dataGroupSecondCh = $(`[data-role="animation-group"]`).eq(1).children();
    const $dataGroupFirstCon = $(`[data-role="animation-group"]`).eq(0).find('.icon-slide-prd');


    if(!isA11yCheckVersion()){ // 접근성모드 CHPFMTASK-2218 (2025.04.14)
        if ($pageInnerScroll.attr('data-type') == 'kvFixed' || $pageInnerScroll.attr('data-type') == 'kvRelative') {
            
            $pageInnerScroll.css('overflow', 'hidden');
            $('.container-component').css('height','100%'); // 접근성모드 CHPFMTASK-2218 (2025.04.14)

            if($dataGroupFirstCon.length > 0){
                $dataGroupFirstCon.css({
                    'opacity' : '0',
                    'transform': 'translateY(30px)'
                });
            }
            let _duration = ''
            function goToSection(sectionIndex, _duration){ // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 - 파라미터추가(_duration) 2025-03-19 
                const offset = -sectionIndex *100;

                // CHPFMTASK-2015 : easing, duration 적용 (2025.03.11)
                const root = document.documentElement;
                const easingSteady = getComputedStyle(root).getPropertyValue('--kds-easing-steady').trim();
                // const _duration = param == 'directContents' ? '0s' : '.4s'; // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 2025-03-19 
                //  _duration != null ? '0s' : '.4s'; // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 2025-03-19 

                if ($pageInnerScroll.attr('data-type') == 'kvFixed') {
                    // $contentsSection.css('transform',`translateY(${offset}vh)`);
                    // CHPFMTASK-2015 : easing, duration 적용 (2025.03.11)
                    $contentsSection.css({
                        "transform" : `translateY(${offset}vh)`,
                        // "transition": '.4s '+ easingSteady
                        "transition": _duration +' '+ easingSteady // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 2025-03-19 
                    });

                    setTimeout(function(){
                    $contentsSection.css('marginBottom',`${offset}vh`);
                    },1200);
                    if ($pageInnerScroll.attr('data-item') == 'fast') {
                        setTimeout(function(){
                            $innerContents.children().addClass('active');
                            if($dataGroupFirstCon.length > 0){
                                $dataGroupFirstCon.css({
                                    "opacity" : '1',
                                    "transform": 'translateY(0)',
                                    "transition": '.3s'
                                });
                            }
                        },500);
                        if ($wHeight > 667) {
                            setTimeout(function(){
                                $dataGroupSecondCh.addClass('active');
                            },500);
                        }
                    }
                } else {
                    // $containerSection.css('transform',`translateY(${offset}vh)`);
                    // CHPFMTASK-2015 : easing, duration 적용 (2025.03.11)
                    $containerSection.css({
                        "transform" : `translateY(${offset}vh)`,
                        // "transition": '.4s '+ easingSteady
                        "transition": _duration +' '+ easingSteady // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 2025-03-19 
                    });
                    setTimeout(function(){
                        $containerSection.css('marginBottom',`${offset}vh`);
                    }, 1200)
                }
            }
            
            // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 2025-03-19 
            if($kvSection.length > 0){
                $kvSection.addClass('directpage');
            }
            if(param == 'directContents'){
                $pageInnerScroll.css('overflowY', 'auto');
                goToSection('1', '0s');
                currentSection = 1;
            }
            
            document.addEventListener('touchstart',(event)=>{
                const touchStartY = event.touches[0].clientY;
                const handleTouchEnd = (event) =>{
                    const touchEndY = event.changedTouches[0].clientY;
                    const $kvSection = $('[touchEventKv]');
                    const $innerContents = $('[touchEventContentsInner]');
                    const $componentHeader = $containerSection.find('.component-header');
                    const $innerContentsPosi = $innerContents.offset().top;

                    if(touchStartY > touchEndY + 50 && currentSection == 0){
                        currentSection++;
                        goToSection(currentSection, '.4s'); // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 - 파라미터추가(_duration) 2025-03-19
                        $pageInnerScroll.css('overflowY', 'auto');
                        
                        if ($pageInnerScroll.attr('data-item') == 'fast') {
                            $contentsSection.off('transitionend').on('transitionend', (e)=>{
                                // kv 애니메이션 초기화 && data-role 애니메이션 재실행 && 해더 addClass blur
                                if($kvSection.hasClass('active') && currentSection === 1) {
                                    $kvSection.removeClass('active');
                                    $componentHeader.addClass('blur');
                                    for (let key in [...$('[data-role="animation-group"]')]) {
                                        $('[data-role="animation-group"]').eq(key).data('ui').render();
                                    }
                                }
                            });
                        }
                    } else if (touchStartY < touchEndY - 50 && currentSection ==  1 && $innerContentsPosi >= -1) {
                        currentSection--;
                        goToSection(currentSection, '.4s'); // CHPFMTASK-2069 : 미성년 카드 신규 혜택 생성 컨텐츠영역으로 바로 이동 - 파라미터추가(_duration) 2025-03-19
                        $pageInnerScroll.css('overflowY', 'hidden');
                        if ($pageInnerScroll.attr('data-item') == 'fast') {
                            // kv 애니메이션 재실행 && 해더 removeClass blur
                            $kvSection.addClass('active');
                            $componentHeader.removeClass('blur');
                        }
                    }

                    
                    document.removeEventListener('touchend', handleTouchEnd)
                }
                document.addEventListener('touchend', handleTouchEnd)
            });

            // kv 리사이즈 (CHPFMTASK-2026)
            const minViewPort = 375;
            const maxViewPort = 480;
            const minViewPorttHeight = 667;
            const minScale = 1;
            const maxScale = 1.2;
            const scaleContent = document.querySelector('.safe-camp-inner');

            function updateScale() {
                const width = window.innerWidth;
                const height = window.innerHeight; 
                // iPhone SE 375 X 667
                if(width === minViewPort && height === minViewPorttHeight){
                scaleContent.style.transform = 'scale(1)';
                } else if(width >= minViewPort && width < maxViewPort){
                const scale = minScale + (maxScale - minScale) * ((width - minViewPort) / (maxViewPort - minViewPort));
                const posTop = (width - minViewPort) / 4;        
                scaleContent.style.transform = `scale(${scale})`;  
                } else if(width > maxViewPort){
                scaleContent.style.transform = 'translateY(0)';        
                }   
                else{        
                scaleContent.style.transform = 'scale(1)';
                }
            };
            if(scaleContent){
                window.removeEventListener('resize', updateScale);
                window.addEventListener('resize', updateScale);
                updateScale();
            }      
            window.addEventListener('resize', updateScale);
        } 
        return false;
    // 접근성모드 CHPFMTASK-2218 (2025.04.14)
    } else { 
        console.log('isA11yCheckVersion')
        $kvSection.css('opacity','1')
        $('.container-component').css('height','auto');
        var headerHeight = $('.component-header').height()

        if(param == 'directContents'){
            var offsetVal = 0;
            
            if ($pageInnerScroll.attr('data-type') == 'kvFixed') {
                offsetVal = $innerContents.offset().top + headerHeight
                console.log('kvFixed')
            } else {
                offsetVal = $innerContents.offset().top
                console.log('relative')
            }
          
            setTimeout(() => {
                scrollTo(offsetVal, false, true);
                if($a11yFocusTitle.length >0){
                    $a11yFocusTitle.focus(); // 접근성모드 CHPFMTASK-2218 (2025.05.07)
                }
            }, 150)
        } else {
            setTimeout(() => {
                $pageInnerScroll.scrollTop(0)
            }, 500)
        }
        if ($pageInnerScroll.attr('data-type') == 'kvFixed') {
            $kvSection.css('position', 'relative');
            $containerSection.addClass('a11y_mode');

            $('.ui-kbank-page-control.activeSlide .page-inner-scroll').on('scroll',  function(){
                const consecTop = $contentsSection.offset().top;
                const $componentHeader = $containerSection.find('.component-header');

                if(consecTop < 0){
                    $componentHeader.addClass('blur');
                } else {
                    $componentHeader.removeClass('blur');
                }
            })
        }
    }
}

// scrollingAddActive 2025.02.18 (CHPFMTASK-1828) : bg Animation 추가
export function scrollingAddActive() {
    const pageInnerScroll = document.querySelector('page-inner-scroll');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                setTimeout(function(){
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                },500)
            }
        })
    })

    document.querySelectorAll('[scrollingAddActive]').forEach(element => observer.observe(element));
}

// CHPFMTASK-2177 [채널/퍼블] SEP 1호 데굴데굴 농장 적금 퍼블리싱 요청 건 (2025.05.21)
export function farm(){
    function initRange(){
        const MAX = 7;
        let index = 1;
        let callback;
        const bx = $( "#ui-simple-farm-range" );

        const rangeBx = bx.find( ".farm-savings-input-range" );
        const input = rangeBx.find( "input" );
        const bg = rangeBx.find( ".range-bg" );
        const btns = bx.find( ".item-index" );

        const characterWrap = bx.find( ".farm-savings-item-wrap" );
        function open(delay = 0){
            gsap.fromTo( characterWrap, 
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 0.4, delay: delay, ease: Back.easeOut }
            );
        }

        const showRagne = (n) => {
            input.val( n );
        }

        const showBg = (n) => {
            const bW = n / MAX * 100;
            bg.css( "background", `linear-gradient(to right, #27ce2b 0%, #00b182 ${bW}%, #ebe6f1 ${bW}%, #ebe6f1 100%)`)
        }

        const showBtn = (n) => {
            btns.removeClass( "active" );

            const item = $( btns[n]);
            item.addClass( "active" );

            const icon = item.find( "[class*=ico]" );
            gsap.killTweensOf( icon );
            gsap.fromTo( icon, { scale: 1 }, { scale: 0.8, duration: 0.15, yoyo: true, repeat: 1 });
        }

        input.on( "input", () => {
            const idx = +input.val();
            showBg( idx - 1 );
            showBtn( idx - 1);

            index = idx;
            onChange( callback );
        });

        const btnsClick = ({ currentTarget }) => {
            const idx = $( currentTarget ).index();

            showBg( idx );
            showRagne( idx + 1 );
            showBtn( idx );
            
            index = idx + 1;
            onChange( callback );
        }

        btns.off( "click", btnsClick );
        btns.on( "click", btnsClick );

        const onChange = (func) => {
            if( func ) func();
            callback = func;
        }

        const getInfo = () => {
            return {
                index
            }
        }

        const setValue = (n) => {
            showBg(n - 1);
            showRagne( n );
            showBtn(n - 1);

            index = n;
            onChange( callback );
        }

        return{
            onChange, 
            getInfo,
            setValue,
            open
        }
    }

    function initPopupSavings(){
        const bx = $( ".ui-simple-farm-popup-savings" );
        const characterBx = bx.find( ".ui-simple-farm-swiper-savings" );
        const characters = characterBx.find( ".farm-savings-item" );
        const btnPrev = bx.find( ".button-prev" );
        const btnNext = bx.find( ".button-next" );

        let index;
        
        const popup = bx.data("ui");
        const btns = bx.find( ".farm-savings-current" ).find( ".btn-chips" );
        const innerScroll = bx.find( ".inner-scroll" )[0];

        function btnPrevClick(){
            index--;
            if( index < 0 ) index = characters.length - 1;

            showCharacter(index);
            showBtnsScroll(index);
        }

        function btnNextClick(){
            index = ( index + 1 ) % characters.length;

            showCharacter(index);
            showBtnsScroll(index);
        }

        const open = (n = 0) => {
            index = n;

            btnPrev.off( "click", btnPrevClick );
            btnNext.off( "click", btnNextClick );
    
            btnPrev.on( "click", btnPrevClick );
            btnNext.on( "click", btnNextClick );
    
            btns.off( "click", btnsClick );
            btns.on( "click", btnsClick );

            // popup.open().callback(() => {
                // if( swiper.destroyed ) swiper = bx.find( ".ui-swiper" ).data( "ui" ).swiper;

                // swiper.off( "slideChange" );
                // swiper.on( "slideChange", ({ realIndex }) => {
                //     index = realIndex;
                //     showBtnsScroll( realIndex );
                // });

            // });

            showCharacter(index);
            popup.beforeOpenCallback(() => {
                setTimeout(() => {
                    showBtnsScroll(index);
                });
            });

            // swiper.slideTo( index, 0 );
            // showBtnsScroll( index, 0 );
            // gsap.to( elSwiper, { opacity: 1, duration: 0.1, delay: 0.15 });

            // popup.beforeCloseCallback(() => {
            //     popup.close();
            //     elSwiper.css( "opacity", 0 );
            // });
        }

        const showCharacter = (n) => {
            characters.attr( "aria-hidden", "true" );
            $( characters[n]).attr( "aria-hidden", "false" );
        }

        const showBtnsScroll = (n, mTime = 0.25) => {
            btns.removeClass( "active" );

            const btn = btns[n];
            btn.classList.add( "active" );

            const cW = innerScroll.clientWidth;
            const bX = ( btn.offsetLeft + ( btn.clientWidth / 2 )) - 20;

            gsap.killTweensOf( innerScroll );
            innerScroll.scrollLeft = bX - (cW / 2 )

            gsap.to( innerScroll, { 
                duration: mTime, 
                scrollLeft: bX - (cW / 2 ), 
                ease: Cubic.easeInOut 
            });
        }

        function btnsClick(){
            index = $( this ).index();

            showBtnsScroll(index);
            showCharacter(index);
        }

        return{
            open,
        }
    }

    function initFarmCharacter(){
        $( ".ui-simple-farm-character" ).each((_, el) => {
            const item = $(el);
            item.find( ".farm-savings-item-chat" ).css( "opacity", 0 );

            let timer;
            let txtCount = -1;
            item.on( "click", () => {
                const character = item.find( ".ico-character-group" ).find( "[class*=ico-character-]");
                const txtBx = item.find( ".farm-savings-item-chat" );
                const txtList = txtBx.find( ".txt" );

                if( txtBx.hasClass( "active" )) return;

                character[0].style.opacity = 0;
                character[1].style.opacity = 1;

                txtCount = ( txtCount + 1 ) % txtList.length;

                const txt = $( txtList[txtCount] );

                gsap.killTweensOf( txtBx );

                txtList.removeClass( "active" );
                txtBx.addClass( "active" );
                txt.addClass( "active" );

                gsap.fromTo( txtBx, { y: 5, opacity: 0 }, { duration: 0.3, y: 0, opacity: 1, ease: Cubic.easeIn });

                clearTimeout(timer);
                timer = setTimeout(() => {
                    character[0].style.opacity = 1;
                    character[1].style.opacity = 0;

                    gsap.to( txtBx, { duration:0.15, y: 5, opacity: 0, ease: Cubic.easeIn, onComplete: () => {
                        txtBx.removeClass( "active" );
                    }});
                }, 1500 );
            });
        })
    }

    function initIntro(){
        const introBx = $( ".ui-simple-intro" );
        function play(delay = 0){
            const scene1 = introBx.find( ".intro-scene1" );
            const scene2 = introBx.find( ".intro-scene2" );

            scene1.removeClass( "active" );
            scene1.removeClass( "done" );

            scene2.removeClass( "active" );

            const scene1Lottie = scene1.find( ".ui-lottie" ).data( "ui" );

            setTimeout(() => {
                scene1.addClass( "active" );
                scene1Lottie.completeCallbackAction(() => {
                    scene1.addClass( "done" );

                    setTimeout(() => {
                        scene1.removeClass( "active" );
                        scene2.addClass( "active" );
                    }, 300 );
                });

                scene1Lottie.stop();
                scene1Lottie.replay();
            }, delay * 1000);
        }

        return{
            play
        }
    }

    function initSpinnerPopup(){
        let doneCallback;
        const spinnerPopup = $( ".ui-simple-farm-spinner-popup" ).data( "ui" );
        spinnerPopup.destroy();
        const btns = $( ".ui-simple-spinner-btns" ).find( ".input-radio-btn" ).find( "input" );

        function open(){
            spinnerPopup.open();
        }

        spinnerPopup.setDone(() => {
            doneCallback && doneCallback( spinnerPopup.getValue() );
        });

        const getDone = ( callback ) => {
            doneCallback = callback;
        }

        const autoTransfer = ( enabled ) => {
            $( btns[0]).prop( "checked", enabled );
            $( btns[1]).prop( "checked", !enabled );
        }

        return{
            open,
            getDone,
            autoTransfer
        }
    }

    function initInterestPopup(){
        const elLottie = $('.lottie-confetti');
        const lottie = elLottie.data( "ui" );

        lottie.completeCallbackAction(() => {
            elLottie.addClass( "finish" );
        });

        function play(delay = 0){
            elLottie.removeClass( "finish" );

            setTimeout(() => {
                lottie.stop();
                lottie.replay()
            }, delay * 1000 );
        }

        return{
            play
        }
    }

    function initFarmAdd(){
        let completeCallback;
        const farmAddBx = $( ".ui-simple-farm-add" );
        const lottie = farmAddBx.find( ".ui-lottie" ).data( "ui" );
        let isFirstPlay = false;

        function playLottie( delay ){
            lottie.completeCallbackAction(() => {
                completeCallback && completeCallback();
            });

            setTimeout(() => {
                if( !isFirstPlay ) lottie.play();
                else{
                    lottie.stop();
                    lottie.replay();
                }

                isFirstPlay = true;
            }, delay * 1000 )
        }

        function complete(callback){
            completeCallback = callback;
        }

        return{
            playLottie,
            complete
        }
    }

    return{
        initRange,
        initPopupSavings,
        initFarmCharacter,
        initIntro,
        initSpinnerPopup,
        initInterestPopup,
        initFarmAdd,
    }
}


// UI Init
export function initUI() {
    pageLoadKDS();
    animateBtn();
    confirmAmount();
    pasteInfoTooltip();
    removeTouchMoveAction();
    /*! s: FETASK-a11y page isA11yHeaderEmptyTextCheck v.1.0.0 */
    //isA11yCheckVersion() && isA11yHeaderEmptyTextCheck();
    /*! e: FETASK-a11y page isA11yHeaderEmptyTextCheck v.1.0.0 */

    /*! s: FETASK-a11y page isA11yAgreement v.1.0.0 */
    isA11yCheckVersion() && isA11yAgreement();
    /*! e: FETASK-a11y page isA11yAgreement v.1.0.0 */

    /*! s: FETASK-a11y page isA11yUtilText v.1.0.0 */
    isA11yCheckVersion() && isA11yUtilText();
    /*! s: FETASK-a11y page isA11yUtilText v.1.0.0 */

    /*! s: FETASK-a11y page isA11yRecList v.1.0.0 */
    isA11yCheckVersion() && isA11yRecList()
    /*! e: FETASK-a11y page isA11yRecList v.1.0.0 */

    /*! s: FETASK-a11y page isA11yFormPasswordAcess v.1.0.0 */
    isA11yCheckVersion() && isA11yFormPasswordAcess();
    /*! e: FETASK-a11y page isA11yFormPasswordAcess v.1.0.0 */

    /*! s: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
    isA11yCheckVersion() && addPopupCloseBtn();
    /*! e: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */

    /*! s: FETASK-a11y page benefit-list-group v.1.0.0 */
    isA11yCheckVersion() && isA11yBenefitList();
    /*! e: FETASK-a11y page benefit-list-group v.1.0.0 */

    /*! s: FETASK-a11y page progress-step-group v.1.0.0 */
    isA11yCheckVersion() && isA11yProgressStep();
    /*! e: FETASK-a11y page progress-step-group v.1.0.0 */

    /*! s: FETASK-a11y page isA11yOnceSpinnerDiv v.1.0.0 */
    isA11yCheckVersion() && isA11yOnceSpinnerDiv();
    /*! e: FETASK-a11y page isA11yOnceSpinnerDiv v.1.0.0 */

    /*! s: FETASK-a11y page isA11yDateSpinnerInput v.1.0.0 */
    isA11yCheckVersion() && isA11yDateSpinnerInput();
    /*! e: FETASK-a11y page isA11yDateSpinnerInput v.1.0.0 */

    /*! s: FETASK-a11y page isA11yImgLink v.1.0.0 */
    isA11yCheckVersion() && isA11yImgLink();
    /*! e: FETASK-a11y page isA11yImgLink v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTrnForm v.1.0.0 */
    isA11yCheckVersion() && isA11yTrnForm();
    /*! e: FETASK-a11y page isA11yTrnForm v.1.0.0 */

    /*! s: FETASK-a11y page a11yUnconfirmed v.1.0.0 */
    isA11yCheckVersion() && a11yUnconfirmed();
    /*! e: FETASK-a11y page a11yUnconfirmed v.1.0.0 */

    /*! s: FETASK-a11y page a11yNewHome v.1.0.0 */
    isA11yCheckVersion() && a11yNewHome();
    /*! e: FETASK-a11y page a11yNewHome v.1.0.0 */

    /*! s: FETASK-a11y page isA11yAgreementInputTitle v.1.0.0 */
    isA11yCheckVersion() && isA11yAgreementInputTitle();
    /*! e: FETASK-a11y page isA11yAgreementInputTitle v.1.0.0 */

    /*! s: FETASK-a11y page isA11yInitButtonRole v.1.0.0 */
    //isA11yCheckVersion() && isA11yInitButtonRole();
    /*! e: FETASK-a11y page isA11yInitButtonRole v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTrnListGroup v.1.0.0 */
    isA11yCheckVersion() && isA11yTrnListGroup();
    /*! e: FETASK-a11y page isA11yTrnListGroup v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTitleHeadHide v.1.0.0 */
    isA11yCheckVersion() && isA11yTitleHeadHide();
    /*! e: FETASK-a11y page isA11yTitleHeadHide v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTableCaption v.1.0.0 */
    isA11yCheckVersion() && isA11yTableCaption();
    /*! e: FETASK-a11y page isA11yTableCaption v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTabItemsSelected v.1.0.0 */
    isA11yTabItemsSelected() && isA11yTabItemsSelected();
    /*! e: FETASK-a11y page isA11yTabItemsSelected v.1.0.0 */

    /*! s: FETASK-a11y page changePrdDetailWrap v.1.0.0 */
    isA11yCheckVersion() && changePrdDetailWrap();
    /*! e: FETASK-a11y page changePrdDetailWrap v.1.0.0 */

    /*! s: FETASK-a11y page fcCalendar v.1.0.0 */
    isA11yCheckVersion() && fcCalendar();
    /*! e: FETASK-a11y page fcCalendar v.1.0.0 */

    /*! s: FETASK-a11y page a11yCalendarAccess v.1.0.0 */
    a11yCalendarAccess() && a11yCalendarAccess();
    /*! e: FETASK-a11y page a11yCalendarAccess v.1.0.0 */

    /*! s: FETASK-a11y page isA11yinputRadio v.1.0.0 */
    isA11yCheckVersion() && isA11yinputRadio();
    /*! e: FETASK-a11y page isA11yinputRadio v.1.0.0 */

    isA11yCheckVersion() && isA11yBingo();

    // isA11yCheckVersion() && isA11yFavoriteIcoToggle();
}
